{
  "shippingFees": {
    "sectionTitle": "Phí vận chuyển",
    "sectionDescription": "Phí vận chuyển theo từng biến thể, phân theo dịch vụ và vùng đích. Nhãn dịch vụ và vùng được dịch theo ngôn ngữ; mã wire giữ nguyên tiếng Anh.",
    "columns": {
      "service": "Dịch vụ",
      "zone": "Vùng",
      "shippingFee": "Phí vận chuyển",
      "additionalFee": "Phí thêm"
    },
    "columnHints": {
      "shippingFee": "Phí cho sản phẩm đầu tiên",
      "additionalFee": "Phí cho mỗi sản phẩm thêm"
    },
    "addService": "Thêm dịch vụ",
    "removeService": "Xóa dịch vụ",
    "zoneOverride": {
      "title": "Ghi đè theo vùng",
      "description": "Ghi đè phí mặc định cho các vùng đích cụ thể.",
      "addZone": "Thêm ghi đè vùng",
      "removeZone": "Xóa ghi đè vùng",
      "defaultZone": "Mặc định (mọi vùng)"
    },
    "toasts": {
      "saved": "Đã lưu phí vận chuyển.",
      "error": "Không lưu được phí vận chuyển."
    },
    "errors": {
      "SHIPPING_SERVICE_FEE_REQUIRED": "Cần nhập phí vận chuyển cho dịch vụ đã chọn.",
      "BLUEPRINT_STANDARD_SERVICE_REQUIRED": "Cần có phí dịch vụ Tiêu chuẩn nội địa.",
      "SERVICE_CODE_INVALID": "Mã dịch vụ này không có trong danh mục.",
      "SHIPPING_METHOD_IN_USE": "Dịch vụ này đang được sử dụng nên không thể xóa.",
      "feeRequired": "Nhập phí vận chuyển.",
      "feeInvalid": "Nhập số tiền phí hợp lệ.",
      "duplicateService": "Dịch vụ này đã được thêm.",
      "duplicateZone": "Vùng này đã có ghi đè."
    }
  },
  "shippingAggregation": {
    "_vgBinding": "vg-binding: P14.D-05 — Merchant Detail shippingAggregationMode toggle labels/helper/toasts (per_line|highest_base) across en/vi/fr [task-16]",
    "title": "Cách gộp phí vận chuyển",
    "ariaLabel": "Chuyển đổi cách gộp phí vận chuyển",
    "readOnly": "Bạn không có quyền thay đổi thiết lập này.",
    "modes": {
      "per_line": "Theo từng dòng",
      "highest_base": "Theo phí gốc cao nhất"
    },
    "helper": {
      "per_line": "Theo từng dòng: phí vận chuyển của mỗi biến thể được cộng độc lập trên toàn đơn hàng.",
      "highest_base": "Theo phí gốc cao nhất: lấy phí gốc cao nhất trong đơn cộng với phí thêm cho các sản phẩm còn lại."
    },
    "toasts": {
      "saved": "Đã cập nhật cách gộp phí vận chuyển.",
      "error": "Không cập nhật được cách gộp phí vận chuyển."
    }
  },
  "common": {
    "updatedDate": "Cập nhật"
  },
  "logisticsTable": {
    "selectAllRowsAria": "Chọn tất cả các dòng",
    "columnStatus": "Trạng thái",
    "statusToggleAria": "Bật/tắt trạng thái của {{sku}}",
    "emptyGenerateOptionsFirst": "Chưa có SKU nào — chọn tuỳ chọn ở block Options trước."
  },
  "category": {
    "title": "Danh mục",
    "subtitle": "Cây danh mục sản phẩm",
    "columns": {
      "name": "Tên",
      "slug": "Slug",
      "parent": "Danh mục cha",
      "productCount": "Số sản phẩm",
      "isActive": "Đang hoạt động"
    },
    "actions": {
      "create": "Tạo danh mục",
      "edit": "Sửa",
      "delete": "Xóa",
      "reorder": "Sắp xếp lại",
      "moveTo": "Chuyển đến"
    },
    "fields": {
      "name": "Tên",
      "slug": "Slug",
      "parent": "Danh mục cha",
      "description": "Mô tả",
      "seoTitle": "Tiêu đề SEO",
      "seoDescription": "Mô tả SEO",
      "image": "Hình ảnh"
    },
    "errors": {
      "duplicateSlug": "Đã tồn tại danh mục với slug này",
      "hasChildren": "Không thể xóa — danh mục có danh mục con",
      "circularParent": "Danh mục không thể là tổ tiên của chính nó"
    },
    "views": {
      "all": "Tất cả",
      "active": "Đang hoạt động",
      "inactive": "Ngừng hoạt động",
      "topLevel": "Chỉ cấp cao nhất"
    },
    "page": {
      "subtitle": "Quản lý cây danh mục 2 cấp hiển thị trong catalog storefront và sidebar quản trị blueprint.",
      "filterViewsAria": "Bộ lọc khung nhìn",
      "treeHeading": "Cây danh mục",
      "itemCount": "{{count}} mục",
      "loadError": "Không tải được danh mục.",
      "retry": "Thử lại",
      "reorderFailed": "Sắp xếp lại thất bại"
    },
    "detailPanel": {
      "emptySelect": "Chọn một danh mục từ cây, hoặc bấm \"+ Category\" để thêm mới.",
      "nameRequired": "Cần nhập Tên (Tiếng Anh).",
      "created": "Đã tạo danh mục.",
      "saved": "Đã lưu danh mục.",
      "saveFailed": "Lưu thất bại.",
      "deleted": "Đã xoá \"{{name}}\".",
      "cannotDeleteTitle": "Không thể xoá danh mục",
      "cannotDeleteBody": "Danh mục này vẫn còn blueprint đang được gán.",
      "deleteFailed": "Xoá thất bại.",
      "newCategory": "Danh mục mới",
      "categoryFallback": "Danh mục",
      "idLabel": "ID: {{id}}",
      "nameEnLabel": "Tên (Tiếng Anh)",
      "nameEnPlaceholder": "T-Shirts",
      "nameViLabel": "Tên (Tiếng Việt)",
      "nameViPlaceholder": "Áo thun",
      "nameFrLabel": "Tên (Tiếng Pháp, tuỳ chọn)",
      "nameFrPlaceholder": "T-shirts",
      "slugLabel": "Slug URL",
      "slugPlaceholder": "t-shirts",
      "slugHint": "Chữ thường, kebab-case, duy nhất trong cùng cấp cha.",
      "topLevelOption": "— Cấp cao nhất —",
      "depthHint": "Độ sâu tối đa 2 cấp (cấp cao nhất → danh mục con).",
      "statusLabel": "Trạng thái",
      "aliasLabel": "Alias (tên thay thế khi tìm kiếm, tuỳ chọn)",
      "aliasPlaceholder": "Tees, Apparel Tops",
      "shortDescLabel": "Mô tả ngắn (tuỳ chọn)",
      "shortDescPlaceholder": "Áo thun cotton mềm, in toàn thân",
      "imageLabel": "Ảnh đại diện (tuỳ chọn)",
      "imageHelper": "PNG / JPEG / SVG ≤ 5 MB",
      "saveBtn": "Lưu thay đổi",
      "cancel": "Huỷ",
      "deleteConfirmTitle": "Xoá danh mục?",
      "deleteConfirmPrefix": "Đang xoá \"",
      "deleteConfirmSuffix": "\" — có thể khôi phục từ nhật ký xoá mềm, nhưng các blueprint đang gán vào danh mục này sẽ chặn thao tác."
    },
    "seoForm": {
      "legend": "SEO",
      "defaultHint": "Mặc định: \"{{value}}\".",
      "canonicalLabel": "Canonical URL (tuỳ chọn)",
      "googleIndexLabel": "Cho phép Google index danh mục này",
      "keywordsLabel": "Meta keywords (tuỳ chọn)",
      "keywordsPlaceholder": "t-shirt, custom apparel, print on demand",
      "keywordsHint": "Các từ phân cách bằng dấu phẩy (một số công cụ tìm kiếm sử dụng).",
      "descriptionLabel": "Meta description"
    },
    "treeView": {
      "collapse": "Thu gọn",
      "expand": "Mở rộng",
      "dragToReorder": "Kéo để sắp xếp trong cùng cấp",
      "addSub": "+ Con",
      "empty": "Chưa có danh mục nào. Bấm \"+ Category\" để thêm mới.",
      "treeAria": "Cây danh mục"
    },
    "list": {
      "pageTitle": "Danh mục & Bộ sưu tập",
      "pageSubtitle": "Quản lý cấu trúc danh mục sản phẩm, danh mục cha – con và các kênh catalog đang hoạt động.",
      "tabCategory": "Danh mục",
      "tabCollection": "Bộ sưu tập",
      "searchPlaceholder": "Tìm danh mục...",
      "searchAria": "Tìm danh mục",
      "filterStatusAria": "Lọc theo trạng thái",
      "filterStatusAll": "Trạng thái: Tất cả",
      "filterDisplayAria": "Lọc theo hiển thị",
      "filterDisplayAll": "Hiển thị: Tất cả",
      "statusActive": "Đang hoạt động",
      "statusInactive": "Ngừng hoạt động",
      "displayOn": "Bật",
      "displayOff": "Tắt",
      "colName": "Tên",
      "colImage": "Ảnh",
      "colLastUpdate": "Cập nhật cuối",
      "colUpdatedBy": "Người cập nhật",
      "colStatus": "Trạng thái",
      "colDisplay": "Hiển thị",
      "colActions": "Thao tác",
      "dragColumnAria": "Sắp xếp lại",
      "expand": "Mở rộng",
      "collapse": "Thu gọn",
      "statusToggleAria": "Bật/tắt trạng thái cho {{name}}",
      "displayToggleAria": "Bật/tắt hiển thị trên trang chủ cho {{name}}",
      "editAria": "Chỉnh sửa {{name}}",
      "viewProductsAria": "Xem sản phẩm thuộc {{name}}",
      "showingRange": "Đang hiển thị {{from}}–{{to}} trên {{total}} danh mục",
      "empty": "Không có danh mục nào khớp bộ lọc này.",
      "toggleFailed": "Không lưu được thay đổi.",
      "rowsPerPage": "Số dòng mỗi trang:",
      "paginationAria": "Phân trang",
      "prevPage": "Trang trước",
      "nextPage": "Trang sau",
      "colCreatedAt": "Ngày tạo",
      "toggleSaved": "Đã lưu thay đổi.",
      "working": "Đang lưu…",
      "dragToReorder": "Kéo để đổi vị trí trong cùng một cấp",
      "reorderSaved": "Đã cập nhật thứ tự."
    },
    "form": {
      "createTitle": "Tạo danh mục",
      "editTitle": "Chỉnh sửa danh mục",
      "breadcrumbAria": "Đường dẫn",
      "crumbBlueprint": "Blueprint",
      "crumbCreate": "Tạo mới",
      "crumbEdit": "Chỉnh sửa",
      "basicInfo": "Thông tin cơ bản",
      "nameLabel": "Tên danh mục",
      "namePlaceholder": "Nhập tên danh mục",
      "slugLabel": "Slug",
      "slugPlaceholder": "Được tạo tự động",
      "slugHelper": "Slug được tạo tự động từ Tên danh mục và dùng để sinh đường dẫn URL.",
      "aliasLabel": "Bí danh",
      "aliasPlaceholder": "Nhập tên hiển thị",
      "imageLabel": "Ảnh",
      "imageHelper": "Tối đa 5MB. Định dạng PNG, JPG hoặc WebP.",
      "imageRemove": "Xoá ảnh",
      "shortDescLabel": "Mô tả ngắn",
      "shortDescPlaceholder": "Mô tả chi tiết danh mục để phục vụ catalog...",
      "parentLabel": "Danh mục cha",
      "parentNone": "Không có (Cấp 1)",
      "parentHelper": "Chỉ được chọn Danh mục cấp 1 làm Danh mục cha.",
      "productsHeading": "Sản phẩm",
      "productsEmptyTitle": "Chưa chọn sản phẩm nào",
      "productsEmptyBody": "Chọn sản phẩm để liên kết với danh mục này.",
      "productsSelected": "Đã chọn {{count}} sản phẩm",
      "productsSelectedBody": "Các sản phẩm này được liên kết riêng với danh mục này.",
      "selectProducts": "Chọn sản phẩm",
      "manageProducts": "Quản lý sản phẩm",
      "seoHeading": "Thiết lập SEO",
      "seoSubtitle": "Tối ưu cách danh mục này hiển thị trên công cụ tìm kiếm.",
      "seoTitleLabel": "Tiêu đề SEO",
      "seoTitlePlaceholder": "Nhập tiêu đề SEO",
      "seoTitleHelper": "Nếu để trống, hệ thống có thể tự động dùng Bí danh.",
      "canonicalLabel": "Canonical URL",
      "canonicalPlaceholder": "https://example.com/category/...",
      "canonicalHelper": "URL ưu tiên để công cụ tìm kiếm tránh nội dung trùng lặp.",
      "googleIndexLabel": "Lập chỉ mục Google",
      "metaKeywordsLabel": "Từ khoá Meta",
      "metaKeywordsPlaceholder": "Nhập từ khoá rồi nhấn Enter",
      "metaKeywordRemove": "Xoá từ khoá {{keyword}}",
      "metaDescriptionLabel": "Mô tả Meta",
      "metaDescriptionPlaceholder": "Nhập mô tả ngắn cho công cụ tìm kiếm...",
      "metaDescriptionHelper": "Độ dài khuyến nghị: 150–160 ký tự.",
      "metaDescriptionCounter": "{{count}} / {{max}} ký tự",
      "stateDrafted": "Đã lưu nháp mọi thay đổi",
      "stateSaved": "Đã lưu mọi thay đổi",
      "cancel": "Huỷ",
      "save": "Lưu",
      "saving": "Đang lưu…",
      "saveCategory": "Lưu danh mục",
      "saveChanges": "Lưu thay đổi",
      "savedCreate": "Đã tạo danh mục.",
      "savedEdit": "Đã lưu danh mục.",
      "saveFailed": "Lưu thất bại.",
      "loadError": "Không tải được danh mục này.",
      "errors": {
        "nameRequired": "Vui lòng nhập Tên danh mục.",
        "nameDuplicate": "Tên danh mục đã tồn tại. Vui lòng nhập tên khác.",
        "aliasRequired": "Vui lòng nhập Bí danh.",
        "canonicalInvalid": "Canonical URL không đúng định dạng.",
        "metaDescriptionTooLong": "Meta Description vượt quá số ký tự cho phép.",
        "parentMustBeLevel1": "Chỉ được chọn Danh mục cấp 1 làm Danh mục cha.",
        "hasChildren": "Mục này đang có {{count}} mục con nên không thể trở thành con của mục khác. Hãy chuyển các mục con trước.",
        "productsRequired": "Vui lòng chọn ít nhất một sản phẩm."
      },
      "imageUpload": "Tải ảnh lên",
      "imageUploading": "Đang tải…",
      "imageChange": "Đổi ảnh",
      "imageTypeError": "Chỉ chấp nhận ảnh PNG, JPG hoặc WebP.",
      "imageSizeError": "Ảnh quá lớn — tối đa {{max}}.",
      "imageUploadError": "Tải ảnh lên thất bại.",
      "loadingOptions": "Đang tải…",
      "parentLockedHelper": "Mục này đang có {{count}} mục con nên không thể trở thành con của mục khác — cây chỉ tối đa 2 cấp. Hãy chuyển các mục con trước."
    },
    "products": {
      "dialogTitle": "Chọn sản phẩm",
      "dialogSubtitle": "Tìm và chọn sản phẩm để liên kết với danh mục này.",
      "searchPlaceholder": "Tìm sản phẩm...",
      "filterStatusAria": "Lọc sản phẩm theo trạng thái",
      "filterStatusAll": "Trạng thái: Tất cả",
      "statusActive": "Đang hoạt động",
      "statusDraft": "Bản nháp",
      "statusInactive": "Ngừng hoạt động",
      "showSelectedOnly": "Chỉ hiện mục đã chọn",
      "selectAllOnPage": "Chọn tất cả sản phẩm trên trang này",
      "selectRowAria": "Chọn {{name}}",
      "colImage": "Ảnh",
      "colName": "Tên sản phẩm",
      "colBlueprint": "Blueprint",
      "colSkuCount": "Số SKU",
      "colStatus": "Trạng thái",
      "skuCount": "{{count}} SKU",
      "showingRange": "Đang hiển thị {{from}}–{{to}} trên {{total}} sản phẩm",
      "selectedCount": "Đã chọn {{count}}",
      "empty": "Không có sản phẩm nào khớp bộ lọc này.",
      "loadError": "Không tải được danh sách sản phẩm.",
      "status": {
        "Active": "Đang hoạt động",
        "Draft": "Bản nháp",
        "Inactive": "Ngừng hoạt động"
      },
      "takenBy": "Đã thuộc “{{category}}”",
      "takenByUnnamed": "Đã thuộc một danh mục khác"
    }
  },
  "blueprint": {
    "title": "Blueprint",
    "subtitle": "Mẫu sản phẩm (blueprint)",
    "columns": {
      "name": "Tên",
      "category": "Danh mục",
      "techniques": "Kỹ thuật",
      "basePrice": "Giá cơ bản",
      "isActive": "Đang hoạt động",
      "nameCode": "Tên/Mã",
      "status": "Trạng thái",
      "location": "Khu vực",
      "publishTime": "Thời gian xuất bản",
      "creator": "Người tạo",
      "lastUpdated": "Cập nhật gần nhất",
      "vendors": "Nhà cung cấp",
      "source": "Nguồn",
      "activeAction": "Mở bán",
      "actions": "Thao tác"
    },
    "actions": {
      "create": "Tạo Blueprint",
      "edit": "Sửa",
      "duplicate": "Nhân bản",
      "archive": "Lưu trữ",
      "import": "Nhập",
      "export": "Xuất",
      "exporting": "Đang xuất…"
    },
    "detail": {
      "tabs": {
        "info": "Thông tin",
        "variants": "Biến thể",
        "techniques": "Kỹ thuật",
        "pricing": "Giá",
        "addOns": "Add-on",
        "media": "Media",
        "seo": "SEO"
      }
    },
    "wizard": {
      "title": "Tạo blueprint",
      "subtitle": "Wizard 3 bước. Sau khi gửi, blueprint sẽ vào hàng đợi Duyệt sản phẩm để admin thứ hai xét duyệt.",
      "steps": {
        "information": "1. Thông tin",
        "attributes": "2. Thuộc tính",
        "preview": "3. Xem trước"
      },
      "type": {
        "label": "Loại",
        "locked": "Product (đã khoá)"
      },
      "productCode": "Mã sản phẩm",
      "productCodeHint": "3-12 ký tự, chỉ chữ in hoa và số.",
      "productName": "Tên sản phẩm (EN)",
      "slug": "Slug",
      "slugHint": "Tự động sinh từ tên; có thể chỉnh tay.",
      "category": "Danh mục",
      "collections": "Bộ sưu tập",
      "technology": "Công nghệ (chọn nhiều)",
      "productionType": {
        "label": "Loại sản xuất",
        "printing": "In ấn",
        "embroidery": "Thêu"
      },
      "processingTime": {
        "label": "Thời gian xử lý (ngày)",
        "fromDays": "Từ",
        "toDays": "Đến"
      },
      "scheduledPublish": "Hẹn giờ publish",
      "scheduledPublishHint": "Để trống = publish ngay khi được duyệt.",
      "templates": "Blueprint Templates",
      "templatesHint": "Template cấp blueprint sẽ cascade xuống mọi variant chưa có override.",
      "images": "Ảnh",
      "imagesDrop": "Kéo ảnh vào đây hoặc click để chọn",
      "imagesAccept": "JPEG / PNG / WEBP — tối đa 10 ảnh, cần ≥5 mới publish được.",
      "description": "Mô tả",
      "guideline": "Hướng dẫn",
      "videoUrl": "Video URL",
      "videoUrlHint": "Bắt buộc là URL YouTube hoặc Vimeo.",
      "attributes": {
        "title": "SKU generator",
        "subtitle": "Chọn Option + giá trị, hệ thống sẽ tự tạo SKU theo tổ hợp tích Đề-các.",
        "addOption": "Thêm option",
        "generate": "Generate SKU",
        "preview": "Preview"
      },
      "sku": {
        "table": "Bảng SKU",
        "addBlank": "Thêm SKU trống",
        "code": "SKU",
        "attributes": "Thuộc tính",
        "weight": "Cân nặng (g)",
        "dim": {
          "l": "D",
          "w": "R",
          "h": "C"
        },
        "templates": "Templates"
      },
      "preview": {
        "information": "Thông tin",
        "skuTable": "Bảng SKU",
        "publishNotReady": "Hiện chưa đủ 5 ảnh. Người duyệt sẽ chặn publish cho đến khi có ≥5 ảnh.",
        "submitNote": "Sau khi gửi, blueprint vào hàng đợi Duyệt sản phẩm (admin tự tạo). Cần admin khác duyệt mới được publish."
      },
      "actions": {
        "cancel": "Huỷ",
        "back": "Quay lại",
        "next": "Tiếp",
        "submit": "Gửi duyệt",
        "submitting": "Đang gửi…"
      },
      "create": {
        "pageSubtitle": "Sau khi gửi, blueprint sẽ được đưa vào hàng đợi Duyệt sản phẩm để admin thứ hai xét duyệt.",
        "stepCounter": "Bước {{current}} / {{total}}",
        "stepperAria": "Tiến trình wizard",
        "steps": {
          "information": "Thông tin",
          "attributes": "Thuộc tính",
          "logistics": "Vận chuyển",
          "settings": "Cài đặt",
          "preview": "Xem trước"
        },
        "actions": {
          "continue": "Tiếp tục ›",
          "goBack": "‹ Quay lại",
          "submitForApproval": "Gửi duyệt",
          "apply": "Áp dụng",
          "creating": "Đang tạo…",
          "addLocation": "+ Thêm location",
          "addVendor": "+ Thêm vendor",
          "save": "Lưu"
        },
        "type": {
          "label": "Loại:",
          "product": "Sản phẩm",
          "cannotChange": "(Không thể thay đổi sau khi tạo)"
        },
        "checking": "Đang kiểm tra…",
        "code": {
          "invalid": "3-12 ký tự, chỉ chữ in hoa và số.",
          "taken": "Mã Blueprint này đã được dùng — hãy chọn mã khác.",
          "available": "Mã Blueprint khả dụng.",
          "placeholder": "Nhập mã sản phẩm"
        },
        "slug": {
          "taken": "Đã có sản phẩm trùng tên (slug \"{{slug}}\") — hãy đặt tên khác."
        },
        "fields": {
          "blueprintCode": "Mã",
          "blueprintName": "Tên",
          "blueprintNamePlaceholder": "Nhập tên sản phẩm",
          "skuType": "Loại SKU",
          "category": "Danh mục",
          "categoryPlaceholder": "Chọn danh mục",
          "categoryRequired": "Bắt buộc chọn danh mục",
          "collection": "Bộ sưu tập",
          "productionType": "Loại",
          "technology": "Kỹ thuật",
          "processingTime": "Thời gian xử lý",
          "publishTime": "Thời gian publish",
          "description": "Mô tả",
          "guideline": "Hướng dẫn",
          "videoUrl": "Video URL",
          "images": "Ảnh",
          "uploadedThumbnails": "Ảnh đã tải lên",
          "chargeForEmbroidery": "Tính tiền thêu",
          "maxEmbroideryColors": "Số màu thêu tối đa",
          "youtubeVideoUrl": "URL video Youtube",
          "technologyRequired": "Công nghệ là trường bắt buộc",
          "processingTimeRequired": "Thời gian xử lý là trường bắt buộc",
          "processingTimeInverted": "Số ngày bắt đầu phải nhỏ hơn số ngày kết thúc",
          "blueprintNameRequired": "Tên blueprint là trường bắt buộc",
          "blueprintCodeRequired": "Mã blueprint là trường bắt buộc",
          "imagesRequired": "Ảnh là trường bắt buộc — cần thêm {{count}} ảnh (tối thiểu {{min}})",
          "searchCategory": "Tìm danh mục…",
          "searchingCategories": "Đang tìm…",
          "noCategoryOptions": "Không có danh mục đang hoạt động nào khớp."
        },
        "skuType": {
          "product": "Sản phẩm",
          "accessory": "Phụ kiện"
        },
        "category": {
          "quickCreateAria": "Tạo nhanh danh mục mới",
          "quickCreateTitle": "Tạo nhanh danh mục"
        },
        "collection": {
          "loading": "Đang tải bộ sưu tập…",
          "searchPlaceholder": "Tìm bộ sưu tập...",
          "dropdownLoading": "Đang tải…",
          "emptyHint": "Chưa có bộ sưu tập. Dùng nút “+” để tạo mới.",
          "noMatch": "Không có bộ sưu tập khớp với “{{query}}”.",
          "quickCreateAria": "Tạo nhanh bộ sưu tập mới",
          "quickCreateTitle": "Tạo nhanh bộ sưu tập",
          "removeAria": "Bỏ bộ sưu tập {{name}}"
        },
        "productionType": {
          "aria": "Loại sản xuất",
          "printing": "In",
          "embroidery": "Thêu",
          "cutting": "Cắt",
          "blank": "Blank"
        },
        "technology": {
          "hint": "Vui lòng chọn ít nhất một công nghệ"
        },
        "processing": {
          "to": "Đến",
          "days": "ngày",
          "from": "Từ",
          "businessDays": "ngày làm việc",
          "figmaHint": "Thời gian sản xuất ước tính, tính theo ngày làm việc."
        },
        "publish": {
          "hint": "Hẹn giờ publish"
        },
        "videoUrl": {
          "hint": "Nhập video URL (YouTube, v.v.)",
          "invalid": "Phải là URL YouTube hoặc Vimeo.",
          "placeholder": "https://youtube.com/watch?v=...",
          "figmaHint": "Thêm video 5–15 giây để sản phẩm sinh động hơn — có thể giúp bạn bán được nhiều hơn!"
        },
        "images": {
          "dropHint": "Kéo & thả ảnh vào đây, hoặc",
          "uploadAria": "Tải lên ảnh mockup",
          "uploading": "Đang tải lên…",
          "uploadButton": "Tải ảnh lên",
          "helper": "JPEG / PNG — tối đa 10 ảnh. Cần tối thiểu {{min}} ảnh",
          "helperMissing": " (còn thiếu {{count}}).",
          "previewAria": "Xem trước {{name}}",
          "reorderTitle": "Kéo thẻ để đổi vị trí",
          "remove": "Xoá",
          "empty": "Chưa có ảnh nào",
          "emptyHint": "Ảnh thu nhỏ sẽ hiển thị ở đây",
          "needMore": "Cần thêm {{count}} ảnh nữa trước khi đủ điều kiện publish.",
          "primaryBadge": "Ảnh chính",
          "figmaHelper": "Tải lên từ {{min}}–{{max}} ảnh. Ảnh đầu tiên sẽ là ảnh chính của sản phẩm. Bạn có thể kéo để sắp xếp lại."
        },
        "location": {
          "title": "Location & Vendor",
          "subtitle": "Chọn Location & Vendor",
          "emptyBound": "Chưa gán location nào. Bấm \"+ Thêm location\" để chọn từ danh mục Fulfillment Locations.",
          "vendors": "Vendor",
          "selectDefaultHint": "Chọn vendor mặc định bằng nút radio.",
          "markDefaultAria": "Đặt làm vendor mặc định",
          "pickVendorFirstTitle": "Chọn vendor trước khi đặt làm mặc định",
          "minVendorTitle": "Mỗi location cần ít nhất một vendor",
          "removeVendorTitle": "Xoá vendor",
          "vendorListEmpty": "Cần ít nhất một vendor cho mỗi location.",
          "pickDefaultVendor": "Hãy chọn vendor cho nút radio mặc định.",
          "defaultLocation": "Location mặc định",
          "addLocation": "Thêm location",
          "noneExist1": "Chưa có location nào. Hãy tạo location ở trang",
          "fulfillmentLocationsLink": "Fulfillment Locations",
          "noneExist2": "trước.",
          "perSkuNote": "Gán location & vendor theo từng SKU được cấu hình ở trang chi tiết Blueprint sau khi tạo.",
          "selectVendor": "Chọn vendor",
          "noLocationOptions": "Chưa có fulfillment location nào.",
          "noVendorOptions": "Chưa có vendor nào.",
          "vendorSharePctAria": "Tỷ lệ chia đơn cho {{vendor}}, tính theo phần trăm",
          "pctSumOk": "Σ 100% — tỷ lệ hợp lệ",
          "pctSumInvalid": "Σ {{sum}}% — tổng tỷ lệ phải bằng 100%",
          "searchVendor": "Tìm nhà cung cấp…",
          "searchingVendors": "Đang tìm nhà cung cấp…",
          "pctSumUnbound": "Σ {{sum}}% — một phần đang thuộc vendor đã bỏ chọn"
        },
        "selectLocation": "— Chọn Location —",
        "selectVendor": "Chọn vendor…",
        "removeLocationAria": "Xoá location",
        "removeVendorAria": "Xoá vendor",
        "tiktok": {
          "title": "Cấu hình TikTok",
          "subtitle": "Tích chọn từng vendor sẽ giao qua TikTok.",
          "emptyHint": "Hãy chọn Location & Vendor ở trên để ánh xạ vendor cho vận chuyển TikTok.",
          "noVendor": "Chưa chọn vendor",
          "defaultBadge": "Mặc định"
        },
        "skuList": {
          "title": "Danh sách SKU",
          "count": "{{count}} SKU",
          "import": "Nhập Excel",
          "export": "Xuất Excel",
          "filterBy": "Lọc theo:",
          "noAttrGroups": "Chưa có nhóm thuộc tính — hãy dùng generator ở trên.",
          "selectedCount": "Đã chọn {{count}} SKU",
          "templateLabel": "Template:",
          "bulkTemplateAria": "Gán template hàng loạt",
          "skuTypeLabel": "Loại SKU:",
          "tierPriceLabel": "Giá theo tier:",
          "bulkEditPrices": "Sửa giá hàng loạt",
          "deselect": "Bỏ chọn",
          "empty": "Chưa có SKU. Chọn option ở bên trái — bảng sẽ tự điền.",
          "pricesNote": "Giá tính bằng cent (vd 1099 = $10.99). Ô trống sẽ bỏ qua cặp variant×tier đó. Thông tin vận chuyển (cân nặng / kích thước / nhóm vận chuyển) được chỉnh ở trang chi tiết Blueprint sau khi tạo.",
          "clearFilters": "Xóa bộ lọc",
          "noFilterMatch": "Không có SKU nào khớp bộ lọc đã chọn.",
          "exportSuccess": "Đã xuất {{count}} SKU",
          "exportEmptyTemplate": "Chưa có SKU — đã xuất mẫu trống. Điền vào rồi nhập lại.",
          "exportError": "Xuất file thất bại",
          "exportHint": "Tải danh sách SKU hiện tại (.xlsx): SKU, thuộc tính, loại, giá theo từng tier, phí vận chuyển theo từng dịch vụ, logistics và trạng thái.",
          "importDone": "Đã cập nhật {{updated}} SKU, bỏ qua {{skipped}}",
          "importError": "Nhập file thất bại — kiểm tra file đúng định dạng đã xuất",
          "importHint": "Nhập .xlsx/.csv để tạo hoặc cập nhật SKU. Giá trị thuộc tính phải có sẵn trong catalog (Products → Options); giá và phí vận chuyển theo $.",
          "importEmpty": "File không có dòng nào.",
          "importNoMatch": "Không có SKU nào khớp. Import chỉ cập nhật các SKU đã được sinh từ options — hãy Export trước để lấy đúng mẫu, sửa rồi import lại.",
          "importOptionsLoading": "Catalog options chưa tải xong — đợi chút rồi import lại.",
          "importCreated": "Đã tạo {{created}} SKU mới, cập nhật {{updated}}, bỏ qua {{skipped}}",
          "importUnresolved": "Không import được SKU nào — các giá trị thuộc tính này chưa có trong catalog: {{missing}}. Hãy thêm ở Products → Options trước.",
          "importNoRows": "Không import được SKU nào — kiểm tra cột SKU + Attributes khớp mẫu đã export.",
          "importTemplatesUnresolved": "Bỏ qua code template không tồn tại: {{codes}}. Dùng đúng CODE template (Export sẽ hiện code).",
          "optionFilterLabel": "Option:",
          "rowsPerPage": "Số dòng mỗi trang:",
          "showingRange": "Hiển thị {{from}}–{{to}} trong {{total}} SKU",
          "prevPage": "Trang trước",
          "nextPage": "Trang sau",
          "vendorFilterLabel": "Vendor:",
          "allVendors": "Tất cả vendor",
          "allOptions": "Tất cả option",
          "bulkEdit": "Sửa",
          "bulkAssignTemplate": "Gán Template",
          "bulkSetDimension": "Đặt kích thước",
          "copyPricesPrompt": "Location này chưa có giá.",
          "copyPricesFrom": "Sao chép từ {{from}}",
          "copyPricesDone": "Đã sao chép giá từ {{from}}.",
          "bulkMarkSmall": "Đánh dấu Small",
          "bulkUnmarkSmall": "Bỏ Small"
        },
        "skuTable": {
          "selectAllAria": "Chọn tất cả SKU",
          "code": "SKU",
          "attributes": "Thuộc tính",
          "templates": "Template",
          "type": "Loại",
          "selectRowAria": "Chọn SKU {{sku}}",
          "codeReadonlyTitle": "SKU được sinh từ giá trị option (chỉ đọc)",
          "editTemplatesAria": "Sửa template cho SKU này",
          "priceMonotonicTitle": "{{tier}} ({{current}}) phải thấp hơn {{higherTier}} ({{higherValue}}).",
          "toggleActiveTitle": "SKU đang Inactive — bấm để Active lại",
          "toggleInactiveTitle": "SKU đang Active — bấm để Inactive",
          "inactive": "Inactive",
          "active": "Active",
          "action": "Thao tác",
          "vendor": "Vendor",
          "dimension": "Kích thước",
          "status": "Trạng thái",
          "assign": "Gán",
          "set": "Thiết lập",
          "view": "Xem",
          "viewCount": "Xem ({{count}})",
          "templatesCount": "Template ({{count}})",
          "dimensionAria": "Thiết lập kích thước cho {{sku}}",
          "priceZeroTitle": "Giá phải lớn hơn 0.",
          "tierWithUnit": "{{tier}} ($)",
          "priceRequiredTitle": "Bậc giá này bắt buộc phải có giá.",
          "dimensionFormat": "Khối lượng x C x R x D",
          "dimensionValueAria": "Khối lượng {{weight}} g, hộp {{height}} x {{width}} x {{length}} in",
          "small": "Small",
          "smallAria": "Đánh dấu {{sku}} là sản phẩm nhỏ",
          "dimensionValueWithUnit": "{{weight}} g x {{height}} in x {{width}} in x {{length}} in"
        },
        "skuTypeLabels": {
          "product": "Sản phẩm",
          "small_product": "Sản phẩm nhỏ",
          "accessory": "Phụ kiện"
        },
        "logistics": {
          "descriptionExtra": "— Blueprint Active yêu cầu các trường này khi duyệt; vận chuyển chưa đầy đủ sẽ chặn việc chuyển sang Active.",
          "exportSuccess": "Đã xuất {{count}} dòng",
          "exportError": "Xuất file thất bại",
          "exportHint": "Tải logistics (.xlsx): SKU, cân nặng, kích thước kèm đơn vị và phí vận chuyển theo từng dịch vụ ($).",
          "importEmpty": "File không có dòng nào.",
          "importNoMatch": "Không có SKU nào khớp — Export trước để lấy mẫu, điền rồi import lại.",
          "importDone": "Đã cập nhật {{updated}}, bỏ qua {{skipped}} dòng",
          "importError": "Nhập file thất bại — kiểm tra file đúng định dạng đã xuất",
          "importFeeInvalid": "Bỏ qua phí vận chuyển ở: {{columns}} — phải là số từ 0 đến 10000.",
          "importWrongLocation": "File này chứa giá của {{sheet}}, nhưng tab đang mở là {{active}}. Hãy chuyển sang tab của location đó rồi import.",
          "importHint": "Nhập .xlsx/.csv để cập nhật hàng loạt cân nặng, kích thước (kèm đơn vị) và phí vận chuyển, khớp theo SKU."
        },
        "preview": {
          "logisticsBanner": "⚠ Phần vận chuyển (khối lượng + dài/rộng/cao + phí theo từng dịch vụ) chưa đủ. Bạn vẫn lưu nháp được, nhưng người phê duyệt sẽ không cho chuyển sang Active tới khi đủ. Hoàn tất ở block Vận chuyển phía trên trước khi gửi để bật Active.",
          "information": "Thông tin",
          "nameEn": "Tên (EN)",
          "slug": "Slug",
          "collections": "Bộ sưu tập",
          "technologies": "Công nghệ",
          "selectedCount": "đã chọn {{count}}",
          "processingTime": "Thời gian xử lý",
          "daysRange": "{{from}}–{{to}} ngày",
          "publishAt": "Publish lúc",
          "immediate": "Ngay khi được duyệt",
          "templates": "Template",
          "images": "Ảnh",
          "publishReady": "đủ điều kiện publish",
          "needFive": "cần 5+",
          "skuTable": "Bảng SKU",
          "skuSummary": "{{skus}} SKU — {{entries}} mục giá.",
          "noSkus": "Chưa có SKU nào — chọn tuỳ chọn ở block Tuỳ chọn để sinh SKU trước khi lưu.",
          "noPricesWarn": "⚠ Chưa đặt giá. Người phê duyệt sẽ thấy giá trống — điền ở block Giá phía trên, hoặc lưu rồi sửa giá ở trang chi tiết blueprint sau khi được duyệt.",
          "imageCountWarn": "⚠ Số ảnh hiện là {{count}}/5. Người duyệt sẽ chặn publish cho đến khi có đủ 5+ ảnh.",
          "noAreasBanner": "Chưa SKU nào được gán Template nên sản phẩm này sẽ không có vùng in — không mở bán được cho tới khi có ít nhất một vùng in. Hãy gán Template ở bước Thuộc tính, hoặc thêm vùng in sau ở trang sản phẩm.",
          "submitNote": "Gửi sẽ đưa blueprint này vào hàng đợi Duyệt sản phẩm (admin tự tạo). Cần một admin khác duyệt trước khi publish."
        },
        "templatePicker": {
          "aria": "Chọn template",
          "title": "Chọn Template",
          "searchPlaceholder": "Tìm template…",
          "empty": "Chưa có blueprint template nào. Hãy thêm template ở trang catalog trước.",
          "noMatch": "Không có template khớp với \"{{query}}\".",
          "select": "Chọn",
          "deselectAria": "Bỏ chọn {{name}}"
        },
        "vendorPicker": {
          "aria": "Gán vendor/location cho SKU",
          "title": "Vendor / Location — {{sku}}",
          "titleBulk": "Vendor / Location — {{count}} SKU",
          "description": "Gán location + vendor cho SKU. Cột % đơn hàng chia theo từng location: tổng mỗi location = 100 để chia đơn theo tỉ lệ; bỏ trống = routing lấy vendor điểm cao nhất.",
          "empty1": "Chưa có location. Bấm",
          "empty2": "để bắt đầu.",
          "location": "Location",
          "default": "Mặc định",
          "vendor": "Vendor",
          "orderPercent": "% đơn hàng",
          "noVendor": "Chưa có vendor. Bấm \"+ Thêm vendor\".",
          "pickLocationFirst": "Chọn location trước",
          "sumNoSplit": "Không chia — routing lấy vendor điểm cao nhất",
          "sumValid": "Hợp lệ — chia theo %",
          "sumInvalid": "Tổng % của location này phải = 100 (hoặc bỏ trống hết)",
          "sumNeed100Suffix": " — cần = 100",
          "locationsIncomplete": "{{count}} location chưa đủ 100% — không thể lưu",
          "percentValid": "% hợp lệ — chia theo location",
          "weightWarnTitle": "Mỗi location phải có tổng % = 100, hoặc bỏ trống hết (không chia). Không thể Áp dụng khi còn location dở.",
          "applyInvalidTitle": "Có location % chưa hợp lệ (≠100 và ≠0) — chỉnh về 100 hoặc xoá hết %"
        },
        "bulkPrice": {
          "aria": "Sửa giá tier hàng loạt",
          "title": "Sửa giá hàng loạt — {{count}} SKU",
          "hint": "Để trống một tier để giữ nguyên giá hiện tại của từng SKU. Giá đã nhập sẽ ghi đè lên mọi SKU đã chọn.",
          "noTiers": "Chưa cấu hình tier giá nào.",
          "pricePlaceholder": "vd 1099 (= $10.99)",
          "monotonicWarn": "⚠ {{tier}} ({{current}}) ≥ {{higherTier}} ({{higherValue}}). Tier cao hơn phải cao hơn tier thấp hơn."
        },
        "imagePreview": {
          "aria": "Xem trước {{name}}",
          "ariaDefault": "Xem trước ảnh",
          "closeAria": "Đóng xem trước"
        },
        "categoryModal": {
          "aria": "Tạo nhanh danh mục",
          "title": "Tạo nhanh danh mục",
          "code": "Mã danh mục",
          "name": "Tên danh mục",
          "namePlaceholder": "Áo thun",
          "parent": "Danh mục cha",
          "rootCategory": "Danh mục gốc",
          "submit": "Tạo danh mục"
        },
        "collectionModal": {
          "aria": "Tạo bộ sưu tập mới",
          "title": "Tạo bộ sưu tập mới",
          "nameEn": "Tên (EN)",
          "nameEnPlaceholder": "vd Spring 2026",
          "nameVi": "Tên (VI)",
          "nameViPlaceholder": "vd Mùa xuân 2026",
          "slug": "Slug",
          "slugPlaceholder": "tự động sinh từ tên",
          "slugHint": "Tự động sinh từ tên; chỉnh tay để ghi đè.",
          "submit": "Tạo bộ sưu tập"
        },
        "confirm": {
          "discard": "Bỏ bản nháp chưa lưu và rời đi?"
        },
        "addons": {
          "heading": "Add-on",
          "description": "Tuỳ chọn bổ sung mà merchant có thể thêm khi đặt sản phẩm này.",
          "enable": "Bật add-on",
          "disabledHint": "Sản phẩm này đang tắt add-on. Bật lên để chọn những add-on áp dụng.",
          "addLabel": "Thêm add-on",
          "selectAddon": "Chọn add-on…",
          "noMore": "Không còn add-on nào",
          "loading": "Đang tải add-on…",
          "add": "Thêm",
          "remove": "Xoá",
          "empty": "Chưa chọn add-on nào.",
          "colName": "Tên",
          "colMode": "Kiểu chọn",
          "colRequired": "Bắt buộc",
          "colActions": "Thao tác",
          "requiredSuffix": ", bắt buộc",
          "yes": "Có",
          "no": "Không",
          "linkedOnCreateHint": "Các add-on này được gắn sau khi sản phẩm được tạo. Bạn có thể sửa lại ở bước Settings của sản phẩm."
        },
        "toast": {
          "categoryNameRequiredTitle": "Cần nhập Tên danh mục",
          "categoryNameRequiredDesc": "Hãy nhập tên danh mục.",
          "categoryCodeRequiredTitle": "Cần nhập Mã danh mục",
          "categoryCodeRequiredDesc": "Hãy nhập mã (vd DM-001).",
          "categoryCodeInvalidTitle": "Mã danh mục không hợp lệ",
          "categoryCodeInvalidDesc": "Mã phải chứa chữ cái hoặc chữ số.",
          "categoryCreateFailTitle": "Tạo danh mục thất bại",
          "categoryCreatedTitle": "Đã tạo danh mục",
          "categoryCreatedDesc": "{{name}} đã sẵn sàng để dùng.",
          "networkError": "Lỗi mạng",
          "collectionNameRequiredTitle": "Cần nhập Tên",
          "collectionNameRequiredDesc": "Hãy nhập tên bộ sưu tập (EN).",
          "collectionCreateFailTitle": "Tạo bộ sưu tập thất bại",
          "collectionCreatedTitle": "Đã tạo bộ sưu tập",
          "collectionCreatedDesc": "{{name}} đã sẵn sàng để dùng.",
          "uploadFailedReason": "tải lên thất bại",
          "more": "khác",
          "skippedUnsupportedTitle": "Đã bỏ qua {{count}} tệp không được hỗ trợ",
          "skippedUnsupportedDesc": "Chỉ chấp nhận JPEG / PNG. Đã bỏ qua: {{files}}",
          "imageCapTitle": "Đã đạt giới hạn ảnh",
          "imageCapDesc": "Chỉ cho phép 10 ảnh khi tạo. Đã bỏ qua {{count}} tệp.",
          "uploadFailedTitle": "{{count}} lần tải lên thất bại",
          "step1ImagesDesc": "Cần tối thiểu {{min}} ảnh mockup (hiện {{current}}). Bổ sung ảnh trước khi tiếp tục.",
          "step1FixFields": "Hãy sửa các trường được tô sáng trước khi tiếp tục.",
          "step1IncompleteTitle": "Block Thông tin chưa đủ",
          "skuUniqueDesc": "Mỗi SKU phải là duy nhất và không được để trống.",
          "skuAddOneDesc": "Thêm ít nhất một SKU trước khi tiếp tục.",
          "skuMissingTemplateDesc": "{{count}} SKU chưa có Template. Dùng nút + ở từng dòng hoặc thao tác Template hàng loạt.",
          "step2IncompleteTitle": "Block Tuỳ chọn chưa đủ",
          "locationRequiredTitle": "Bắt buộc chọn Location & Vendor",
          "locationRequiredDesc": "Hãy gắn ít nhất một Location kèm Vendor trước khi tiếp tục. Không thể tạo blueprint nếu thiếu Location & Vendor.",
          "logisticsIncompleteTitle": "Vận chuyển chưa đầy đủ",
          "logisticsIncompleteDesc": "Một số SKU thiếu cân nặng / kích thước / nhóm vận chuyển. Bạn có thể tiếp tục dưới dạng nháp — validation sẽ chạy ở bước duyệt.",
          "createFailTitle": "Tạo blueprint thất bại",
          "submittedTitle": "Đã gửi để duyệt",
          "submittedDesc": "Blueprint hiện đang trong hàng đợi Duyệt sản phẩm.",
          "importTitle": "Tính năng Nhập chưa sẵn sàng",
          "importDesc": "Nhập từ wizard sẽ có ở trang chi tiết Blueprint sau khi tạo (xlsx).",
          "exportTitle": "Tính năng Xuất chưa sẵn sàng",
          "exportDesc": "Xuất có sẵn ở trang chi tiết Blueprint sau khi tạo (xlsx).",
          "priceZeroTitle": "Giá không được bằng 0",
          "priceZeroDesc": "Có {{count}} ô giá đang để 0. Nhập giá lớn hơn 0, hoặc xoá trống ô nếu không muốn đặt giá cho tier đó.",
          "step1MissingFields": "Vui lòng nhập đầy đủ các trường bắt buộc: {{fields}}.",
          "priceRequiredDesc": "{{count}} ô giá còn trống. Mỗi SKU phải có giá cho mọi bậc giá trước khi sang bước tiếp.",
          "tierOrderDesc": "{{count}} ô giá sai thứ tự bậc — bậc thấp hơn phải có giá rẻ hơn bậc trên nó.",
          "optionRowIncomplete": "Có {{count}} dòng option chưa hoàn tất — hãy chọn option và ít nhất 1 giá trị, hoặc xoá dòng đó."
        },
        "vendorCell": {
          "unassigned": "Chưa gán"
        },
        "tocAria": "Các phần của blueprint",
        "nothingSavedYet": "Chưa lưu — bấm Lưu để tạo blueprint",
        "blocks": {
          "details": "Thông tin",
          "techniques": "Kỹ thuật",
          "mockups": "Ảnh mockup",
          "options": "Tuỳ chọn",
          "locations": "Địa điểm",
          "logistic": "Vận chuyển",
          "review": "Kiểm tra lại",
          "pricing": "Giá",
          "tiktok": "TikTok Shop",
          "areas": "Vùng in",
          "accessories": "Phụ kiện"
        },
        "blockSubtitles": {
          "techniques": "Cấu hình kỹ thuật sản xuất cho blueprint này.",
          "options": "Chọn tuỳ chọn để sinh tổ hợp SKU. Tối đa 3 tuỳ chọn mỗi blueprint.",
          "locations": "Cấu hình địa điểm sản xuất và gán vendor cho blueprint này.",
          "logistic": "Cấu hình vận chuyển và phí cho từng SKU theo địa điểm.",
          "review": "Kiểm tra lại toàn bộ trước khi lưu.",
          "pricing": "Cấu hình giá và template cho từng SKU theo địa điểm.",
          "tiktok": "Cấu hình TikTok Shop (không bắt buộc) cho blueprint này.",
          "areas": "Cấu hình giá cho vùng in/thêu",
          "accessories": "Cấu hình giá cho phụ kiện và hạng mục kèm theo."
        },
        "dimensionModal": {
          "aria": "Thiết lập kích thước",
          "title": "Thiết lập kích thước",
          "subtitle": "Cấu hình kích thước thùng để tính phí vận chuyển.",
          "unitBox": "Khối lượng thùng",
          "boxHeight": "Chiều cao thùng",
          "boxWidth": "Chiều rộng thùng",
          "boxLength": "Chiều dài thùng",
          "bulkTarget": "Đã chọn {{count}} SKU"
        },
        "countryTabsAria": "Quốc gia",
        "countryTabsEmpty": "Thêm địa điểm ở block Địa điểm để cấu hình giá theo từng quốc gia.",
        "areas": {
          "selectionMode": "Chế độ chọn",
          "mode": {
            "multi": "Chọn nhiều",
            "single": "Chọn một"
          },
          "startChargingFrom": "Bắt đầu tính phí từ",
          "startChargingHint": "Giá áp dụng từ vùng in thứ này trở đi. Không được nhỏ hơn số lượng bắt buộc.",
          "clampedToRequired": "Đã nâng lên {{value}} — có đúng số vùng đó là bắt buộc, và vùng bắt buộc không bao giờ miễn phí.",
          "pricingConfig": "Cấu hình giá theo vùng",
          "applySameFee": "Dùng một giá cho mọi tier",
          "emptyNeedsTemplate": "Chưa có vùng in nào. Vùng in đến từ template đã gán cho SKU — gán Template ở block Giá thì chúng sẽ hiện ở đây.",
          "bulkEdit": "Sửa",
          "bulkEditAria": "Sửa giá cho nhiều vùng in",
          "bulkEditSubtitle": "Sửa giá cho nhiều vùng in cùng lúc.",
          "bulkPrice": "Giá",
          "bulkRequired": "Bắt buộc",
          "bulkDisplay": "Hiển thị",
          "bulkEditDone": "Đã cập nhật {{count}} vùng in.",
          "startChargingRequired": "Bắt buộc nhập \"Bắt đầu tính phí từ\" — nhập số từ 1 trở lên."
        },
        "accessories": {
          "pricingConfig": "Cấu hình giá phụ kiện",
          "searchPlaceholder": "Tìm phụ kiện để thêm...",
          "searching": "Đang tìm…",
          "noResults": "Không có phụ kiện nào khớp.",
          "add": "Thêm",
          "added": "Đã thêm",
          "emptySearchToAdd": "Chưa liên kết phụ kiện nào. Tìm ở trên để thêm.",
          "scopeFilter": "Tìm phụ kiện theo",
          "scope": {
            "product": "Blueprint",
            "variant": "Biến thể"
          }
        },
        "breadcrumbAria": "Đường dẫn",
        "crumbBlueprint": "Blueprint",
        "crumbCreate": "Tạo mới",
        "chargeForEmbroidery": {
          "yes": "Có",
          "no": "Không"
        },
        "maxEmbroideryColors": {
          "invalid": "Số màu thêu tối đa phải là số nguyên lớn hơn 0."
        },
        "toc": {
          "pinTitle": "Ghim thanh mục lục khi cuộn",
          "unpinTitle": "Bỏ ghim thanh mục lục"
        },
        "tocLabels": {
          "mockups": "Mockup"
        }
      }
    },
    "errors": {
      "missingTechnique": "Blueprint phải có ít nhất một kỹ thuật",
      "duplicateName": "Đã tồn tại blueprint với tên này",
      "loadFailed": "Không tải được blueprints",
      "networkError": "Lỗi mạng",
      "networkErrorDesc": "Lỗi mạng - kiểm tra kết nối",
      "exportFailed": "Xuất thất bại"
    },
    "detailPage": {
      "loading": "Đang tải blueprint…",
      "errorHeading": "Chi tiết blueprint",
      "backToList": "Quay lại Blueprints",
      "pricingSummary": "Áp ${{amount}} cho {{count}} biến thể @ {{tier}}",
      "defaultTier": {
        "standard": "Tiêu chuẩn",
        "premium": "Cao cấp",
        "enterprise": "Doanh nghiệp"
      },
      "errors": {
        "missingId": "Thiếu blueprint id trong URL",
        "loadFailedHttp": "Tải thất bại (HTTP {{status}})",
        "networkCheck": "Lỗi mạng — kiểm tra kết nối",
        "network": "Lỗi mạng",
        "notFound": "Không tìm thấy blueprint"
      },
      "header": {
        "code": "Mã:",
        "slug": "Slug:",
        "status": "Trạng thái:"
      },
      "actions": {
        "viewHistory": "Xem lịch sử",
        "edit": "Sửa",
        "cancel": "Huỷ",
        "delete": "Xoá",
        "deleting": "Đang xoá…",
        "deleteTitle": "Xoá mềm blueprint này (chỉ khi Inactive)",
        "putOnSale": "Mở bán",
        "takeOffSale": "Ngừng bán",
        "saving": "Đang lưu…",
        "saveAsDraft": "Lưu nháp",
        "saveChange": "Lưu thay đổi",
        "goBack": "‹ Quay lại",
        "continue": "Tiếp tục ›"
      },
      "confirm": {
        "deleteBlueprint": "Xoá blueprint \"{{name}}\"? Đây là xoá mềm và có thể khôi phục từ lịch sử audit.",
        "removeVendorMapping": "Gỡ mapping vendor này?"
      },
      "toast": {
        "httpStatus": "HTTP {{status}}",
        "invalidPriceTitle": "Giá không hợp lệ",
        "invalidPriceDesc": "Nhập số ≥ 0 (vd 19.99)",
        "csvEmptyTitle": "Excel trống",
        "csvEmptyDesc": "Không có dòng dữ liệu.",
        "csvInvalidTitle": "Excel sai định dạng",
        "csvMissingSku": "Thiếu cột SKU.",
        "importDoneTitle": "Import: {{count}} SKU cập nhật",
        "importPriceChanged": "Giá đã thay đổi — bấm Lưu thay đổi để lưu (ghi tự động).",
        "importTemplatesChanged": "Templates cập nhật vào grid — bấm Lưu thay đổi để lưu.",
        "importShippingChanged": "Phí vận chuyển đã cập nhật vào grid — bấm Lưu thay đổi để lưu.",
        "importStatusChanged": "Đã cập nhật trạng thái.",
        "logisticExportDone": "Đã xuất {{count}} dòng logistic",
        "logisticExportFailed": "Xuất logistic thất bại",
        "logisticImportFormat": "Không nhận diện được file — hãy Export sheet logistic trước, điền rồi import lại.",
        "logisticImportWrongLocation": "File này của {{sheet}}, nhưng tab đang mở là {{active}}. Hãy đổi tab rồi import lại.",
        "logisticImportNoMatch": "Không có SKU nào khớp — hãy Export để lấy mẫu, điền rồi import lại.",
        "logisticImportDone": "Đã cập nhật {{updated}}, bỏ qua {{skipped}} dòng logistic — nhấn Save để áp dụng",
        "logisticImportFailed": "Import logistic thất bại — kiểm tra file có đúng định dạng đã export không",
        "importShippingInvalid": "Bỏ qua phí vận chuyển ở: {{columns}} — phải là số từ 0 đến 10000.",
        "pricingChangeFailed": "Đổi giá thất bại",
        "pricingUpdatedTitle": "Đã cập nhật giá",
        "pricingUpdatedDesc": "Đã ghi mục audit log.",
        "cannotDeleteTitle": "Không thể xoá",
        "cannotDeleteDesc": "Blueprint phải ở trạng thái Inactive trước khi xoá.",
        "deleteFailed": "Xoá thất bại",
        "blueprintDeleted": "Đã xoá blueprint",
        "cannotSaveTitle": "Không thể lưu",
        "cannotSaveImages": "Cần tối thiểu 5 ảnh mockup.",
        "saveFailed": "Lưu thất bại",
        "blueprintSaved": "Đã lưu blueprint",
        "loadVendorsFailed": "Tải vendor thất bại",
        "missingSelectionTitle": "Thiếu lựa chọn",
        "missingSelectionDesc": "Chọn cả vendor và biến thể trước khi thêm mapping.",
        "addVendorFailed": "Thêm vendor thất bại",
        "vendorMappingAdded": "Đã thêm mapping vendor",
        "removeFailed": "Gỡ thất bại",
        "vendorMappingRemoved": "Đã gỡ mapping vendor",
        "statusChangeFailed": "Đổi trạng thái thất bại",
        "statusNoTransition": "Trạng thái “{{status}}” không đổi trực tiếp ở đây được — sản phẩm Pending Approval đi qua hàng chờ duyệt.",
        "statusChanged": "Trạng thái → {{status}}",
        "savePublishFieldsFailed": "Lưu trường publish thất bại",
        "publishingFieldsSaved": "Đã lưu trường publish",
        "saveSeoFailed": "Lưu SEO thất bại",
        "seoSaved": "Đã lưu SEO",
        "linkAddonFailed": "Gán add-on thất bại",
        "addonLinkedTitle": "Đã gán add-on",
        "addonLinkedDesc": "{{name}} đã được gán vào sản phẩm.",
        "removeAddonFailed": "Gỡ add-on thất bại",
        "addonRemoved": "Đã gỡ add-on",
        "savePrintAreasFailed": "Lưu vùng in thất bại",
        "printAreasSaved": "Đã lưu vùng in",
        "reApprovalTitle": "Đã lưu — sản phẩm bị gỡ khỏi kệ",
        "reApprovalDesc": "Thay đổi này đưa sản phẩm về chờ duyệt, merchant không đặt được cho tới khi có người duyệt lại. Đã sửa: {{fields}}.",
        "reApprovalResubmitTitle": "Đã lưu — gửi duyệt lại",
        "reApprovalResubmitDesc": "Sản phẩm từng bị từ chối; thay đổi này đưa nó trở lại hàng đợi duyệt. Đã sửa: {{fields}}.",
        "step1IncompleteTitle": "Bước 1 chưa hoàn tất",
        "step1ImagesDesc": "Cần tối thiểu {{min}} ảnh mockup — hiện có {{current}}.",
        "tierOrderTitle": "Bậc giá sai thứ tự",
        "tierOrderDesc": "{{current}} không thấp hơn {{higherTier}} ({{higherValue}}). Bậc thấp hơn phải có giá rẻ hơn bậc trên nó.",
        "locationNeedsVendor": "Location \"{{locations}}\" chưa chọn vendor. Chọn vendor hoặc bỏ location đó trước khi lưu.",
        "vendorSplitInvalid": "Tổng % của các vendor theo % phải bằng 100%.",
        "vendorSplitUnbound": "Có địa điểm vẫn chia % cho vendor đã bỏ chọn — hãy nhập lại tỷ lệ.",
        "importSkuDataChanged": "Đã cập nhật Small / kích thước trong bảng — bấm Save Change để lưu."
      },
      "info": {
        "blueprintName": "Tên blueprint",
        "blueprintCode": "Mã blueprint",
        "locked": "(đã khoá)",
        "slug": "Slug",
        "category": "Danh mục",
        "selectCategory": "Chọn danh mục...",
        "collections": "Bộ sưu tập",
        "noCollections": "Chưa có bộ sưu tập.",
        "productionType": "Loại sản xuất",
        "derivedFromTechniques": "Loại sản xuất đã lưu: {{types}} — suy ra từ các technique ở trên.",
        "derivedReadOnly": "(suy ra, chỉ đọc)",
        "technology": "Công nghệ",
        "processingTime": "Thời gian xử lý",
        "to": "đến",
        "days": "ngày",
        "publishTime": "Thời gian publish",
        "tags": "Tags (phân cách bằng dấu phẩy)",
        "description": "Mô tả",
        "guideline": "Hướng dẫn",
        "videoUrl": "Video URL",
        "videoUrlPlaceholder": "https://youtube.com/watch?v=..."
      },
      "seo": {
        "heading": "SEO",
        "title": "Tiêu đề",
        "metaDescription": "Meta description",
        "canonicalUrl": "Canonical URL",
        "canonicalUrlError": "canonicalUrl phải bắt đầu bằng http:// hoặc https://",
        "googleIndex": "Google index",
        "indexInherit": "(kế thừa)",
        "indexYes": "index (có)",
        "indexNo": "noindex (không)",
        "metaKeywords": "Meta keywords (phân cách bằng dấu phẩy, tối đa 20)",
        "canonicalUrlPlaceholder": "https://…"
      },
      "images": {
        "label": "Ảnh",
        "editHint": "Bấm Edit ở đầu trang để tải / sửa ảnh.",
        "dragDrop": "Kéo thả ảnh vào đây, hoặc",
        "uploadAria": "Tải ảnh mockup",
        "uploading": "Đang tải lên…",
        "uploadButton": "Tải ảnh lên",
        "acceptHint": "JPEG / PNG — tối đa 10 ảnh, cần ≥5 ảnh để publish.",
        "moreNeeded": "Cần thêm {{count}} ảnh nữa trước khi mở cổng publish.",
        "mockup": "Mockup",
        "reorderHint": "Ảnh #1 là ảnh thumbnail (hiển thị ở danh sách + storefront). Kéo thả để đổi thứ tự.",
        "mockupAlt": "Mockup {{index}}",
        "thumb": "Thumbnail",
        "remove": "Gỡ",
        "emptyTitle": "Chưa tải ảnh nào",
        "emptyHint": "Ảnh thumbnail sẽ hiển thị ở đây",
        "requiredError": "Cần tối thiểu {{min}} ảnh mockup mới sang bước tiếp — hiện có {{current}}.",
        "viewImage": "Xem ảnh mockup {{index}}",
        "viewerAria": "Xem trước ảnh mockup"
      },
      "attributes": {
        "bindingSummary": "{{locCount}} loc · {{vendorCount}} vendor",
        "notAssigned": "Chưa gán",
        "heading": "Thuộc tính",
        "addOnlyHint": "Thêm option hoặc giá trị để sinh thêm SKU. Giá trị đang được SKU hiện có dùng thì không xoá được.",
        "newSkuNote": "Sẽ tạo {{added}} SKU mới khi Save (tổng {{total}}). Nhớ nhập giá cho chúng ở block Pricing sau đó.",
        "lockedHint": "SKU / thuộc tính / ma trận biến thể bị khoá (không đổi sau khi tạo).",
        "options": "Options",
        "optionsSummary": "{{skuCount}} SKU · {{bindingCount}} option binding"
      },
      "locationVendor": {
        "heading": "Location & Vendor",
        "removeHint": "Bớt vendor: đơn đang chạy xử lý nốt, đơn mới chưa assign sẽ không chuyển qua vendor đã gỡ (flow pending_reassignment ở Order).",
        "noBindingEditable": "Chưa bind location. Bấm \"+ Add Location\".",
        "noBinding": "Chưa bind location nào.",
        "location": "Location",
        "defaultParen": "(mặc định)",
        "vendors": "Vendor",
        "noVendor": "Chưa gán vendor",
        "defaultStarTitle": "★ = vendor mặc định",
        "selectLocation": "— Chọn location —",
        "removeLocation": "Gỡ location",
        "radioDefault": "(radio = mặc định)",
        "selectVendor": "Chọn vendor…",
        "removeVendor": "Gỡ vendor",
        "addVendor": "+ Thêm vendor",
        "defaultLocation": "Location mặc định",
        "addLocation": "+ Thêm location",
        "shareWithoutVendor": "chưa chọn — vẫn đang giữ tỷ lệ"
      },
      "sku": {
        "listTitle": "Danh sách SKU",
        "listSubtitle": "{{count}} SKU · thuộc tính khoá, đổi giá cần nhập lý do",
        "bulkEditHint": "Sửa hàng loạt: tải Template → fill cột Templates (mã, nhiều cái cách nhau bằng |) + giá từng tier → Import → Lưu thay đổi.",
        "templateBtn": "Template",
        "templateBtnTitle": "Tải file Template Excel (SKU điền sẵn, fill template + giá rồi Import)",
        "exportBtn": "Export",
        "exportBtnTitle": "Tải Excel chứa dữ liệu hiện tại",
        "importBtn": "Import",
        "filterBy": "Lọc theo:",
        "noAttributeGroups": "Không có nhóm thuộc tính.",
        "selectedCount": "Đã chọn {{count}} SKU",
        "templateLabel": "Template:",
        "assignTemplates": "Gán templates",
        "vendorLabel": "Vendor:",
        "assignVendorLocation": "Gán vendor/location",
        "priceLabel": "Giá:",
        "bulkEditPrices": "Sửa giá hàng loạt",
        "deselect": "Bỏ chọn",
        "selectAll": "Chọn tất cả SKU",
        "colSkuCode": "Mã SKU",
        "colAttributes": "Thuộc tính",
        "colTemplates": "Templates",
        "colVendorLocation": "Vendor / Location",
        "selectRow": "Chọn SKU {{sku}}",
        "removeTemplateAria": "Gỡ template {{template}} khỏi {{sku}}",
        "editTemplatesAria": "Sửa templates cho SKU này",
        "splitTitle": "Đơn hàng chia theo % cấu hình",
        "editVendorAria": "Sửa vendor/location cho SKU này",
        "footerNote": "Thêm option hoặc giá trị sẽ tạo SKU mới khi Save; giá trị đang được dùng thì không xoá được. Tồn kho quản lý ở trang Stock riêng.",
        "allOptions": "Tất cả tùy chọn",
        "clearFilters": "Xóa bộ lọc",
        "filterNoMatch": "Không có SKU nào khớp bộ lọc này.",
        "exportExcel": "Xuất Excel",
        "importExcel": "Nhập Excel"
      },
      "priceLoc": {
        "label": "Giá theo location",
        "badgeTitle": "Tab base = giá áp mọi location (mặc định). Tab location khác = giá riêng cho location đó (đè base). Lưu ở Lưu thay đổi.",
        "badge": "base + override theo location · lưu ở Lưu thay đổi",
        "baseSuffix": "(base)",
        "bulk": "Hàng loạt:",
        "copyFrom": "Copy giá từ location…"
      },
      "logistics": {
        "colSku": "SKU",
        "colWeight": "Cân nặng (g)",
        "colDimensions": "D×R×C (cm)"
      },
      "preview": {
        "information": "Thông tin",
        "blueprintCode": "Mã blueprint",
        "nameEn": "Tên (EN)",
        "slug": "Slug",
        "category": "Danh mục",
        "collections": "Bộ sưu tập",
        "productionTypes": "Loại sản xuất",
        "processingTime": "Thời gian xử lý",
        "daysRange": "{{from}}–{{to}} ngày",
        "tags": "Tags",
        "images": "Ảnh",
        "status": "Trạng thái",
        "skusHeading": "SKU ({{count}})",
        "skusNote": "{{count}} biến thể. Đổi giá / logistics ở các step trước, rồi bấm Lưu thay đổi.",
        "imageWarning": "⚠ Số ảnh {{count}}/5 — cần ≥5 ảnh trước khi lưu.",
        "editHint": "Bấm \"Edit\" ở đầu trang để chỉnh sửa.",
        "noSkus": "Chưa có SKU nào."
      },
      "addons": {
        "heading": "Add-ons",
        "description": "Tính năng tuỳ chọn. Bật để gán add-on dùng chung vào sản phẩm (1 add-on có thể gán nhiều blueprint).",
        "enable": "Bật add-ons",
        "disabledHint": "Add-ons đang tắt. Bật toggle để chọn add-on cho sản phẩm.",
        "addLabel": "Thêm add-on",
        "noMore": "— Không còn add-on để gán —",
        "selectAddon": "— Chọn add-on —",
        "requiredSuffix": ", bắt buộc",
        "saving": "Đang lưu…",
        "add": "Thêm",
        "loading": "Đang tải add-on…",
        "empty": "Chưa gán add-on nào cho sản phẩm này.",
        "colName": "Tên",
        "colMode": "Chế độ",
        "colRequired": "Bắt buộc",
        "colStatus": "Trạng thái",
        "colActions": "Hành động",
        "yes": "Có",
        "no": "Không",
        "remove": "Gỡ",
        "footerNoteBefore": "Tạo add-on mới ở trang ",
        "footerNoteAfter": ". Tại đây chỉ gán add-on có sẵn."
      },
      "accessoryLinks": {
        "title": "Phụ kiện liên kết",
        "subtitle": "Liên kết sản phẩm phụ kiện bán kèm blueprint này. Khi mua kèm, phụ kiện chỉ tính phí ship phụ trội nếu bật công tắc; mua độc lập luôn tính đủ phí ship.",
        "addLabel": "Liên kết phụ kiện",
        "selectAccessory": "— Chọn phụ kiện —",
        "add": "Liên kết",
        "empty": "Chưa có phụ kiện nào liên kết với blueprint này.",
        "colName": "Phụ kiện",
        "colChoiceMode": "Kiểu chọn",
        "colRequired": "Bắt buộc",
        "colChargeFromN": "Tính từ lần",
        "colMinMax": "SL Min–Max",
        "colChargeShipping": "Ship khi mua kèm",
        "colActions": "Thao tác",
        "chargeShippingHint": "Tính phí ship phụ trội khi mua kèm",
        "choiceMulti": "Nhiều",
        "choiceSingle": "Một",
        "min": "Min",
        "max": "Max",
        "applyAll": "Áp dụng cho tất cả add-on",
        "applyAllHint": "Một bộ cấu hình chung áp cho mọi accessory liên kết lúc lưu. Tắt để cấu hình riêng từng cái.",
        "maxAddons": "Tối đa add-on / đơn",
        "unlimited": "Không giới hạn",
        "remove": "Gỡ"
      },
      "vendorModal": {
        "title": "Thêm mapping vendor",
        "description": "Chọn vendor + biến thể từ blueprint này để tạo mapping.",
        "vendor": "Vendor",
        "searchVendors": "Tìm vendor theo tên…",
        "variant": "Biến thể",
        "pickVariant": "— Chọn biến thể —",
        "adding": "Đang thêm…",
        "add": "Thêm"
      },
      "statusModal": {
        "aria": "Xác nhận đổi trạng thái",
        "title": "Xác nhận đổi trạng thái",
        "description": "Đổi trạng thái blueprint từ {{from}} sang {{to}}?",
        "confirm": "Xác nhận"
      },
      "templatePicker": {
        "inactiveBadge": "Ngừng dùng"
      },
      "vendorPicker": {
        "aria": "Gán vendor/location cho SKU",
        "skuFallback": "SKU",
        "titleScoped": "Vendor — {{label}} · {{sku}}",
        "titleBulk": "Vendor / Location — {{count}} SKU",
        "titleSingle": "Vendor / Location — {{sku}}",
        "descScoped": "Chọn vendor + % cho location này (location = tab đang chọn). Tổng % = 100 để chia đơn; bỏ trống = routing lấy vendor điểm cao nhất. Lưu ở nút Lưu thay đổi.",
        "descGeneral": "Gán location + vendor cho SKU. Cột % đơn hàng chia theo từng location: tổng mỗi location = 100 để chia đơn theo tỉ lệ; bỏ trống = routing lấy vendor điểm cao nhất. Lưu ở nút Lưu thay đổi.",
        "emptyLocations": "Chưa có location. Bấm + Thêm location để bắt đầu.",
        "default": "Mặc định",
        "vendor": "Vendor",
        "orderPct": "% đơn hàng",
        "noVendorHint": "Chưa có vendor. Bấm \"+ Thêm vendor\".",
        "selectLocationFirst": "Chọn location trước",
        "sumNoSplitTitle": "Không chia — routing lấy vendor điểm cao nhất",
        "sumValidTitle": "Hợp lệ — chia theo %",
        "sumInvalidTitle": "Tổng % của location này phải = 100 (hoặc bỏ trống hết)",
        "needHundredSuffix": " — cần = 100",
        "warnTitle": "Mỗi location phải có tổng % = 100, hoặc bỏ trống hết (không chia). Không thể Apply khi còn location dở.",
        "warnText": "{{count}} location chưa đủ 100% — không thể lưu",
        "okTitle": "Mọi location có % hợp lệ (=100)",
        "okText": "% hợp lệ — chia theo location",
        "apply": "Áp dụng",
        "applyBulk": "Áp dụng ({{count}})",
        "applyInvalidTitle": "Có location % chưa hợp lệ (≠100 và ≠0) — chỉnh về 100 hoặc xoá hết %"
      },
      "bulkPrice": {
        "aria": "Sửa giá hàng loạt",
        "title": "Sửa giá hàng loạt — {{count}} SKU",
        "description": "Nhập giá (USD) cho tier muốn đổi. Mỗi lần áp 1 tier — bấm Apply sẽ hỏi lý do.",
        "pricePlaceholder": "USD (vd 19.99)",
        "apply": "Áp dụng",
        "tierOrderHint": "Phải thấp hơn bậc phía trên."
      },
      "logistic": {
        "exportHint": "Tải logistics (.xlsx): SKU, khối lượng, kích thước kèm đơn vị và phí vận chuyển theo từng dịch vụ ($).",
        "importHint": "Nhập .xlsx/.csv để cập nhật hàng loạt khối lượng, kích thước (kèm đơn vị) và phí vận chuyển, khớp theo SKU."
      }
    },
    "list": {
      "heading": "Blueprints",
      "subtitle": "Quản lý cấu hình blueprint và luồng xuất bản.",
      "loading": "Đang tải blueprints…",
      "empty": "Không tìm thấy blueprint nào",
      "rowActionsAria": "Thao tác dòng",
      "vendorCountOne": "{{count}} nhà cung cấp",
      "vendorCountOther": "{{count}} nhà cung cấp",
      "vendorModalAria": "Nhà cung cấp của blueprint",
      "vendorModalTitle": "Nhà cung cấp — {{name}}",
      "vendorModalDescOne": "{{count}} nhà cung cấp cung ứng blueprint này.",
      "vendorModalDescOther": "{{count}} nhà cung cấp cung ứng blueprint này.",
      "vendorModalNote": "Danh sách nhà cung cấp chi tiết sẽ có ở trang chi tiết blueprint. Bảng tóm tắt này chỉ hiển thị tổng số nhà cung cấp.",
      "statusToggleAria": "Bật/tắt trạng thái của {{name}}",
      "statusToggleOk": "Đã cập nhật trạng thái",
      "statusToggleFailed": "Không đổi được trạng thái",
      "activateTitle": "Mở bán sản phẩm này?",
      "deactivateTitle": "Ngừng bán sản phẩm này?",
      "activateDesc": "“{{name}}” sẽ chuyển sang Active và hiện trong catalog của mọi merchant. Muốn mở bán thì mọi SKU phải có khối lượng và kích thước.",
      "deactivateDesc": "“{{name}}” sẽ chuyển sang Inactive và mất khỏi catalog của mọi merchant ngay lập tức. Đơn đã đặt không bị ảnh hưởng.",
      "activateConfirm": "Mở bán",
      "deactivateConfirm": "Ngừng bán",
      "cancel": "Huỷ",
      "onSale": "Đang bán",
      "offSale": "Ngừng bán",
      "awaitingApproval": "Chờ duyệt →",
      "close": "Đóng",
      "exportStarted": "Đã bắt đầu xuất",
      "exportStartedDesc": "Quá trình tải xuống sẽ bắt đầu ngay.",
      "stats": {
        "totalBlueprints": "Tổng Blueprint",
        "published": "Đã xuất bản",
        "draft": "Nháp",
        "totalSkus": "Tổng SKU",
        "categories": "Danh mục",
        "printAreas": "Vùng in"
      },
      "searchPlaceholder": "Tìm blueprint...",
      "searchAria": "Tìm blueprint",
      "filterPublishStatusAll": "Trạng thái xuất bản",
      "filterPublishStatusAria": "Lọc theo trạng thái xuất bản",
      "filterCreatorAll": "Người tạo",
      "filterCreatorAria": "Lọc theo người tạo",
      "filterStatusAll": "Trạng thái",
      "filterStatusAria": "Lọc theo trạng thái",
      "filterClearHint": "Bấm lại để bỏ lọc này",
      "statusActive": "Đang bật",
      "statusInactive": "Đang tắt",
      "statusDraft": "Bản nháp",
      "statusPendingApproval": "Chờ phê duyệt",
      "colBlueprint": "Blueprint",
      "colProcessingTime": "Thời gian xử lý",
      "colPublishStatus": "Trạng thái xuất bản",
      "colPublishTime": "Thời điểm xuất bản",
      "colStatus": "Trạng thái",
      "colCreator": "Người tạo",
      "colCreatedDate": "Ngày tạo",
      "colLastUpdate": "Cập nhật lần cuối",
      "colUpdatedBy": "Người cập nhật",
      "colAction": "Hành động",
      "selectAllAria": "Chọn toàn bộ blueprint trên trang này",
      "selectRowAria": "Chọn {{name}}",
      "editAria": "Sửa {{name}}",
      "configureSeoAria": "Cấu hình SEO cho {{name}}",
      "actionEdit": "Sửa",
      "actionConfigureSeo": "Cấu hình SEO",
      "bulkSelectedOne": "Đã chọn {{count}} SKU",
      "bulkSelectedOther": "Đã chọn {{count}} SKU",
      "bulkClearAria": "Bỏ chọn tất cả",
      "rowsPerPage": "Số dòng mỗi trang:",
      "showingRange": "Hiển thị {{from}}–{{to}} trong {{total}} blueprint",
      "prevPage": "Trang trước",
      "nextPage": "Trang sau",
      "paginationAria": "Phân trang blueprint",
      "loadError": "Không tải được danh sách blueprint.",
      "retry": "Thử lại",
      "working": "Đang xử lý…",
      "statusUpdated": "Đã cập nhật trạng thái",
      "statusUpdatedDesc": "{{name}} giờ là {{status}}.",
      "statusUpdateFailed": "Không cập nhật được trạng thái",
      "duplicated": "Đã nhân bản blueprint",
      "duplicatedDesc": "Đã tạo {{code}} dưới dạng bản nháp.",
      "duplicatedManyDesc": "Đã tạo {{count}} bản nháp.",
      "duplicateFailed": "Không nhân bản được",
      "publishStatus": {
        "Published": "Đã xuất bản",
        "Draft": "Bản nháp",
        "Unpublished": "Đã ẩn",
        "Pending": "Đang chờ"
      },
      "seoModal": {
        "heading": "Thiết lập SEO",
        "subtitle": "Tối ưu cách “{{name}}” hiển thị trên công cụ tìm kiếm.",
        "loading": "Đang tải thiết lập SEO…",
        "loadFailed": "Không tải được thiết lập SEO của blueprint này.",
        "titleLabel": "Tiêu đề SEO",
        "titlePlaceholder": "Nhập tiêu đề SEO",
        "titleHelper": "Để trống thì hệ thống có thể tự dùng Alias.",
        "canonicalLabel": "URL canonical",
        "canonicalPlaceholder": "https://example.com/blueprint/...",
        "canonicalHelper": "URL ưu tiên cho công cụ tìm kiếm, tránh trùng lặp nội dung.",
        "googleIndexLabel": "Google Index",
        "keywordsLabel": "Từ khóa meta",
        "keywordsPlaceholder": "Nhập từ khóa rồi nhấn Enter",
        "keywordRemove": "Xóa từ khóa {{keyword}}",
        "descriptionLabel": "Mô tả meta",
        "descriptionPlaceholder": "Nhập mô tả ngắn cho công cụ tìm kiếm...",
        "descriptionHelper": "Độ dài khuyến nghị: 150–160 ký tự.",
        "descriptionCounter": "{{count}} / {{max}} ký tự",
        "cancel": "Hủy",
        "save": "Lưu",
        "saved": "Đã lưu thiết lập SEO",
        "saveFailed": "Không lưu được thiết lập SEO",
        "reApprovalHint": "Blueprint này đang Active. Lưu thay đổi SEO sẽ đưa nó về hàng chờ duyệt, merchant không đặt được cho đến khi có người duyệt lại.",
        "reApprovalTitle": "Đã lưu — sản phẩm bị ngừng bán",
        "reApprovalDesc": "Thay đổi này đưa sản phẩm về hàng chờ duyệt, merchant không đặt được cho đến khi được duyệt. Đã sửa: {{fields}}.",
        "reApprovalResubmitTitle": "Đã lưu — gửi duyệt lại",
        "reApprovalResubmitDesc": "Sản phẩm trước đó bị từ chối; thay đổi này đưa nó trở lại hàng chờ duyệt. Đã sửa: {{fields}}.",
        "errors": {
          "titleTooLong": "Tiêu đề SEO tối đa {{max}} ký tự.",
          "canonicalInvalid": "URL canonical phải bắt đầu bằng http:// hoặc https://.",
          "metaDescriptionTooLong": "Mô tả meta tối đa {{max}} ký tự."
        }
      }
    },
    "blankMethods": {
      "heading": "Phương pháp Blank",
      "banner": "Sản phẩm blank — không tính phí in, khắc hay thêu. Một bản ghi \"Blank Product\" mặc định sẽ được tạo tự động.",
      "toast": {
        "created": "Đã tạo phương pháp blank",
        "createFailed": "Tạo thất bại",
        "createFailedTitle": "Tạo phương pháp blank thất bại",
        "deleted": "Đã xóa phương pháp blank"
      },
      "codeAria": "Mã (slug)",
      "codePlaceholder": "mã (ví dụ: blank-product)",
      "nameEnglish": "Tên hiển thị (tiếng Anh)",
      "addBtn": "Thêm phương pháp blank",
      "colCode": "Mã",
      "empty": "Chưa có phương pháp blank nào — thêm một mục ở trên.",
      "toggleTitleOn": "Đang bật — nhấn để tắt",
      "toggleTitleOff": "Đang tắt — nhấn để bật",
      "toggleAria": "Bật/tắt cho {{code}}",
      "confirmDelete": "Xóa phương pháp blank \"{{code}}\"?"
    },
    "listFilters": {
      "search": {
        "placeholder": "Tìm blueprint, SKU hoặc danh mục…",
        "aria": "Tìm blueprint"
      },
      "status": {
        "aria": "Lọc theo trạng thái",
        "all": "Tất cả trạng thái",
        "pendingApproval": "Chờ duyệt"
      },
      "source": {
        "aria": "Lọc theo nguồn",
        "all": "Tất cả nguồn",
        "admin": "Admin"
      },
      "clear": "Xóa lọc"
    },
    "imagesSection": {
      "headerCountOne": "{{count}} ảnh · cần tối thiểu 5",
      "headerCountOther": "{{count}} ảnh · cần tối thiểu 5",
      "tooFew": "Cần ít nhất 5 ảnh mockup trước khi có thể lưu blueprint này.",
      "bulkMax": "Đã đạt tối đa 10 ảnh.",
      "bulkFailed": "{{count}} ảnh lỗi",
      "bulkSkipped": "{{count}} ảnh bị bỏ qua (tối đa 10)",
      "dragTitle": "Kéo để đổi vị trí ảnh",
      "moveEarlier": "Chuyển ảnh {{index}} lên trước",
      "moveLater": "Chuyển ảnh {{index}} ra sau",
      "removeImage": "Xóa ảnh {{index}}",
      "max10": "Tối đa 10 ảnh",
      "uploadOne": "+ Tải ảnh lên",
      "uploadMultiple": "+ Tải nhiều ảnh",
      "pickerTitle": "Tải ảnh mockup lên"
    },
    "personalize": {
      "heading": "3. Cá nhân hóa",
      "toggleOn": "Cá nhân hóa: BẬT",
      "toggleOff": "Cá nhân hóa: TẮT",
      "intro": "Chọn vùng nào trong 19 vùng cá nhân hóa cố định được dùng cho blueprint này.",
      "zonesAria": "Các vùng cá nhân hóa",
      "zonesEnabled": "Đã bật {{active}}/{{total}} vùng",
      "disabled": "Đã tắt cá nhân hóa — ẩn lưới vùng.",
      "zones": {
        "front-center": "Giữa mặt trước",
        "front-left-chest": "Ngực trái (trước)",
        "front-right-chest": "Ngực phải (trước)",
        "front-bottom": "Dưới mặt trước",
        "back-center": "Giữa mặt sau",
        "back-upper": "Trên mặt sau",
        "back-bottom": "Dưới mặt sau",
        "left-sleeve": "Tay áo trái",
        "right-sleeve": "Tay áo phải",
        "collar": "Cổ áo",
        "hood-front": "Mũ trùm (trước)",
        "hood-back": "Mũ trùm (sau)",
        "pocket-front": "Túi (trước)",
        "pocket-back": "Túi (sau)",
        "cuff-left": "Cổ tay trái",
        "cuff-right": "Cổ tay phải",
        "hem": "Gấu áo",
        "side-left": "Sườn trái",
        "side-right": "Sườn phải"
      }
    },
    "pricingSection": {
      "heading": "4. Giá",
      "headerSummary": "{{variants}} biến thể · {{tiers}} bậc giá · đã chọn {{selected}}",
      "bulkApplyNone": "Áp giá hàng loạt cho 0 biến thể đã chọn:",
      "bulkApplyOne": "Áp giá hàng loạt cho {{count}} biến thể đã chọn:",
      "bulkApplyOther": "Áp giá hàng loạt cho {{count}} biến thể đã chọn:",
      "tierLabel": "Bậc giá",
      "priceUsd": "Giá (USD)",
      "applyTierPrice": "Áp giá theo bậc…",
      "auditReason": "Bắt buộc nhập lý do (ghi audit)",
      "invalidPrice": "Nhập giá USD không âm (ví dụ 19.99)",
      "colVariant": "Biến thể (SKU)",
      "selectAllAria": "Chọn tất cả biến thể",
      "selectRowAria": "Chọn biến thể {{sku}}",
      "empty": "Chưa có biến thể — hãy thêm từ mục Biến thể trước."
    },
    "importDialog": {
      "title": "Nhập blueprint",
      "description": "Tải lên file XLSX nhiều sheet. Hệ thống sẽ phân tích, hiển thị các mục trùng, rồi ghi nhận bản ghi.",
      "steps": {
        "upload": "1. Tải lên",
        "preview": "2. Xem trước",
        "confirm": "3. Xác nhận"
      },
      "upload": {
        "intro": "Tải lên file XLSX theo mẫu nhiều sheet chuẩn (Metadata + Pricing). Hệ thống sẽ phân tích và hiển thị cảnh báo trùng lặp trước khi ghi nhận.",
        "downloadTemplate": "Tải file mẫu",
        "selected": "Đã chọn:",
        "fileKb": "{{size}} KB"
      },
      "preview": {
        "noData": "Không có dữ liệu xem trước.",
        "sheets": "Các sheet",
        "noSheets": "(không phát hiện sheet nào)",
        "rows": "{{count}} dòng",
        "duplicateDetection": "Phát hiện trùng lặp",
        "noDuplicates": "Không phát hiện blueprint tương tự.",
        "rowLabel": "Dòng {{row}} —",
        "score": "(điểm {{score}})"
      },
      "confirm": {
        "body": "Xác nhận nhập file hiển thị bên dưới. Nhấn \"Xác nhận\" để tiếp tục."
      },
      "done": "Đã chấp nhận xem trước. Endpoint ghi nhận thực tế sẽ có ở đợt cập nhật sau; có thể đóng hộp thoại này.",
      "footer": {
        "uploadPreview": "Tải lên & xem trước",
        "confirming": "Đang xác nhận…",
        "confirm": "Xác nhận"
      },
      "toast": {
        "noFileTitle": "Chưa chọn file",
        "noFileDesc": "Vui lòng chọn file XLSX trước khi tiếp tục.",
        "previewFailed": "Xem trước khi nhập thất bại",
        "unexpected": "Máy chủ trả về phản hồi không hợp lệ.",
        "previewedTitle": "Đã xem trước bản nhập",
        "previewedDesc": "Đã chấp nhận xem trước. Trình ghi nhận sẽ có ở đợt cập nhật sau."
      }
    },
    "routing": {
      "modeMerchant": "Merchant",
      "modePercent": "%",
      "modeGroupAria": "Cách chia đơn cho {{vendor}}",
      "defaultVendorAria": "Vendor mặc định {{vendor}}",
      "merchantPlaceholder": "Chọn merchant",
      "merchantSearch": "Tìm merchant",
      "merchantSearching": "Đang tìm merchant…",
      "merchantEmpty": "Không tìm thấy merchant",
      "errorMerchantEmpty": "Chọn ít nhất một merchant",
      "errorMerchantDup": "{{merchant}} đã được gán cho vendor khác ở location này",
      "merchantLoadError": "Không tải được danh sách merchant (thiếu quyền user:read)",
      "toastMerchantInvalid": "Có vendor ở chế độ Merchant chưa chọn merchant hoặc trùng merchant với vendor khác."
    },
    "accessoryParents": {
      "title": "Blueprint đang dùng phụ kiện này",
      "searchPlaceholder": "Tìm theo tên hoặc mã",
      "colImage": "Ảnh",
      "colName": "Tên",
      "colCode": "Mã",
      "colCategory": "Danh mục",
      "colStatus": "Trạng thái",
      "empty": "Chưa có blueprint nào liên kết phụ kiện này",
      "loadFailed": "Không tải được danh sách blueprint liên kết",
      "openInNewTab": "Mở {{name}} trong tab mới",
      "close": "Đóng",
      "rowsPerPage": "Số dòng mỗi trang",
      "range": "Hiển thị {{from}}–{{to}} trên {{total}}",
      "prevPage": "Trang trước",
      "nextPage": "Trang sau",
      "paginationAria": "Phân trang blueprint liên kết"
    },
    "accessoryOff": {
      "title": "Tắt Phụ kiện?",
      "body1": "Tắt Phụ kiện sẽ chuyển Blueprint này thành Blueprint thường và gỡ nó khỏi danh sách phụ kiện của các Blueprint này.",
      "body2": "Bạn có chắc muốn tiếp tục?",
      "viewProducts": "Xem sản phẩm",
      "cancel": "Huỷ",
      "save": "Lưu",
      "close": "Đóng"
    },
    "retail": {
      "label": "Bán lẻ",
      "hint": "Hiển thị phụ kiện này trên Homepage và bán riêng",
      "disabledHint": "Bật Phụ kiện để dùng Bán lẻ"
    }
  },
  "product_approval": {
    "title": "Duyệt sản phẩm",
    "subtitle": "Sản phẩm vendor chờ duyệt",
    "columns": {
      "product": "Sản phẩm",
      "vendor": "Vendor",
      "submittedAt": "Ngày gửi",
      "category": "Danh mục",
      "status": "Trạng thái",
      "type": "Loại",
      "actions": "Thao tác"
    },
    "status": {
      "pending": "Chờ duyệt",
      "approved": "Đã duyệt",
      "rejected": "Đã từ chối",
      "changesRequested": "Yêu cầu chỉnh sửa"
    },
    "actions": {
      "approve": "Duyệt",
      "reject": "Từ chối",
      "requestChanges": "Yêu cầu chỉnh sửa",
      "viewDiff": "Xem khác biệt",
      "uploadExcel": "Upload Excel",
      "diff": "Diff",
      "details": "Chi tiết",
      "cancel": "Huỷ"
    },
    "fields": {
      "rejectionReason": "Lý do từ chối",
      "changeNotes": "Ghi chú yêu cầu chỉnh sửa"
    },
    "pageSubtitle": "Duyệt sản phẩm mới và thay đổi từ vendor. Re-approval áp dụng cho 5 trường: {{fields}}.",
    "types": {
      "newSubmission": "Gửi mới",
      "reApproval": "Duyệt lại",
      "adminSelfCreate": "Admin tự tạo"
    },
    "filters": {
      "typeLabel": "Loại",
      "statusLabel": "Trạng thái",
      "sourceLabel": "Nguồn",
      "allTypes": "Tất cả loại",
      "allStatuses": "Tất cả trạng thái"
    },
    "source": {
      "all": "Tất cả nguồn",
      "vendorSelfSubmit": "Vendor tự gửi",
      "adminExcelUpload": "Admin upload Excel"
    },
    "sourcePill": {
      "vendorSubmit": "Vendor gửi",
      "adminUpload": "Admin upload"
    },
    "summary": {
      "pendingLabel": "chờ duyệt",
      "totalLabel": "tổng"
    },
    "bulk": {
      "selected": "Đã chọn {{count}}",
      "approve": "Duyệt ({{count}})",
      "approving": "Đang duyệt…",
      "reject": "Từ chối ({{count}})",
      "clear": "Bỏ chọn"
    },
    "table": {
      "selectAllAria": "Chọn tất cả pending",
      "selectRowAria": "Chọn {{name}}",
      "loading": "Đang tải…",
      "empty": "Không có sản phẩm nào trong queue."
    },
    "links": {
      "viewVendorProduct": "Xem VendorProduct",
      "openBlueprint": "Mở blueprint detail"
    },
    "applyTargets": "Sẽ apply cho {{count}} vendor khi duyệt",
    "duplicate": {
      "title": "Phát hiện {{count}} blueprint tương tự",
      "similarity": "(tương tự {{pct}}%)"
    },
    "reject": {
      "title": "Từ chối — {{name}}",
      "bulkTitle": "Từ chối {{count}} sản phẩm",
      "hint": "Lý do từ chối (10-500 ký tự). Sẽ ghi nhật ký kiểm toán và gửi cho vendor.",
      "placeholder": "VD: Giá baseCost không khớp thị trường, vui lòng kiểm tra lại và bổ sung shipping zone EU…",
      "counter": "{{count}} / 500 (tối thiểu 10)",
      "submitting": "Đang gửi…",
      "confirm": "Xác nhận từ chối",
      "errorLength": "Lý do phải dài 10-500 ký tự"
    },
    "override": {
      "title": "4-eyes override — {{name}}",
      "bodyBefore": "Bạn đang duyệt blueprint do chính bạn tạo. Vai trò ",
      "bodyAfter": " cho phép bỏ qua quy tắc 4-eyes, nhưng cần ghi rõ lý do để lưu vào nhật ký kiểm toán.",
      "reasonLabel": "Lý do override",
      "placeholder": "Ví dụ: chỉ có 1 superadmin trực hôm nay, đã review chéo với QA…",
      "hint": "1-2000 ký tự. Lý do sẽ được ghi vào nhật ký kiểm toán (audit log).",
      "submitting": "Đang gửi…",
      "confirm": "Xác nhận override",
      "errorLength": "Override reason phải dài 1-2000 ký tự"
    },
    "diff": {
      "loading": "Đang tải diff…"
    },
    "errors": {
      "generic": "Có lỗi xảy ra",
      "fourEyesRequired": "Bạn không thể tự duyệt blueprint mình tạo. Cần admin khác duyệt.",
      "overrideReasonRequired": "Superadmin tự duyệt cần cung cấp lý do ghi đè (override reason).",
      "notReadyForPublish": "Blueprint chưa đủ điều kiện xuất bản — bổ sung mockup và print area còn thiếu ở trang chi tiết trước khi duyệt.",
      "blueprintNotFound": "Blueprint mà yêu cầu duyệt này tham chiếu không còn tồn tại.",
      "approvalNotFound": "Không tìm thấy yêu cầu duyệt này.",
      "alreadyResolved": "Yêu cầu này đã được xử lý.",
      "categoryNotFound": "Chưa có danh mục nào để gắn blueprint mới. Cần tạo ít nhất một danh mục trước khi duyệt.",
      "costGuard": "Giá vốn của vendor không thấp hơn giá merchant thấp nhất ở một số SKU — xem danh sách SKU rồi từ chối kèm lý do.",
      "alreadyListed": "Vendor này đã liên kết với một SKU Printway trong số này qua sản phẩm khác.",
      "blueprintUnavailable": "Sản phẩm Printway không ở trạng thái Active (hoặc có SKU không còn thuộc sản phẩm đó).",
      "pricingMissing": "Có SKU Printway chưa có giá merchant — hãy đặt giá cho blueprint trước.",
      "variantSpecOutOfRange": "Có variant có thời gian xử lý (1–60 ngày), công suất (≥ 1/ngày), cân nặng hoặc kích thước (> 0) ngoài khoảng cho phép — hãy yêu cầu vendor sửa.",
      "withSkus": "{{reason}} — {{skus}}",
      "forProduct": "{{product}}: {{reason}}",
      "conflictRetry": "Có thay đổi khác chạm vào yêu cầu này cùng lúc. Chưa có gì được lưu — vui lòng thử lại."
    },
    "toast": {
      "loadFailTitle": "Không tải được danh sách",
      "unknownError": "Lỗi không xác định",
      "approveFailed": "Duyệt thất bại",
      "approved": "Đã duyệt sản phẩm",
      "rejected": "Đã từ chối sản phẩm",
      "approvedCount": "Đã duyệt {{ok}}/{{total}}",
      "rejectedCount": "Đã từ chối {{ok}}/{{total}}",
      "failCount": "{{fail}} lỗi."
    },
    "diffModal": {
      "title": "Khác biệt cần duyệt lại",
      "empty": "Vendor không sửa trường nào yêu cầu duyệt lại (chỉ thay đổi description / images / tags). Re-approval không cần thiết.",
      "col": {
        "field": "Trường",
        "previous": "Trước",
        "new": "Mới"
      },
      "fields": {
        "processingTime": "Thời gian xử lý",
        "baseCost": "Giá gốc",
        "capacityPerDay": "Năng lực / ngày",
        "shippingZones": "Vùng vận chuyển",
        "productionSpecs": "Thông số sản xuất",
        "cost_price_cents": "Giá gốc",
        "variant_dimensions": "Kích thước",
        "variant_processing_time_days": "Thời gian xử lý (ngày)",
        "variant_capacity_per_day": "Năng lực / ngày",
        "variant_weight_grams": "Khối lượng (g)",
        "variant_cost_cents": "Giá vốn (theo SKU)",
        "variant_cost_markup_cents": "Phần cộng thêm (markup)"
      },
      "actions": {
        "close": "Đóng"
      }
    },
    "uploadDialog": {
      "title": {
        "upload": "Upload Excel sản phẩm vendor",
        "preview": "Preview — sản phẩm chờ duyệt"
      },
      "fileLabel": "File CSV/Excel",
      "selectVendorPlaceholder": "— Chọn vendor —",
      "vendorLoadFail": "Không tải được danh sách vendor. Mở lại dialog sau khi quay trở lại trang Vendors để cache đầy.",
      "parsedRows": "Đã parse {{count}} hàng — kiểm tra preview sau khi upload.",
      "applyLabel": "Apply blueprint cho các vendor (tuỳ chọn)",
      "applyHelp": "Khi admin duyệt, hệ thống sẽ seed 1 VendorProduct (state=\"live\") cho mỗi vendor đã chọn. Bỏ trống = blueprint chỉ vào catalog chung.",
      "applyVendorEmpty": "Vendor directory chưa có dữ liệu — apply-to picker không khả dụng.",
      "applyCountNote": "Sẽ apply cho {{count}} vendor khi admin approve.",
      "previewSummary": "{{products}} sản phẩm, {{variants}} variant. Upload ID:",
      "validationErrorsTitle": "Lỗi kiểm tra dữ liệu ({{count}})",
      "errorRow": "Hàng {{row}}",
      "col": {
        "diffWarning": "Diff / cảnh báo"
      },
      "badgeNew": "Mới",
      "fieldsChanged": "{{count}} trường thay đổi",
      "similarBlueprints": "{{count}} blueprint tương tự",
      "uploading": "Đang upload…",
      "uploadPreview": "Upload + preview",
      "actions": {
        "close": "Đóng"
      },
      "parse": {
        "noRows": "Không tìm thấy hàng dữ liệu nào — kiểm tra header.",
        "readFail": "Không đọc được file: {{message}}",
        "readFailGeneric": "Không đọc được file Excel/CSV"
      },
      "toast": {
        "uploadFailedTitle": "Upload thất bại",
        "uploadedTitle": "Đã upload và parse",
        "uploadedDesc": "{{products}} sản phẩm / {{variants}} variant đang chờ duyệt."
      }
    },
    "mapping": {
      "linksTo": "Duyệt sẽ liên kết vendor này với sản phẩm Printway",
      "col": {
        "sku": "SKU Printway",
        "vendorLabel": "Size / màu của vendor",
        "printwayLabel": "Size / màu Printway",
        "cost": "Giá vốn vendor",
        "lowestTier": "Giá merchant thấp nhất",
        "margin": "Biên lợi nhuận"
      },
      "disabled": "tắt",
      "labelMismatch": "nhãn khác Printway",
      "noPrice": "Chưa có giá",
      "violationHint": "Dòng tô đỏ: giá vốn vendor không thấp hơn giá merchant thấp nhất — duyệt sẽ bị từ chối."
    },
    "confirmApprove": {
      "title": "Duyệt yêu cầu này?",
      "bulkTitle_one": "Duyệt {{count}} yêu cầu?",
      "bulkTitle_other": "Duyệt {{count}} yêu cầu?",
      "body_one": "Duyệt sẽ liên kết vendor với sản phẩm Printway cho {{count}} SKU.",
      "body_other": "Duyệt sẽ liên kết vendor với sản phẩm Printway cho {{count}} SKU.",
      "bulkBody_one": "Duyệt {{count}} yêu cầu. Các sản phẩm đã map sẽ liên kết vendor với sản phẩm Printway.",
      "bulkBody_other": "Duyệt {{count}} yêu cầu. Các sản phẩm đã map sẽ liên kết vendor với sản phẩm Printway.",
      "routing": "SKU đã liên kết sẽ vào luồng chia đơn: SKU nào chưa có allocation thì vendor này có thể nhận đơn ngay theo điểm.",
      "bodyGeneric": "Sản phẩm vendor đã map sẽ liên kết vendor với sản phẩm Printway khi được duyệt.",
      "bulkBodySkus_one": "Duyệt {{count}} yêu cầu — {{skus}} SKU sẽ vào pool chia đơn.",
      "bulkBodySkus_other": "Duyệt {{count}} yêu cầu — {{skus}} SKU sẽ vào pool chia đơn.",
      "loading": "Đang đếm số SKU sẽ liên kết…",
      "loadFailed": "Không tải được mapping SKU"
    },
    "unmappedBadge": "Chưa map"
  },
  "products_special": {
    "title": "Sản phẩm đặc biệt",
    "subtitle": "Gắn nhãn sản phẩm đặc biệt / nổi bật",
    "columns": {
      "product": "Sản phẩm",
      "tag": "Nhãn",
      "assignedAt": "Ngày gán",
      "expiresAt": "Hết hạn",
      "blueprintCode": "Mã blueprint",
      "name": "Tên",
      "variantAssignments": "Gán biến thể",
      "merchants": "Merchant",
      "createdDate": "Ngày tạo",
      "actions": "Thao tác",
      "productName": "TÊN SẢN PHẨM",
      "skuCount": "SỐ SKU",
      "assignedMerchants": "MERCHANT ĐƯỢC GÁN",
      "status": "TRẠNG THÁI",
      "action": "THAO TÁC"
    },
    "actions": {
      "assign": "Gán nhãn",
      "unassign": "Bỏ gán",
      "edit": "Sửa",
      "delete": "Xoá"
    },
    "fields": {
      "tag": "Nhãn đặc biệt",
      "expiresAt": "Hết hạn vào"
    },
    "list": {
      "heading": "Sản phẩm đặc biệt",
      "subtitle": "Quản lý các sản phẩm đặc biệt chỉ dành riêng cho một số merchant được chọn.",
      "create": "Tạo mới",
      "searchLabel": "Tìm kiếm",
      "searchPlaceholder": "Tìm theo tên sản phẩm hoặc SKU...",
      "merchantMin": "Merchant tối thiểu",
      "merchantMax": "Merchant tối đa",
      "createdAfter": "Tạo từ ngày",
      "createdBefore": "Đến ngày",
      "clearFilter": "Xoá bộ lọc",
      "totalCount": "{{count}} blueprint special",
      "selectedLabel": "blueprint special đang được chọn",
      "deselect": "Bỏ chọn",
      "deleting": "Đang xoá…",
      "deleteSelected": "Xoá {{count}} dòng",
      "loading": "Đang tải Products Special…",
      "loadError": "Không tải được danh sách: {{message}}",
      "empty": "Chưa có sản phẩm đặc biệt nào.",
      "selectAllAria": "Chọn tất cả dòng trang này",
      "selectRowAria": "Chọn {{code}}",
      "variantCount": "{{count}} biến thể",
      "allBlueprint": "Toàn bộ blueprint",
      "assignMerchantsOne": "{{count}} merchant →",
      "assignMerchantsOther": "{{count}} merchants →",
      "rowsLabel": "Dòng",
      "rowsPerPageAria": "Số dòng mỗi trang",
      "bulkDeleted": "Đã xoá hàng loạt",
      "bulkDeletedPartial": "{{deleted}} đã xoá, {{notFound}} không tìm thấy",
      "bulkDeletedAll": "Đã xoá {{count}} blueprint special",
      "deleteFailed": "Không xoá được",
      "networkError": "Lỗi mạng",
      "confirmBulkDelete": "Xoá {{count}} blueprint special đã chọn?",
      "deleted": "Đã gỡ sản phẩm đặc biệt",
      "confirmDelete": "Gỡ \"{{label}}\" khỏi sản phẩm đặc biệt? Blueprint sẽ trở lại catalog công khai.",
      "noVariantAssignment": "Chưa có gán biến thể",
      "searchAria": "Tìm sản phẩm đặc biệt",
      "filterStatusAll": "Trạng thái: Tất cả",
      "filterStatusAria": "Lọc theo trạng thái",
      "working": "Đang xử lý…",
      "retry": "Thử lại",
      "rowsPerPage": "Số dòng mỗi trang:",
      "showingRange": "Hiển thị {{from}}-{{to}} trong {{total}} sản phẩm đặc biệt",
      "paginationAria": "Phân trang sản phẩm đặc biệt",
      "prevPage": "Trang trước",
      "nextPage": "Trang sau",
      "skuCount": "{{count}} SKU",
      "noMerchants": "Chưa gán merchant",
      "moreMerchants": "+{{count}} nữa",
      "statusToggleAria": "Bật/tắt trạng thái cho {{name}}",
      "editAria": "Sửa merchant được gán cho {{name}}",
      "deleteAria": "Gỡ {{name}} khỏi sản phẩm đặc biệt",
      "statusActivated": "Đã bật sản phẩm đặc biệt",
      "statusDeactivated": "Đã tắt sản phẩm đặc biệt",
      "statusFailed": "Không đổi được trạng thái",
      "confirmDeleteTitle": "Gỡ khỏi sản phẩm đặc biệt?"
    },
    "detail": {
      "missingId": "Thiếu ID",
      "loading": "Đang tải…",
      "loadError": "Không tải được chi tiết: {{message}}",
      "noData": "không có dữ liệu",
      "emptyResponse": "Phản hồi rỗng",
      "unknownError": "Lỗi không xác định",
      "backToList": "← Quay lại danh sách",
      "blueprintMissing": "— thiếu blueprint —",
      "codeLabel": "Mã:",
      "assignmentIdLabel": "ID gán:",
      "merchantsAssigned": "{{count}} merchant được gán",
      "createdAt": "Tạo: {{date}}",
      "updatedAt": "Cập nhật: {{date}}",
      "blueprintCard": "Blueprint",
      "noTags": "Không có tag",
      "blueprintDeleted": "Blueprint đã xoá hoặc không tồn tại.",
      "blueprintLevelTitle": "Gán merchant cấp blueprint",
      "noBlueprintAssignments": "Chưa gán merchant nào ở cấp blueprint.",
      "variantLevelTitle": "Gán merchant cấp biến thể",
      "variantCol": "Biến thể",
      "statusCol": "Trạng thái",
      "auditLogTitle": "Nhật ký kiểm toán ({{count}})",
      "noAuditEntries": "Chưa có nhật ký kiểm toán.",
      "actorLabel": "Người thực hiện: {{actor}}",
      "viewGroupAria": "Chế độ xem gán biến thể",
      "viewByVariant": "Theo biến thể",
      "viewByMerchant": "Theo merchant",
      "noVariantMerchantAssignments": "Chưa có gán merchant ở cấp biến thể.",
      "variantsForMerchant": "{{count}} biến thể",
      "auditAction": {
        "create": "Đã thêm vào Products Special",
        "update_assignments": "Đã đổi merchant được gán",
        "remove_blueprint": "Đã bỏ khỏi Products Special"
      },
      "assignMerchants": "Gán merchant",
      "assignPerVariant": "Gán theo SKU"
    },
    "attributesGenerator": {
      "labelPlaceholder": "-- Nhãn --",
      "addAttribute": "+ Thêm Option",
      "skuGeneratedOne": "Đã tạo {{count}} SKU — bảng bên phải cập nhật khi bạn tick giá trị.",
      "skuGeneratedOther": "Đã tạo {{count}} SKU — bảng bên phải cập nhật khi bạn tick giá trị.",
      "clearOption": "Xoá lựa chọn",
      "searchOption": "Tìm option…",
      "removeAttribute": "Xoá option",
      "loadingOptions": "Đang tải options…",
      "noOptionsForLabel": "Không có option nào cho {{label}}",
      "noOptionsMatch": "Không có option phù hợp",
      "selectValues": "Chọn giá trị…",
      "noActiveValues": "Option này chưa có giá trị đang hoạt động.",
      "noValuesMatch": "Không có giá trị phù hợp.",
      "maxReached": "Đã đạt tối đa {{max}} option cho một blueprint.",
      "columnOptionType": "Loại Option",
      "columnOptionName": "Tên Option",
      "columnOptionValues": "Giá trị Option",
      "pickOptionFirst": "Chọn Tên Option trước",
      "searchValues": "Tìm giá trị…",
      "removeValueAria": "Xoá {{value}}",
      "valueLockedInUse": "Đang được SKU hiện có sử dụng — chỉ thêm được, không xoá được"
    },
    "giftMessagesTab": {
      "sectionAria": "Lời nhắn quà tặng",
      "newTitle": "Mẫu lời nhắn quà tặng mới",
      "namePlaceholder": "Tên mẫu (EN)",
      "maxLengthPlaceholder": "Độ dài tối đa",
      "pricePlaceholder": "Giá (cent)",
      "saving": "Đang lưu…",
      "submit": "Tạo mẫu",
      "empty": "Chưa có mẫu nào — tạo một cái ở trên.",
      "errTierRequired": "Cần có tier và giá là số nguyên không âm.",
      "toastCreated": "Đã tạo mẫu lời nhắn quà tặng",
      "toastCreateFailed": "Tạo mẫu quà tặng thất bại",
      "col": {
        "nameEn": "Tên (EN)",
        "maxLength": "Độ dài tối đa",
        "tierRows": "Số dòng tier",
        "firstTierPrice": "Giá tier đầu tiên"
      }
    },
    "assignModal": {
      "saveSuccess": "Đã lưu phân công",
      "saveErrorTitle": "Không lưu được phân công",
      "networkCheckError": "Lỗi mạng — kiểm tra kết nối",
      "title": "Gán merchant — {{name}}",
      "hint": "Lưới gán theo từng biến thể. Ô của biến thể ẩn sẽ bị vô hiệu hoá.",
      "scopeGroupAria": "Phạm vi danh sách merchant",
      "scopeAssigned": "Đã gán ({{count}})",
      "scopeAll": "Tất cả ({{count}})",
      "noAssignedYet": "Chưa gán merchant nào. Chuyển sang \"Tất cả\" để thêm.",
      "noMerchants": "Không có merchant nào trong danh bạ.",
      "merchantCol": "Merchant",
      "allVariantsTitle": "Bật/tắt gán cho TOÀN BỘ blueprint (mọi biến thể)",
      "allVariants": "Tất cả biến thể",
      "hiddenVariantTitle": "Biến thể ẩn — đã vô hiệu hoá",
      "hiddenCheckboxTitle": "Không thể gán biến thể ẩn",
      "cancel": "Huỷ",
      "saving": "Đang lưu…",
      "save": "Lưu phân công",
      "scopeAllShort": "Tất cả merchant",
      "searchPlaceholder": "Tìm merchant theo tên hoặc email…",
      "loadingMerchants": "Đang tải danh sách merchant…",
      "directoryError": "Không tải được danh bạ merchant. Kiểm tra kết nối rồi thử lại.",
      "noSearchMatch": "Không có merchant nào khớp “{{term}}”.",
      "offscreenNote": "Cả {{count}} merchant đã gán đều được lưu, kể cả những merchant không hiển thị ở trang này.",
      "removeCol": "Gỡ merchant",
      "removeMerchantTitle": "Gỡ {{name}} khỏi sản phẩm này",
      "removeConfirmTitle": "Gỡ merchant này?",
      "removeConfirmDesc": "{{name}} sẽ không đặt được sản phẩm này nữa, và các SKU đã tick cho họ sẽ bị bỏ. Có hiệu lực khi bạn lưu.",
      "removeConfirmCta": "Gỡ merchant",
      "emptyRowTitle": "Mỗi merchant phải có ít nhất một SKU",
      "emptyRowDesc": "{{count}} dòng merchant chưa tick gì. Hãy tick ít nhất một SKU, hoặc bấm nút gỡ để bỏ gán merchant đó.",
      "emptyRowHint": "Tick ít nhất một SKU, hoặc gỡ merchant này."
    },
    "createModal": {
      "createSuccess": "Đã tạo Products Special",
      "createErrorTitle": "Không tạo được",
      "title": "Tạo Products Special",
      "hint": "Chọn blueprint cần ẩn khỏi catalog chung và gán cho merchant cụ thể. Có thể tinh chỉnh gán theo biến thể sau khi tạo, qua nút \"N merchants →\".",
      "blueprintLabel": "Blueprint",
      "blueprintSearchPlaceholder": "Tìm blueprint theo tên / mã…",
      "merchantsLabel": "Merchant",
      "merchantSearchPlaceholder": "Tìm merchant theo tên / email…",
      "cancel": "Huỷ",
      "submitDisabledTitle": "Chọn 1 blueprint và nhập ≥ 1 merchant ID",
      "creating": "Đang tạo…",
      "submit": "Tạo"
    },
    "status": {
      "Active": "Đang bật",
      "Inactive": "Đang tắt"
    },
    "createSheet": {
      "title": "Tạo sản phẩm đặc biệt",
      "blueprintLabel": "Blueprint",
      "blueprintSearchPlaceholder": "Chọn blueprint",
      "assignmentHeading": "Gán SKU & Merchant",
      "modeAll": "Áp dụng cho tất cả SKU",
      "modePerSku": "Cấu hình theo từng SKU",
      "merchantLabel": "Merchant",
      "merchantSearchPlaceholder": "Chọn merchant",
      "colSkuCode": "MÃ SKU",
      "colSkuName": "TÊN SKU",
      "colAssignedMerchants": "MERCHANT ĐƯỢC GÁN",
      "hiddenSku": "Đang ẩn — không gán được",
      "noSkus": "Blueprint này chưa có SKU nào.",
      "pickBlueprintFirst": "Chọn blueprint để xem danh sách SKU.",
      "skusLoadError": "Không tải được danh sách SKU.",
      "showingSkus": "Hiển thị {{from}}-{{to}} trong {{total}} SKU",
      "skuPaginationAria": "Phân trang SKU",
      "duplicateBlueprint": "Blueprint này đã là sản phẩm đặc biệt.",
      "createSuccess": "Đã tạo sản phẩm đặc biệt",
      "createErrorTitle": "Không tạo được sản phẩm đặc biệt",
      "cancel": "Huỷ",
      "save": "Lưu",
      "editTitle": "Sửa sản phẩm đặc biệt",
      "updateSuccess": "Đã lưu thay đổi",
      "updateErrorTitle": "Không lưu được thay đổi"
    }
  },
  "bundle": {
    "title": "Bundle",
    "subtitle": "Combo nhiều sản phẩm",
    "columns": {
      "name": "Tên",
      "productCount": "Số sản phẩm",
      "price": "Giá",
      "isActive": "Đang hoạt động",
      "code": "Mã",
      "components": "Thành phần",
      "status": "Trạng thái"
    },
    "actions": {
      "create": "Tạo Bundle",
      "edit": "Sửa",
      "pause": "Tạm dừng",
      "resume": "Tiếp tục",
      "delete": "Xóa"
    },
    "banners": {
      "paused": "Bundle này đang tạm dừng — merchant không thấy"
    },
    "fields": {
      "name": "Tên Bundle",
      "products": "Sản phẩm",
      "price": "Giá Bundle (USD)",
      "description": "Mô tả"
    },
    "list": {
      "heading": "Bundles",
      "subtitle": "Combo nhiều blueprint thành 1 SKU bán — giá cố định (USD).",
      "searchPlaceholder": "Tìm theo mã hoặc tên…",
      "totalCount": "{{count}} bundle",
      "loading": "Đang tải danh sách bundles…",
      "loadError": "Không tải được: {{message}}",
      "empty": "Chưa có bundle nào.",
      "componentCount": "{{count}} blueprint",
      "pageInfo": "Trang {{page}} / {{total}}",
      "prev": "Trước",
      "next": "Sau",
      "created": "Đã tạo bundle {{code}}"
    },
    "create": {
      "title": "Tạo bundle mới",
      "note": "Chỉ hỗ trợ giá cố định (USD). Không có giảm giá / cộng dồn / định giá động.",
      "codeLabel": "Mã (IN HOA)",
      "descLabel": "Mô tả (tuỳ chọn)",
      "descPlaceholder": "Nội dung mô tả",
      "priceLabel": "Giá (USD) — cố định",
      "priceHint": "={{cents}} cents — chỉ một mức giá; không hỗ trợ giảm giá/cộng dồn/định giá động.",
      "componentsLabel": "Blueprint thành phần (2-20)",
      "componentsSearchPlaceholder": "Tìm blueprint theo tên hoặc mã…",
      "cancel": "Huỷ",
      "creating": "Đang tạo…",
      "submit": "Tạo bundle",
      "createFailed": "Không tạo được bundle",
      "networkError": "Lỗi mạng — kiểm tra kết nối",
      "codePlaceholder": "MUG-COMBO-01",
      "namePlaceholder": "Mug + sticker combo",
      "hint": {
        "code": "Mã chỉ gồm CHỮ HOA, số, _ hoặc - (không dấu cách).",
        "name": "Nhập tên gói.",
        "price": "Giá phải lớn hơn 0.",
        "components": "Chọn từ 2 đến 20 mẫu thành phần."
      }
    },
    "detail": {
      "close": "Đóng",
      "componentsTitle": "Thành phần ({{count}})",
      "loadingComponents": "Đang tải thành phần…",
      "noComponents": "Chưa có thành phần."
    }
  },
  "mapping": {
    "title": "Mapping",
    "subtitle": "Mapping sản phẩm sang SKU vendor",
    "columns": {
      "product": "Sản phẩm",
      "vendor": "Vendor",
      "vendorSku": "SKU Vendor",
      "updatedAt": "Cập nhật",
      "externalSku": "SKU ngoài",
      "sourceTitle": "Tiêu đề nguồn",
      "candidates": "Ứng viên",
      "ticket": "Ticket",
      "generated": "Tạo lúc"
    },
    "banners": {
      "ticketOnly": "Mapping chỉ được quản lý qua ticket hỗ trợ — liên hệ admin để yêu cầu thay đổi"
    },
    "actions": {
      "viewHistory": "Xem lịch sử"
    },
    "page": {
      "title": "Lỗi mapping",
      "subtitle": "SKU mapping không khớp giữa store ngoài và blueprint nội bộ.",
      "bannerTitle": "Chỉ xử lý khi có yêu cầu hỗ trợ.",
      "bannerBody1": "Admin chỉ được xử lý mapping khi merchant đã mở ticket",
      "bannerBody2": "Xử lý khi chưa có ticket sẽ bị hệ thống từ chối.",
      "searchPlaceholder": "Tìm theo SKU ngoài…",
      "ticketOnlyLabel": "Chỉ hiển thị dòng có ticket",
      "pendingCount": "{{count}} đang chờ",
      "loading": "Đang tải mapping đang chờ…",
      "loadError": "Không tải được:",
      "unknownError": "không xác định",
      "emptyBase": "Không có mapping nào đang chờ",
      "emptyTicketSuffix": " (có ticket)",
      "candidateSummary": "{{count}} ứng viên (cao nhất {{pct}}%)",
      "openTicket": "Mở ticket →",
      "noTicketTooltip": "Chưa thể xử lý khi chưa có ticket",
      "noTicket": "Chưa có ticket",
      "pageInfo": "Trang {{page}} / {{total}}",
      "prev": "Trước",
      "next": "Sau"
    }
  },
  "collection": {
    "title": "Collection",
    "subtitle": "Collection sản phẩm được tuyển chọn",
    "columns": {
      "name": "Tên",
      "blueprintCount": "Số blueprint",
      "isActive": "Đang hoạt động"
    },
    "actions": {
      "create": "Tạo bộ sưu tập"
    },
    "fields": {
      "name": "Tên Collection",
      "slug": "Slug",
      "blueprints": "Blueprint",
      "description": "Mô tả",
      "seoTitle": "Tiêu đề SEO",
      "seoDescription": "Mô tả SEO",
      "image": "Ảnh bìa"
    },
    "page": {
      "title": "Bộ sưu tập",
      "subtitle": "Nhóm các blueprint để lọc catalog và hiển thị trên trang chủ. Quan hệ nhiều-nhiều, mỗi bộ sưu tập có SEO riêng.",
      "newCollection": "Tạo bộ sưu tập",
      "searchPlaceholder": "Tìm theo slug hoặc tên (EN)…",
      "countLabel": "{{count}} bộ sưu tập",
      "loading": "Đang tải bộ sưu tập…",
      "loadError": "Không tải được:",
      "empty": "Chưa có bộ sưu tập nào.",
      "columns": {
        "slug": "Slug",
        "nameEn": "Tên (EN)",
        "blueprints": "Blueprint",
        "seoIndex": "SEO Index",
        "status": "Trạng thái",
        "sort": "Thứ tự"
      },
      "blueprintCount": "{{count}} blueprint",
      "indexed": "Đã index",
      "noindex": "Không index",
      "pageOf": "Trang {{page}} / {{total}}",
      "prev": "Trước",
      "next": "Sau"
    },
    "statusLabels": {
      "Active": "Đang hoạt động",
      "Inactive": "Ngừng hoạt động"
    },
    "toasts": {
      "created": "Đã tạo bộ sưu tập \"{{slug}}\""
    },
    "modal": {
      "createError": "Không tạo được bộ sưu tập",
      "networkError": "Lỗi mạng — kiểm tra kết nối",
      "title": "Tạo bộ sưu tập",
      "subtitle": "Quan hệ nhiều-nhiều với blueprint + khối SEO (tiêu đề/canonical/index/từ khoá/mô tả).",
      "nameEn": "Tên (EN)",
      "nameEnPlaceholder": "Summer Tees",
      "nameVi": "Tên (VI, tuỳ chọn)",
      "nameViPlaceholder": "Áo thun hè",
      "slug": "Slug (kebab-case)",
      "sortOrder": "Thứ tự sắp xếp",
      "descEn": "Mô tả (EN, tuỳ chọn)",
      "descEnPlaceholder": "Nội dung giới thiệu",
      "status": "Trạng thái",
      "blueprints": "Blueprint (nhiều-nhiều)",
      "blueprintsSearchPlaceholder": "Tìm blueprint theo tên hoặc mã…",
      "blueprintsHelper": "Một blueprint có thể thuộc nhiều bộ sưu tập.",
      "seoBlock": "Khối SEO",
      "seoTitle": "Tiêu đề",
      "seoCanonical": "URL canonical",
      "seoAllowIndex": "Cho phép Google index",
      "seoKeywords": "Từ khoá meta (phân tách bằng dấu phẩy)",
      "seoDescription": "Mô tả meta",
      "seoDescriptionPlaceholder": "Tuyển chọn các blueprint áo thun hè…",
      "cancel": "Huỷ",
      "submitting": "Đang tạo…",
      "submit": "Tạo bộ sưu tập",
      "seoTitlePlaceholder": "Summer Tees | PrintWay",
      "seoCanonicalPlaceholder": "https://printway.com/collections/summer-tees",
      "seoKeywordsPlaceholder": "tee, summer, print"
    },
    "list": {
      "colLabel": "Nhãn",
      "empty": "Không có bộ sưu tập nào khớp bộ lọc này.",
      "showingRange": "Đang hiển thị {{from}}–{{to}} trên {{total}} bộ sưu tập",
      "searchPlaceholder": "Tìm bộ sưu tập...",
      "searchAria": "Tìm bộ sưu tập"
    },
    "form": {
      "createTitle": "Tạo bộ sưu tập",
      "editTitle": "Chỉnh sửa bộ sưu tập",
      "saveCollection": "Lưu bộ sưu tập",
      "labelLabel": "Nhãn",
      "labelPlaceholder": "New",
      "hexLabel": "Mã màu HEX",
      "hexPlaceholder": "#E53935",
      "errors": {
        "hexInvalid": "Mã màu HEX phải có dạng #RGB hoặc #RRGGBB."
      }
    }
  },
  "add_on": {
    "title": "Add-on",
    "subtitle": "Cấu hình add-on sản phẩm",
    "tabs": {
      "config": "Cấu hình",
      "accessories": "Phụ kiện",
      "gift": "Quà tặng"
    },
    "columns": {
      "name": "Tên",
      "type": "Loại",
      "price": "Giá",
      "isActive": "Đang hoạt động"
    },
    "actions": {
      "create": "Tạo Add-on",
      "edit": "Sửa",
      "delete": "Xóa"
    },
    "fields": {
      "name": "Tên",
      "type": "Loại",
      "price": "Giá (USD)",
      "description": "Mô tả"
    },
    "page": {
      "subtitle": "Khu vực quản lý add-on hợp nhất: Cấu hình và Quà tặng. Phụ kiện giờ quản lý dưới dạng blueprint phụ kiện trong Sản phẩm > Blueprint.",
      "tabsAria": "Thẻ con của Add-on"
    },
    "accessoriesTab": {
      "readonlyNote": "Danh sách phụ kiện (chỉ đọc). Chỉnh sửa biến thể đầy đủ sẽ có ở bản cập nhật sau.",
      "empty": "Chưa có blueprint phụ kiện nào. Hãy đánh dấu một blueprint là phụ kiện trong trình chỉnh sửa blueprint.",
      "yes": "Có",
      "no": "Không",
      "col": {
        "nameEn": "Tên (EN)",
        "standalone": "Bán riêng",
        "variants": "Biến thể",
        "firstVariantPrice": "Giá biến thể đầu tiên",
        "name": "Tên",
        "code": "Mã",
        "locations": "Địa điểm"
      },
      "note": "Các blueprint được đánh dấu là phụ kiện. Liên kết chúng làm add-on cho một sản phẩm chính bên dưới.",
      "linkTitle": "Liên kết add-on phụ kiện",
      "mainLabel": "Sản phẩm chính",
      "mainPlaceholder": "Chọn blueprint chính",
      "accessoryLabel": "Phụ kiện",
      "accessoryPlaceholder": "Chọn blueprint phụ kiện",
      "chargeFeeLabel": "Tính phí bổ sung",
      "fromQtyLabel": "Tính phí từ đơn vị #",
      "linkBtn": "Liên kết add-on",
      "toastLinked": "Đã liên kết add-on phụ kiện",
      "toastLinkFailed": "Không thể liên kết add-on phụ kiện",
      "errSelectBoth": "Hãy chọn cả sản phẩm chính và phụ kiện.",
      "errAlreadyLinked": "Phụ kiện này đã được liên kết với sản phẩm đã chọn.",
      "status": {
        "Active": "Đang hoạt động",
        "Inactive": "Ngừng hoạt động",
        "Draft": "Bản nháp",
        "PendingApproval": "Chờ duyệt"
      }
    },
    "addonsTab": {
      "sectionAria": "Cấu hình Add-on",
      "newTitle": "Add-on mới",
      "nameEnLabel": "Tên (tiếng Anh)",
      "namePlaceholder": "vd Màu chỉ",
      "choiceMode": "Kiểu chọn",
      "choiceModeLabels": {
        "multi": "Chọn nhiều",
        "single": "Chọn một"
      },
      "required": "Bắt buộc",
      "tierPricesTitle": "Giá theo tier (cần ít nhất một dòng)",
      "addTierRow": "+ Thêm dòng tier",
      "pricePlaceholder": "Giá (cent)",
      "remove": "Xoá",
      "saving": "Đang lưu…",
      "submit": "Tạo add-on",
      "empty": "Chưa có add-on nào — tạo một cái ở trên.",
      "yes": "Có",
      "no": "Không",
      "errTierRequired": "Cần ít nhất một dòng giá theo tier.",
      "toastCreated": "Đã tạo add-on",
      "toastCreateFailed": "Tạo add-on thất bại",
      "col": {
        "nameEn": "Tên (EN)",
        "choice": "Kiểu chọn",
        "required": "Bắt buộc",
        "tierRows": "Số dòng tier"
      }
    }
  },
  "pricing": {
    "title": "Bảng giá",
    "subtitle": "Bậc giá, khuyến mãi, vận chuyển",
    "tabs": {
      "tiers": "Bậc giá",
      "deals": "Khuyến mãi",
      "shipping": "Vận chuyển",
      "shippingRates": "Phí vận chuyển",
      "history": "Lịch sử"
    },
    "columns": {
      "name": "Tên",
      "minQty": "SL tối thiểu",
      "maxQty": "SL tối đa",
      "price": "Giá",
      "discount": "Giảm giá"
    },
    "actions": {
      "createTier": "Tạo bậc giá",
      "createDeal": "Tạo khuyến mãi",
      "createShipping": "Tạo quy tắc vận chuyển",
      "edit": "Sửa",
      "delete": "Xóa"
    },
    "fields": {
      "tierName": "Tên bậc",
      "qtyRange": "Khoảng số lượng",
      "discountPct": "Giảm %",
      "validFrom": "Có hiệu lực từ",
      "validTo": "Có hiệu lực đến"
    },
    "page": {
      "subtitle": "Quản lý bậc giá (mặc định: Standard — có thể thêm bậc mới), khuyến mãi, phí vận chuyển (7 vùng × 2 tốc độ) và lịch sử thay đổi. Thay đổi giá >±10% ở Bậc giá cần Super Admin duyệt.",
      "readonlyPre": "Bạn không có quyền",
      "readonlyPost": "Trang đang ở chế độ chỉ xem.",
      "tabsAria": "Các thẻ giá"
    },
    "common": {
      "retry": "Thử lại",
      "cancel": "Huỷ",
      "networkError": "Lỗi mạng — kiểm tra kết nối"
    },
    "dealsTab": {
      "heading": "Khuyến mãi",
      "description": "Quản lý deals (volume / revenue / direct). Mới tạo luôn ở trạng thái Draft; bước duyệt + active làm ở queue duyệt riêng.",
      "createBtn": "+ Tạo khuyến mãi",
      "loadError": "Không tải được danh sách Deals.",
      "empty": "Chưa có deal nào.",
      "table": {
        "type": "Loại",
        "reward": "Phần thưởng",
        "scope": "Phạm vi",
        "valid": "Hiệu lực",
        "priority": "Ưu tiên",
        "status": "Trạng thái"
      },
      "scopeTiers": " · {{count}} bậc",
      "scopeMerchants": " · {{count}} merchant",
      "scopeBlueprints": " · {{count}} blueprint",
      "statusLabels": {
        "Active": "Đang chạy",
        "Draft": "Nháp",
        "Paused": "Tạm dừng",
        "Expired": "Hết hạn",
        "Archived": "Đã lưu trữ"
      },
      "validation": {
        "nameRequired": "Tên (EN) bắt buộc",
        "priorityInt": "Priority phải là số nguyên ≥ 0",
        "startRequired": "Bắt đầu (Valid From) bắt buộc",
        "endRequired": "Kết thúc (Valid Until) bắt buộc",
        "endAfterStart": "Valid Until phải lớn hơn Valid From",
        "cashbackBaseRequired": "cashback yêu cầu chọn cashback base",
        "cashbackBaseInvalid": "cashback base chỉ hợp lệ khi reward = cashback",
        "tierRequired": "Chọn ít nhất 1 pricing tier",
        "blueprintOrMerchantRequired": "Chọn ít nhất 1 blueprint hoặc 1 merchant"
      },
      "toast": {
        "createdTitle": "Đã tạo deal Draft",
        "createFailTitle": "Không tạo được deal"
      },
      "modal": {
        "nameEn": "Tên (EN) *",
        "type": "Loại *",
        "dealScope": "Phạm vi deal *",
        "rewardKind": "Loại phần thưởng *",
        "percent": "Phần trăm %",
        "valueCents": "Giá trị (cents)",
        "cashbackBase": "Cashback base *",
        "selectPlaceholder": "— chọn —",
        "scope": "Phạm vi",
        "applyTo": "Áp dụng cho *",
        "pricingTiers": "Bậc giá (chọn nhiều)",
        "blueprints": "Blueprints (chọn nhiều)",
        "searchBlueprint": "Tìm blueprint…",
        "merchantsOptional": "Merchants — tùy chọn (để trống nếu chỉ target blueprint)",
        "searchMerchant": "Tìm merchant…",
        "priority": "Ưu tiên *",
        "validFrom": "Có hiệu lực từ *",
        "validUntil": "Có hiệu lực đến *",
        "expiryWarning": "Cảnh báo hết hạn (ngày)",
        "serverErrors": "Lỗi từ server:",
        "creating": "Đang tạo…",
        "createDraft": "Tạo bản nháp"
      }
    },
    "historyTab": {
      "heading": "Lịch sử giá",
      "descriptionPre": "Audit trail của thay đổi pricing (Tiers / Variants). Để xem audit-log đầy đủ, mở Audit Logs với filter ",
      "descriptionPost": ".",
      "auditLink": "Mở Audit Logs (PricingTier) →",
      "loadError": "Không tải được Pricing History.",
      "empty": "Chưa có thay đổi pricing nào.",
      "cols": {
        "changedAt": "Thời điểm",
        "tierVariant": "Bậc / Biến thể",
        "before": "Trước",
        "after": "Sau",
        "changedBy": "Người đổi",
        "reason": "Lý do",
        "source": "Nguồn"
      },
      "tierLevel": "Cấp bậc giá",
      "variant": "Biến thể",
      "tierId": "tier: {{id}}",
      "variantIds": "bp: {{bp}} · var: {{var}} · tier: {{tier}}"
    },
    "reasonModal": {
      "title": "Xác nhận thay đổi giá",
      "description": "Mọi thay đổi giá đều bắt buộc có lý do. Nội dung bạn nhập sẽ được ghi vào audit log cùng với giá mới.",
      "reasonLabel": "Lý do",
      "placeholder": "vd: Tăng chi phí Q3 theo hóa đơn nhà cung cấp #12345",
      "needMoreOne": "Cần thêm ít nhất {{count}} ký tự",
      "needMoreOther": "Cần thêm ít nhất {{count}} ký tự",
      "charCount": "{{count}} ký tự",
      "saving": "Đang lưu…",
      "confirm": "Xác nhận thay đổi",
      "changes": {
        "sku": "SKU",
        "location": "Location",
        "tier": "Tier",
        "price": "Giá cũ → mới"
      },
      "batchSummary_one": "Đã đổi {{count}} giá — một lý do áp cho tất cả.",
      "batchSummary_other": "Đã đổi {{count}} giá — một lý do áp cho tất cả."
    },
    "tiersTab": {
      "heading": "Bậc giá",
      "description": "Pricing tier (mặc định: Standard) — chỉnh sửa inline. Thay đổi giá >±10% cần Super Admin duyệt.",
      "tierCount": "{{count}} bậc giá",
      "loadError": "Không tải được danh sách Pricing Tiers.",
      "empty": "Chưa có Pricing Tier nào.",
      "cols": {
        "tier": "Bậc",
        "status": "Trạng thái",
        "priority": "Ưu tiên",
        "conditions": "Điều kiện (Đơn HOẶC GMV)",
        "priceModifier": "Điều chỉnh giá (bps)",
        "actions": "Thao tác"
      },
      "statusLabels": {
        "Active": "Đang dùng",
        "Inactive": "Ngừng"
      },
      "slugLabel": "slug: {{slug}}",
      "cond": {
        "orders": "Đơn ≥ {{count}}",
        "gmv": "GMV ≥ ${{amount}}",
        "items": "Mục ≥ {{count}}"
      },
      "priceModifierAria": "Phần trăm điều chỉnh giá cho {{name}}",
      "current": "Hiện tại: {{value}}",
      "modifierRange": "Nhập mức giảm từ -50% đến 0% (không cho phép tăng giá).",
      "reasonPlaceholder": "Lý do thay đổi (≥ 10 ký tự — bắt buộc để Save active)",
      "reasonAria": "Lý do thay đổi",
      "reasonHint": "Yêu cầu lý do tối thiểu 10 ký tự ({{count}}/10) — Save sẽ active khi đạt.",
      "approvalTitle": "Thay đổi này cần Super Admin duyệt",
      "approvalDelta": "Δ = {{pct}}% > ngưỡng ±10%.",
      "submitting": "Đang gửi…",
      "submitForApproval": "Gửi duyệt",
      "saving": "Đang lưu…",
      "save": "Lưu",
      "editHint": "— sửa giá trị để chỉnh —",
      "readOnly": "Read-only (yêu cầu quyền pricing:manage)",
      "footerNotePre": "Threshold giá >±10% là tự động. Server cũng kiểm tra lại; nếu bạn vượt ngưỡng, banner sẽ hiển thị nút",
      "footerNoteMid": " thay vì ",
      "footerNotePost": ".",
      "toast": {
        "submittedTitle": "Đã gửi duyệt cho tier {{name}}",
        "submittedDesc": "Super Admin sẽ phê duyệt thay đổi >±10%.",
        "savedTitle": "Đã lưu tier {{name}}",
        "saveFailTitle": "Không lưu được tier {{name}}"
      }
    }
  },
  "technique": {
    "title": "Kỹ thuật",
    "subtitle": "Kỹ thuật in và thêu",
    "tabs": {
      "print": "In",
      "embroidery": "Thêu"
    },
    "columns": {
      "name": "Tên",
      "type": "Loại",
      "basePrice": "Giá cơ bản",
      "isActive": "Đang hoạt động"
    },
    "actions": {
      "create": "Tạo kỹ thuật",
      "edit": "Sửa",
      "delete": "Xóa"
    },
    "detail": {
      "toast": {
        "saved": "Đã lưu",
        "saveFailed": "Lưu thất bại",
        "deleted": "Đã xoá kỹ thuật",
        "deleteFailed": "Xoá thất bại"
      },
      "notFound": "Không tìm thấy kỹ thuật.",
      "backToList": "Quay lại danh sách",
      "back": "Quay lại Kỹ thuật",
      "active": "Hoạt động",
      "inactive": "Ngừng",
      "inactiveDraft": "Ngừng (bản nháp)",
      "codeImmutable": "Code (không đổi)",
      "typeImmutable": "Loại (không đổi)",
      "nameEn": "Tên (EN)",
      "nameVi": "Tên (VI)",
      "nameFr": "Tên (FR)",
      "activeToggleAria": "Bật/tắt hoạt động",
      "digitizingFee": "Phí số hoá (USD cents)",
      "stitchRanges": "Khoảng mũi thêu",
      "addRange": "Thêm khoảng",
      "rangeMin": "Mũi tối thiểu",
      "rangeMax": "Mũi tối đa",
      "rangeFee": "Phí (cents)",
      "remove": "Xoá",
      "overflowTitle": "Công thức phụ phí vượt ngưỡng",
      "overflowPer": "Mỗi số mũi (Y)",
      "overflowFee": "Phí cents (X)",
      "overflowDisabled": "Đã tắt — không tính thêm phí ngoài bậc cuối.",
      "noPricingCutting": "Cắt hiện chưa có trường giá.",
      "noPricingBlank": "Phương pháp blank không có trường giá.",
      "noPricingPrint": "Phương pháp in không có trường giá. Giá nằm ở blueprint / sản phẩm.",
      "cancel": "Huỷ",
      "save": "Lưu",
      "saving": "Đang lưu…",
      "deleteTitle": "Xoá kỹ thuật?",
      "deleteDesc": "Xoá mềm kỹ thuật này. Nó sẽ bị ẩn khỏi danh sách và có thể khôi phục từ cơ sở dữ liệu."
    },
    "createModal": {
      "subtitle": "Chọn loại — Thêu cần cấu hình giá theo dải mũi + phí số hoá.",
      "typeOptions": {
        "print": "In (UV / DTF / DTG / Sublimation)",
        "embroidery": "Thêu (dải mũi + phí số hoá)",
        "cutting": "Cắt (laser / khắc — giá ở MVP-C)",
        "blank": "Blank (không có giá)"
      },
      "code": "Mã",
      "codePlaceholder": "vd dtg, sublimation",
      "codeHint": "Slug: chữ thường / số / gạch ngang / gạch dưới, tối đa 50.",
      "activeOnCreation": "Kích hoạt khi tạo",
      "digitizingFeeHint": "Bắt buộc cho thêu — tính một lần cho mỗi mẫu thêu.",
      "rangeRowHint": "Mỗi dòng:",
      "printNote": "Phương pháp in không có trường bổ sung. Giá nằm ở blueprint / sản phẩm.",
      "cuttingNoteBefore": "Cắt hiện không có trường bổ sung.",
      "cuttingNoteAfter": "schema sẽ có ở MVP-C. Quy tắc giá thêm ở đó.",
      "blankNoteBefore": "Phương pháp Blank",
      "blankNoteStrong": "không có trường giá",
      "blankNoteAfter": "(backend từ chối digitizingFee / embroideryRanges / overflow).",
      "creating": "Đang tạo…",
      "submit": "Tạo kỹ thuật",
      "toast": {
        "created": "Đã tạo kỹ thuật",
        "createFailed": "Tạo kỹ thuật thất bại",
        "createFailedFallback": "Tạo thất bại"
      }
    },
    "create": {
      "titleFallback": "Kỹ thuật thêu mới",
      "basicInfo": "Thông tin cơ bản",
      "name": "Tên",
      "namePlaceholder": "Nhập tên kỹ thuật",
      "code": "Mã",
      "codePlaceholder": "Nhập mã",
      "codeDuplicate": "Mã đã được sử dụng.",
      "description": "Mô tả",
      "descriptionPlaceholder": "Nhập mô tả",
      "digitizingFee": "Phí số hoá file",
      "firstArea": "Vùng thêu thứ nhất",
      "nextArea": "Vùng thêu tiếp theo",
      "nextAreaHint": "Không bắt buộc. Tích chọn vùng để tính giá riêng; vùng không tích sẽ dùng bảng giá ở trên.",
      "applyPriceToAll": "Áp bảng giá này cho {{count}} vùng đã chọn",
      "applyToAllDisabledHint": "Hãy tick ít nhất một vùng trước.",
      "selectAll": "Chọn tất cả",
      "areaLabel": "Vùng: {{area}}",
      "areasLoading": "Đang tải danh sách vùng in…",
      "areasLoadFailed": "Không tải được danh sách vùng in.",
      "areasEmpty": "Chưa cấu hình vùng in nào.",
      "addRange": "Thêm",
      "rangeMin": "Số mũi tối thiểu",
      "rangeMax": "Số mũi tối đa",
      "rangeFee": "Phí thêu",
      "remove": "Xoá dòng",
      "overflowEvery": "Mỗi",
      "overflowStitchesAdd": "mũi thêu vượt thêm, cộng",
      "overflowPer": "Số mũi thêu mỗi bước",
      "overflowFee": "Phí cộng thêm mỗi bước",
      "save": "Lưu",
      "saving": "Đang lưu…",
      "toast": {
        "created": "Đã tạo kỹ thuật",
        "createFailed": "Tạo kỹ thuật thất bại",
        "createFailedFallback": "Tạo thất bại",
        "incomplete": "Chưa lưu được",
        "incompleteDesc": "Còn ô bắt buộc bị trống hoặc sai — các ô đó đã được đánh dấu bên dưới.",
        "saved": "Đã lưu kỹ thuật",
        "saveFailed": "Lưu kỹ thuật thất bại"
      },
      "rangeError": "Mỗi dòng cần số mũi tối đa lớn hơn tối thiểu, và phí từ $0 trở lên.",
      "overflowError": "Điền cả hai ô để thu thêm khi vượt dòng cuối, hoặc để trống cả hai nếu không thu.",
      "codeLocked": "Không thể đổi mã sau khi đã tạo.",
      "breadcrumbAria": "Đường dẫn",
      "crumbBlueprint": "Blueprint",
      "crumbCreate": "Tạo mới",
      "crumbEdit": "Sửa",
      "bulkPricing": {
        "title": "Sửa giá hàng loạt",
        "description": "Nhập một bảng giá rồi áp cho cả {{count}} vùng đang chọn.",
        "overwriteWarning": "Thao tác này ghi đè bảng giá của mọi vùng đang chọn. Vùng chưa tick sẽ không bị thay đổi.",
        "apply": "Áp cho {{count}} vùng",
        "cancel": "Huỷ",
        "invalidHint": "Hãy sửa bảng giá cho đúng trước khi áp."
      }
    },
    "cuttingMethods": {
      "heading": "Phương pháp cắt",
      "caption": "Laser / Khắc / Cơ học (giá theo vùng ở MVP-C)",
      "banner": "Giá theo vùng cắt (cuttingRanges) sẽ có ở MVP-C — danh sách chỉ hiển thị tên/mã/bật-tắt hoạt động.",
      "codeAria": "Mã (slug)",
      "codePlaceholder": "mã (vd laser)",
      "namePlaceholder": "Tên hiển thị (tiếng Anh)",
      "addBtn": "Thêm kỹ thuật cắt",
      "colCode": "Mã",
      "colActions": "Thao tác",
      "loading": "Đang tải…",
      "empty": "Chưa có phương pháp cắt nào — thêm một mục ở trên.",
      "activeToggleTitleActive": "Đang hoạt động — bấm để tắt",
      "activeToggleTitleInactive": "Ngừng hoạt động — bấm để bật",
      "activeToggleAria": "Bật/tắt hoạt động cho {{code}}",
      "confirmDelete": "Xoá phương pháp cắt \"{{code}}\"?",
      "toast": {
        "created": "Đã tạo phương pháp cắt",
        "deleted": "Đã xoá phương pháp cắt",
        "createFailed": "Tạo phương pháp cắt thất bại",
        "createFailedFallback": "Tạo thất bại"
      }
    },
    "printMethods": {
      "heading": "Phương pháp in",
      "caption": "UV / DTF / DTG / Sublimation",
      "codeAria": "Mã (slug)",
      "codePlaceholder": "mã (vd dtg)",
      "namePlaceholder": "Tên hiển thị (tiếng Anh)",
      "addBtn": "Thêm phương pháp in",
      "colCode": "Mã",
      "colActions": "Thao tác",
      "loading": "Đang tải…",
      "empty": "Chưa có phương pháp in nào — thêm một mục ở trên.",
      "activeToggleTitleActive": "Đang hoạt động — bấm để tắt",
      "activeToggleTitleInactive": "Ngừng hoạt động — bấm để bật",
      "activeToggleAria": "Bật/tắt hoạt động cho {{code}}",
      "confirmDelete": "Xoá phương pháp in \"{{code}}\"?",
      "toast": {
        "created": "Đã tạo phương pháp in",
        "deleted": "Đã xoá phương pháp in",
        "createFailed": "Tạo phương pháp in thất bại",
        "createFailedFallback": "Tạo thất bại"
      }
    },
    "embroideryMethods": {
      "heading": "Phương pháp thêu",
      "loading": "Đang tải…",
      "colMinStitches": "Mũi tối thiểu",
      "colMaxStitches": "Mũi tối đa",
      "colFeeCents": "Phí (cent USD)",
      "colFeeDisplay": "Phí (hiển thị)",
      "colActions": "Thao tác",
      "feeCentsAria": "Phí tính bằng cent",
      "saveRanges": "Lưu dải mũi",
      "overflowDescBefore": "Vượt quá maxStitches của dải cuối, phí tính theo",
      "overflowDescStrong": "+$X cho mỗi +Y mũi",
      "overflowPerAria": "Số mũi mỗi mức vượt",
      "overflowFeeAria": "Phí cent khi vượt",
      "globalDigitizingFee": "Phí số hoá chung",
      "digitizingFeeHint": "Tính một lần cho mỗi mẫu thêu.",
      "digitizingFeeAria": "Phí số hoá tính bằng cent",
      "saveDigitizingFee": "Lưu phí số hoá",
      "toast": {
        "stitchRangesSaved": "Đã lưu dải mũi",
        "stitchRangesSaveFailed": "Lưu dải mũi thất bại",
        "digitizingFeeSaved": "Đã lưu phí số hoá",
        "digitizingFeeSaveFailed": "Lưu phí số hoá thất bại",
        "invalidRangesTitle": "Dải mũi không hợp lệ",
        "invalidRangesDesc": "Mỗi dòng cần giá trị min/max/phí hợp lệ; overflow cần perStitches ≥ 1 + feeCents ≥ 0.",
        "invalidFeeTitle": "Phí số hoá không hợp lệ",
        "invalidFeeDesc": "Phải là số nguyên không âm (cent)."
      }
    },
    "table": {
      "activate": "Bật",
      "activateDesc": "\"{{name}}\" ({{code}}) sẽ có thể chọn được trong bộ chọn sản phẩm.",
      "activateTitle": "Bật kỹ thuật?",
      "activeToggleAria": "Bật/tắt hoạt động cho {{code}}",
      "allTypes": "Tất cả loại",
      "bandCountOne": "{{count}} dải",
      "bandCountOther": "{{count}} dải",
      "colAction": "Thao tác",
      "colCode": "Mã",
      "colCreatedBy": "Người tạo",
      "colCreatedDate": "Ngày tạo",
      "colCreator": "Người tạo",
      "colDescription": "Mô tả",
      "colLastUpdate": "Cập nhật cuối",
      "colName": "Tên",
      "colNameCode": "Tên / Mã",
      "colUpdatedBy": "Người cập nhật",
      "deactivate": "Tắt",
      "deactivateDesc": "\"{{name}}\" ({{code}}) sẽ bị ẩn khỏi bộ chọn sản phẩm cho đến khi bật lại.",
      "deactivateTitle": "Tắt kỹ thuật?",
      "descBlank": "Blank — không có giá",
      "descCutting": "Phương pháp cắt (giá MVP-C)",
      "descPrint": "Phương pháp in",
      "digitizingFeeLabel": "Phí số hoá:",
      "editAria": "Sửa kỹ thuật {{code}}",
      "empty": "Không có kỹ thuật nào khớp bộ lọc hiện tại.",
      "loadError": "Không tải được kỹ thuật.",
      "loading": "Đang tải…",
      "newBtn": "Tạo kỹ thuật",
      "nextPage": "Trang sau",
      "noDigitizingFee": "Chưa có phí số hoá",
      "overflowLabel": "Vượt mức:",
      "overflowPer": "mỗi",
      "overflowUnit": "mũi",
      "paginationAria": "Phân trang kỹ thuật",
      "prevPage": "Trang trước",
      "retry": "Thử lại",
      "rowsPerPage": "Số dòng mỗi trang:",
      "searchAria": "Tìm theo mã hoặc tên",
      "searchLabel": "Tìm kiếm",
      "searchPlaceholder": "Tìm theo mã, tên…",
      "showingRange": "Đang xem {{from}}–{{to}} trong {{total}} kỹ thuật",
      "statusDeleted": "Đã xoá",
      "statusFilterAll": "Trạng thái: Tất cả",
      "statusFilterAria": "Lọc theo trạng thái",
      "statusLabel": "Trạng thái",
      "subtitle": "Quản lý các kỹ thuật in và thêu, cấu hình và phương thức sản xuất.",
      "toast": {
        "statusUpdated": "Đã cập nhật trạng thái",
        "toggleFailed": "Bật/tắt hoạt động thất bại"
      },
      "typeLabels": {
        "print": "In",
        "embroidery": "Thêu",
        "cutting": "Cắt",
        "blank": "Blank"
      },
      "working": "Đang xử lý…"
    },
    "treeSelect": {
      "placeholder": "— Chọn kỹ thuật in / thêu —",
      "selectedCount": "Đã chọn {{count}}",
      "removeAria": "Bỏ {{name}}",
      "loading": "Đang tải kỹ thuật…",
      "loadError": "Không tải được kỹ thuật.",
      "empty": "Chưa cấu hình kỹ thuật hoạt động nào.",
      "selectAll": "Chọn tất cả",
      "deselectAll": "Bỏ chọn tất cả",
      "clearAll": "Xoá tất cả",
      "typeLabels": {
        "print": "In",
        "embroidery": "Thêu",
        "cutting": "Cắt",
        "blank": "Blank",
        "engraving": "Khắc"
      }
    },
    "form": {
      "addRange": "Thêm khoảng",
      "cancel": "Huỷ",
      "code": "Mã",
      "codeHint": "Chữ, số, dấu gạch ngang và gạch dưới. Lưu ở dạng chữ thường.",
      "codeLocked": "Không thể sửa mã sau khi đã tạo.",
      "codePlaceholder": "Nhập mã kỹ thuật (ví dụ DTG-001)",
      "createSubtitle": "Thêm một kỹ thuật in hoặc thêu mới vào hệ thống.",
      "createTitle": "Tạo kỹ thuật in",
      "createTitleEmbroidery": "Tạo kỹ thuật thêu",
      "description": "Mô tả",
      "descriptionPlaceholder": "Nhập mô tả ngắn cho kỹ thuật này",
      "digitizingFee": "Phí digitizing (cent)",
      "editSubtitle": "Cập nhật thông tin và cấu hình của kỹ thuật.",
      "editTitle": "Sửa kỹ thuật in",
      "editTitleEmbroidery": "Sửa kỹ thuật thêu",
      "embroideryRequiredNote": "Kỹ thuật thêu bắt buộc có phí digitizing và ít nhất một khoảng mũi chỉ mới lưu được. Phí vượt khoảng được đặt ở trang chi tiết kỹ thuật.",
      "name": "Tên",
      "namePlaceholder": "Nhập tên kỹ thuật",
      "rangeFee": "Phí (cent)",
      "rangeHint": "Mỗi khoảng cần tối đa lớn hơn tối thiểu, và phí từ 0 trở lên.",
      "rangeMax": "Mũi chỉ tối đa",
      "rangeMin": "Mũi chỉ tối thiểu",
      "removeRange": "Xoá",
      "save": "Lưu",
      "saveFailed": "Không lưu được kỹ thuật",
      "stitchRanges": "Khoảng mũi chỉ",
      "toastCreated": "Đã tạo kỹ thuật",
      "toastUpdated": "Đã cập nhật kỹ thuật"
    }
  },
  "template": {
    "title": "Template",
    "subtitle": "Quản lý template artwork",
    "columns": {
      "name": "Tên",
      "blueprint": "Blueprint",
      "regions": "Vùng",
      "updatedAt": "Cập nhật"
    },
    "actions": {
      "create": "Tạo Template",
      "edit": "Sửa",
      "regionErrors": "Lỗi vùng",
      "preview": "Xem trước"
    },
    "regionErrors": {
      "title": "Lỗi vùng",
      "lowOpacity": "Phát hiện độ trong suốt thấp — artwork có thể in không đẹp",
      "outsideRegion": "Phần tử nằm ngoài vùng in",
      "missingArtwork": "Vùng chưa có artwork",
      "description": "Danh mục lỗi gán cho vùng template (nét mảnh, sai template…). Artwork Doctor dùng để chặn/cảnh báo khi merchant upload.",
      "newError": "+ Lỗi mới",
      "empty": "Chưa có lỗi vùng nào.",
      "edit": "Sửa",
      "delete": "Xoá",
      "cancel": "Huỷ",
      "save": "Lưu",
      "saving": "Đang lưu…",
      "confirmDeleteTitle": "Xoá lỗi vùng?",
      "confirmDeleteBody": "Lỗi sẽ bị gỡ khỏi catalog + tự gỡ khỏi mọi template đang dùng (cascade).",
      "col": {
        "key": "Key",
        "label": "Nhãn",
        "severity": "Mức độ",
        "actions": "Thao tác"
      },
      "severity": {
        "errorShort": "Lỗi (chặn)",
        "warningShort": "Cảnh báo",
        "errorOption": "Lỗi (chặn artwork)",
        "warningOption": "Cảnh báo (mềm)"
      },
      "dialog": {
        "editTitle": "Sửa lỗi vùng",
        "newTitle": "Lỗi vùng mới",
        "keyLabel": "Key *",
        "keyPlaceholder": "ví dụ: thin_lines",
        "labelEnLabel": "Nhãn (EN) *",
        "labelViLabel": "Nhãn (VI)",
        "severityLabel": "Mức độ"
      },
      "toast": {
        "loadFailed": "Không tải được danh sách lỗi vùng",
        "keyLabelRequired": "Key và Nhãn (EN) là bắt buộc",
        "saveFailed": "Lưu thất bại",
        "updated": "Đã cập nhật lỗi vùng",
        "created": "Đã tạo lỗi vùng",
        "deleteFailed": "Xoá thất bại",
        "deleted": "Đã xoá lỗi vùng"
      }
    },
    "detail": {
      "back": "← Danh sách",
      "backToList": "← Quay về danh sách",
      "notFound": "Không tìm thấy template.",
      "deleteBtn": "Xoá template",
      "resyncTooltip": "Push spec hiện tại sang Artwork Doctor",
      "resyncing": "Đang push…",
      "resync": "Re-sync AD",
      "saving": "Đang lưu…",
      "save": "Lưu thay đổi",
      "confirmDeleteTitle": "Xoá template?",
      "confirmDeleteBody": "Xoá tạm template — có thể khôi phục từ bộ lọc \"Đã xoá\".",
      "confirmDeleteYes": "Xoá",
      "confirmDeleteNo": "Huỷ",
      "staleBanner": "Template đã được cập nhật bởi người khác. Tải lại để lấy bản mới nhất trước khi lưu (thay đổi chưa lưu sẽ mất).",
      "reload": "Tải lại",
      "generalInfo": "Thông tin chung",
      "nameEn": "Tên (EN) *",
      "code": "Code *",
      "aliasEn": "Alias (EN)",
      "type": "Loại (Type) *",
      "side": "Side (mặt)",
      "productKind": "Loại sản phẩm *",
      "nameVi": "Tên (VI)",
      "printTechnology": "Công nghệ in",
      "printTechnologyHint": "Chọn các công nghệ in template hỗ trợ (DTG/DTF/UV/Sublimation). 1 template có thể nhiều công nghệ.",
      "descriptionEn": "Mô tả (EN)",
      "isActive": "Đang hoạt động",
      "areaDetail": "Chi tiết vùng",
      "selectAll": "Tất cả",
      "analyzing": "Đang nhận diện vùng…",
      "uploading": "Đang tải ảnh lên…",
      "invalidData": "Dữ liệu không hợp lệ.",
      "groupFailed": "Không thể nhóm các vùng này",
      "toast": {
        "saved": "Đã lưu Template",
        "savedWarnings": "Cảnh báo: {{warnings}}",
        "savedCode": "Code: {{code}}",
        "staleTitle": "Bản ghi đã thay đổi",
        "saveFailed": "Lưu Template thất bại",
        "deleted": "Đã xoá Template",
        "deletedDesc": "Đã xoá tạm — có thể khôi phục từ bộ lọc \"Đã xoá\".",
        "deleteFailed": "Xoá Template thất bại",
        "resyncFailed": "Re-sync Artwork Doctor thất bại",
        "adDisabled": "Artwork Doctor đang tắt",
        "adDisabledReason": "Artwork Doctor đang tắt — chưa push spec.",
        "pushed": "Đã push spec sang Artwork Doctor"
      },
      "errors": {
        "network": "Lỗi kết nối — kiểm tra mạng và thử lại.",
        "fieldRequired": "{{field}} là trường bắt buộc",
        "fieldInvalid": "{{field}} không hợp lệ — {{reason}}",
        "atPart": "Bộ phận {{n}}",
        "atLayer": "Lớp {{n}}",
        "atRegion": "Vùng {{n}}",
        "atArea": "Vùng in {{n}}",
        "areaIncomplete": "Vùng in {{n}}: {{fields}} — phải điền trước khi lưu",
        "unknownArea": "{{field}} không có trong danh mục Vùng in — hãy chọn một mục trong danh sách",
        "andMore": "…và {{n}} lỗi khác",
        "noArea": "Template phải có ít nhất một vùng in trước khi lưu."
      },
      "validation": {
        "artworkNoRegion": "Layer artwork ở part \"{{part}}\" cần ít nhất 1 vùng in có kích thước.",
        "artworkNoFile": "Layer artwork ở part \"{{part}}\" cần ít nhất 1 file."
      },
      "fields": {
        "area": "Vùng",
        "bbox": "Khung bao",
        "code": "Mã",
        "name": "Tên",
        "label": "Nhãn",
        "technique": "Kỹ thuật",
        "regions": "Vùng",
        "areas": "Vùng in",
        "layers": "Lớp",
        "parts": "Bộ phận",
        "type": "Loại",
        "productKind": "Nhóm sản phẩm",
        "side": "Mặt",
        "material": "Vật liệu",
        "role": "Vai trò",
        "imageUrl": "Ảnh",
        "validationRules": "Quy tắc kiểm tra",
        "width": "Chiều rộng",
        "height": "Chiều cao",
        "ppi": "PPI",
        "fileFormats": "Định dạng tệp"
      }
    },
    "wizard": {
      "pageTitle": "Tạo template mới",
      "pageSubtitle": "Khai báo thông tin chung, parts/layers và validation. Ảnh khu vực bổ sung ở trang chi tiết sau khi lưu.",
      "cancel": "Huỷ",
      "back": "← Quay lại",
      "next": "Tiếp tục →",
      "submit": "Tạo template",
      "submitting": "Đang tạo…",
      "stepCounter": "Bước {{current}} / {{total}}",
      "stepperAria": "Tiến trình tạo template",
      "generalInfo": "Thông tin chung",
      "steps": {
        "info": "Thông tin chung",
        "parts": "Parts & Layers",
        "validation": "Validation & Canvas"
      },
      "fields": {
        "nameEn": "Tên (EN) *",
        "code": "Mã *",
        "codePlaceholder": "tu-dong-tao-tu-ten",
        "codeHint": "Tự tạo từ Tên (EN). Có thể sửa tay. Chỉ a-z, A-Z, 0-9, dấu gạch dưới hoặc gạch nối (1-50 ký tự).",
        "aliasEn": "Biệt danh (EN)",
        "type": "Loại (Type) *",
        "side": "Mặt (Side)",
        "productKind": "Loại sản phẩm *",
        "nameVi": "Tên (VI)",
        "printTechnology": "Công nghệ in",
        "printTechnologyHint": "Chọn các công nghệ in mà template hỗ trợ (DTG/DTF/UV/Sublimation).",
        "descriptionEn": "Mô tả (EN)",
        "isActive": "Đang hoạt động"
      },
      "areaImageUploadFailed": "Tải ảnh khu vực thất bại",
      "invalidData": "Dữ liệu không hợp lệ.",
      "createdTitle": "Đã tạo Template",
      "createdDesc": "Mã: {{code}}. Tiếp tục bổ sung ảnh khu vực / vùng ở trang chi tiết.",
      "createFailed": "Tạo Template thất bại",
      "errors": {
        "network": "Lỗi kết nối — kiểm tra mạng và thử lại."
      }
    },
    "opacityPreview": {
      "areaPreviewAria": "Xem trước vùng template: {{code}}",
      "noImage": "Chưa có template image",
      "dropHint": "Kéo-thả file PNG vào đây hoặc bấm để chọn file. Tối đa 50 MB.",
      "chooseFile": "Chọn file",
      "regionsCountOne": "{{count}} vùng",
      "regionsCountOther": "{{count}} vùng",
      "replacePng": "Thay PNG",
      "status": {
        "preflight": "Kiểm tra file",
        "decoding": "Decode PNG",
        "classify": "Quét opacity",
        "label": "Tách vùng",
        "summarize": "Tổng hợp kết quả"
      },
      "warningLabel": "Cảnh báo:",
      "outOfRangeWarning": "{{count}} pixel nằm ngoài 5 mức opacity hợp lệ (±2% tolerance). File PNG phải chuẩn 5 mức opacity (0% / 40% / 60% / 80% / 100%). Không thể lưu template cho đến khi sửa file PNG.",
      "artworkAlt": "Artwork vùng template",
      "selectRegionAria": "Chọn vùng {{bucket}}",
      "bucket": {
        "1": "Nền",
        "2": "In: Vùng an toàn",
        "3": "In: Thường",
        "4": "Cắt: Bế",
        "5": "Cắt: Thường"
      }
    },
    "gridOverlay": {
      "uploadHint": "Upload ảnh template để xem vùng in",
      "contoursAlt": "Template kèm đường viền vùng",
      "flipTitle": "Lật {{name}} trong {{group}}",
      "overlapDetectedOne": "Phát hiện {{count}} vùng chồng lấn một phần",
      "overlapDetectedOther": "Phát hiện {{count}} vùng chồng lấn một phần",
      "regionTypes": {
        "C": "Cắt",
        "D": "Bế (die cut)",
        "P": "In",
        "S": "Vùng an toàn",
        "X": "Không dùng được"
      }
    },
    "nested": {
      "checkManifest": {
        "heading": "Check Manifest (Artwork Doctor)",
        "addLabel": "Thêm check (chọn loại kiểm tra)",
        "loadingOption": "Đang tải…",
        "selectPlaceholder": "— chọn check type —",
        "paramsSuffix": " · params",
        "add": "+ Thêm",
        "empty": "Chưa gắn check nào. Chọn loại kiểm tra ở trên để thêm.",
        "enabled": "bật",
        "remove": "Xoá",
        "severity": "mức độ",
        "severityOptions": {
          "error": "lỗi",
          "warning": "cảnh báo"
        },
        "part": "part",
        "selectPart": "— chọn part —",
        "layer": "layer (zIndex)",
        "selectLayer": "— chọn layer —",
        "region": "region",
        "selectRegion": "— chọn region —",
        "params": "Params"
      },
      "layerForm": {
        "zIndex": "zIndex *",
        "material": "Material *",
        "role": "Role *",
        "thickness": "thicknessMm",
        "printSides": "printSides",
        "printSidesCutOnly": "0 (chỉ cắt)",
        "alignTo": "alignTo (layer ref)",
        "alignToNone": "— không —",
        "alignToSymmetric": "symmetric",
        "files": "Files",
        "addFile": "+ File",
        "noFiles": "Chưa có file.",
        "fileKind": "kind",
        "fileSurface": "surface",
        "imageUrl": "imageUrl",
        "pngButton": "PNG…",
        "removeFile": "Xoá file",
        "opacityError": "Opacity-detect thất bại.",
        "opacityResult": "Phát hiện {{count}} region từ PNG.",
        "opacityBlocked": " (Có pixel ngoài dải — kiểm tra trước khi lưu.)",
        "mergeRegions": "Thêm vào regions",
        "opacityProgress": "Đang phân tích PNG… {{progress}}%",
        "regions": "Regions",
        "addRegion": "+ Region",
        "noRegions": "Chưa có region.",
        "removeLayer": "Xoá layer"
      },
      "partAccordion": {
        "heading": "Parts → Layers → Regions",
        "addPart": "+ Thêm part",
        "empty": "Chưa có part nào. Thêm part để bắt đầu.",
        "noCode": "(chưa có mã)",
        "layerCount": "({{count}} layers)",
        "defaultBadge": "mặc định",
        "legacyBadge": "part cũ không mặc định",
        "removePart": "Xoá part",
        "code": "Code * (slug)",
        "sortOrder": "sortOrder",
        "isDefault": "isDefault",
        "hasStand": "hasStand",
        "resizeArtwork": "Resize Artwork (AD tự co/giãn)",
        "anchorSize": "Anchor size (kích thước gốc, vd 12x12)",
        "label": "Label ({{lang}}{{required}})",
        "layers": "Layers",
        "addLayer": "+ Thêm layer",
        "noLayers": "Chưa có layer.",
        "regionCount": "({{count}} regions)"
      },
      "regionErrorAssign": {
        "heading": "Region errors (gán từ catalog)",
        "loading": "Đang tải catalog…",
        "empty": "Catalog chưa có error nào. Tạo ở “Region errors” (header)."
      },
      "regionForm": {
        "labelEn": "Label (EN)",
        "kind": "Kind *",
        "technique": "Technique",
        "techniqueBackground": "— (nền) —",
        "bbox": "bbox {{coord}}",
        "gridX": "gridX",
        "gridY": "gridY",
        "locked": "Locked",
        "contour": "Contour (JSON: [[x,y], …] — dán + validate)",
        "dependsOn": "dependsOn (region refs)",
        "removeRegion": "Xoá region"
      }
    },
    "canvas": {
      "areaBlock": {
        "addArea": "Thêm vùng",
        "activateAreaAria": "Kích hoạt vùng {{n}}",
        "areaTitle": "Vùng {{n}}",
        "uploadAria": "Tải ảnh mẫu lên",
        "upload": "Tải lên",
        "removeAreaAria": "Xóa vùng",
        "required": "Bắt buộc",
        "area": "Vùng",
        "fileFormat": "Định dạng tệp",
        "regionsTitle": "Vùng ({{count}})",
        "regionsEmpty": "Chưa có vùng nào cho khu vực này.",
        "regionRequired": "Bắt buộc",
        "regionOptional": "Tuỳ chọn",
        "toggleRegionsAria": "Hiện hoặc ẩn các vùng của khu vực {{n}}"
      },
      "areaFields": {
        "selectArea": "Chọn vùng…",
        "all": "Tất cả",
        "widthPx": "Rộng (px)",
        "heightPx": "Cao (px)",
        "dpi": "DPI"
      },
      "areaImageUpload": {
        "groupAria": "Ảnh nền của vùng",
        "uploadLabel": "Tải ảnh mẫu lên",
        "remove": "Xóa",
        "previewAlt": "Xem trước ảnh nền vùng",
        "noRouteTitle": "Không có đường dẫn tải về ở giao diện cho ID GridFS này (R2)",
        "previewUnavailable": "Chưa xem trước được — đang chờ endpoint tải lên",
        "dropzoneAria": "Bấm hoặc kéo thả để tải ảnh mẫu lên",
        "uploading": "Đang tải lên…",
        "clickOrDrag": "Bấm hoặc kéo thả để tải lên",
        "uploadEndpointPending": "Đang chờ endpoint tải lên"
      },
      "actionButtons": {
        "mismatch": "Mismatch ({{count}})",
        "semiFinish": "Semi-finish ({{count}})",
        "ungroup": "Bỏ nhóm"
      },
      "groupList": {
        "regionOne": "{{count}} vùng",
        "regionOther": "{{count}} vùng",
        "material": "Vật liệu",
        "none": "— Không —",
        "selectRegionsTitle": "Bấm để chọn các vùng trong nhóm này",
        "mismatchNoMaterial": "Mismatch — không cần vật liệu",
        "flip": "Lật",
        "empty": "Chưa có nhóm — chọn ≥2 vùng rồi bấm Semi-finish / Mismatch.",
        "materialOptions": {
          "wood": "Gỗ",
          "acrylic": "Acrylic"
        }
      },
      "areaDetail": {
        "legendCut": "C: Cắt ({{count}})",
        "legendPrint": "P: In ({{count}})",
        "all": "Tất cả",
        "canvasAria": "Khung vẽ vùng",
        "noRegion": "Chưa có region"
      },
      "regionBatchEdit": {
        "title": "Chi tiết region",
        "selectedCountOne": "Đã chọn {{count}} region",
        "selectedCountOther": "Đã chọn {{count}} region",
        "deselectAll": "Bỏ chọn tất cả",
        "emptyPrompt": "Chọn region trên canvas để chỉnh sửa",
        "label": "Nhãn",
        "technique": "Kỹ thuật",
        "required": "Bắt buộc",
        "modeLabel": {
          "label": "Nhãn, Bắt buộc, Lỗi",
          "required": "Bắt buộc",
          "regionError": "Lỗi region"
        }
      },
      "regionErrorChecklist": {
        "heading": "Lỗi region (gán hàng loạt)",
        "loading": "Đang tải catalog…",
        "empty": "Catalog chưa có lỗi nào. Tạo ở “Region errors” (header).",
        "severity": {
          "error": "lỗi",
          "warning": "cảnh báo"
        }
      },
      "regionFieldDropdowns": {
        "mixed": "— Hỗn hợp —",
        "noLabel": "(không nhãn)",
        "techniqueLabel": {
          "printNormal": "In: Thường",
          "printSafeZone": "In: Vùng an toàn",
          "cutNormal": "Cắt: Thường",
          "cutDieCut": "Cắt: Bế",
          "engraveNormal": "Khắc: Thường",
          "engraveDeep": "Khắc: Sâu",
          "background": "(nền)"
        }
      },
      "validationDetail": {
        "name": "Tên",
        "namePlaceholder": "Tên validation",
        "title": "Chi tiết validation",
        "export": "Xuất",
        "default": "Mặc định",
        "resize": "Đổi kích thước",
        "empty": "Chưa có validation — bấm + để tạo"
      },
      "validationTabs": {
        "tabAria": "Validation {{index}}",
        "defaultStarAria": "Validation mặc định",
        "deleteAria": "Xóa validation",
        "addAria": "Thêm validation",
        "confirmDeleteTitle": "Xóa validation?",
        "confirmDeleteBefore": "Đang xóa \"",
        "confirmDeleteAfter": "\" sẽ gỡ bỏ validation rule này cùng toàn bộ khu vực của nó. Không thể hoàn tác cho đến khi bạn lưu."
      },
      "groupConflict": {
        "semiConflict": "Các vùng đã chọn đang thuộc một nhóm semi khác",
        "mismatchConflict": "Các vùng đã chọn đang thuộc một nhóm mismatch khác",
        "semiCannotMismatch": "Các vùng trong cùng một nhóm semi không thể gộp mismatch với nhau",
        "mismatchCannotSemi": "Các vùng trong cùng một nhóm mismatch không thể gộp semi với nhau",
        "mismatchMinRegions": "Mismatch cần chọn ít nhất 2 vùng",
        "noMatch": "Các vùng đã chọn không khớp nhóm nào để gỡ"
      },
      "regionBox": {
        "needFlipAria": "Cần lật (mirror)"
      }
    },
    "contour": {
      "invalidJson": "JSON không hợp lệ: {{detail}}",
      "invalidJsonShort": "JSON không hợp lệ",
      "mustBePairs": "contour phải là mảng các cặp số [[x,y], …]"
    },
    "createDialog": {
      "namePlaceholder": "My Template"
    }
  },
  "option": {
    "title": "Quản lý Option",
    "subtitle": "Quản lý thuộc tính sản phẩm và danh mục Nhãn (Label) gom nhóm chúng.",
    "loading": "Đang tải…",
    "createdByAdmin": "Admin",
    "editAria": "Sửa {{name}}",
    "editTitle": "Sửa option + giá trị",
    "tabs": {
      "options": "Option",
      "labels": "Nhãn"
    },
    "search": {
      "placeholder": "Tìm theo tên..."
    },
    "filter": {
      "allLabels": "Tất cả nhãn"
    },
    "columns": {
      "label": "Nhãn",
      "name": "Tên Option",
      "values": "Giá trị",
      "createdDate": "Ngày tạo",
      "createdBy": "Người tạo/cập nhật",
      "actions": "Thao tác"
    },
    "empty": {
      "none": "Chưa có option nào. Dùng \"+ Thêm mới\" để tạo.",
      "noMatch": "Không có option nào khớp bộ lọc hiện tại."
    },
    "footer": {
      "total": "Tổng: {{count}}",
      "show": "Hiển thị:"
    },
    "types": {
      "color": "Màu sắc",
      "size": "Kích cỡ",
      "dimension": "Kích thước",
      "text": "Văn bản"
    },
    "status": {
      "active": "Đang hoạt động",
      "inactive": "Ngừng hoạt động"
    },
    "fields": {
      "code": "Mã",
      "label": "Nhãn",
      "status": "Trạng thái"
    },
    "actions": {
      "addNew": "+ Thêm mới",
      "cancel": "Huỷ",
      "save": "Lưu",
      "edit": "Sửa",
      "close": "Đóng",
      "enable": "Bật",
      "disable": "Tắt",
      "deleteOption": "Xoá option"
    },
    "pagination": {
      "first": "Trang đầu",
      "previous": "Trang trước",
      "next": "Trang sau",
      "last": "Trang cuối"
    },
    "values": {
      "none": "— chưa có giá trị —",
      "more": "+{{count}} nữa",
      "title": "Giá trị",
      "dialogTitle": "Giá trị của {{name}}",
      "dialogAria": "Toàn bộ giá trị của option này",
      "dialogCount": "{{count}} giá trị",
      "dialogClose": "Đóng"
    },
    "create": {
      "title": "Tạo option mới",
      "aria": "Tạo option",
      "nameEnLabel": "Tên option (EN)",
      "nameEnPlaceholder": "vd: Apparel Color",
      "nameViLabel": "Tên option (VI)",
      "nameViPlaceholder": "vd: Màu áo",
      "codePlaceholder": "tự sinh từ tên",
      "codeHint": "chữ_thường_snake_case, không đổi sau khi tạo.",
      "submit": "Tạo option",
      "submitting": "Đang tạo…"
    },
    "edit": {
      "title": "Sửa option — {{name}}",
      "aria": "Sửa option {{name}}",
      "nameEnLabel": "Tên (EN)",
      "nameViLabel": "Tên (VI)",
      "labelCode": "Nhãn / Mã",
      "immutable": "Không thể đổi sau khi tạo.",
      "noChanges": "Không có thay đổi để lưu",
      "save": "Lưu thay đổi",
      "saving": "Đang lưu…"
    },
    "value": {
      "labelEnLabel": "Nhãn (EN)",
      "labelEnPlaceholder": "vd: Yellow",
      "labelViLabel": "Nhãn (VI)",
      "labelViPlaceholder": "vd: Vàng",
      "codePlaceholder": "tự động",
      "add": "+ Thêm giá trị",
      "adding": "Đang thêm…",
      "loading": "Đang tải giá trị…",
      "empty": "Chưa có giá trị — thêm một giá trị ở trên.",
      "columns": {
        "label": "Nhãn",
        "position": "Vị trí",
        "status": "Trạng thái"
      },
      "hexLabel": "Mã màu (hex)",
      "hexPlaceholder": "#FF0000",
      "hexInvalid": "Mã màu không hợp lệ — dùng định dạng #RRGGBB",
      "hexNLabel": "Màu {{n}}",
      "hexOptional": "tuỳ chọn",
      "swatchImageLabel": "Ảnh swatch",
      "swatchUpload": "Tải lên",
      "swatchUploading": "Đang tải…",
      "swatchPreview": "Xem trước",
      "swatchUploadFailed": "Tải ảnh swatch thất bại"
    },
    "confirm": {
      "deleting": "Đang xoá…",
      "deleteOptionTitle": "Xoá option \"{{name}}\"?",
      "deleteOptionDesc": "Các biến thể đang dùng option này sẽ không thể chỉnh sửa sau đó. Hành động này là vĩnh viễn.",
      "deleteValue": "Xoá giá trị",
      "deleteValueTitle": "Xoá giá trị \"{{label}}\"?",
      "deleteValueDesc": "Nếu giá trị này đang gắn với một SKU hiện có, máy chủ sẽ chặn xoá với lỗi 409. Nếu không, giá trị sẽ bị xoá ngay."
    },
    "toast": {
      "nameRequired": "Cần nhập tên",
      "nameRequiredDesc": "Nhập tên option (EN).",
      "created": "Đã tạo option",
      "createdDesc": "{{name}} đã sẵn sàng để dùng.",
      "createFailed": "Tạo thất bại",
      "networkError": "Lỗi mạng",
      "updated": "Đã cập nhật option",
      "saveFailed": "Lưu thất bại",
      "deleted": "Đã xoá option",
      "deleteFailed": "Xoá thất bại",
      "labelRequired": "Cần nhập nhãn",
      "valueAdded": "Đã thêm giá trị",
      "addValueFailed": "Thêm giá trị thất bại",
      "valueUpdated": "Đã cập nhật giá trị",
      "saveValueFailed": "Lưu giá trị thất bại",
      "valueDeleted": "Đã xoá giá trị",
      "deleteValueFailed": "Xoá giá trị thất bại",
      "toggleFailed": "Đổi trạng thái thất bại"
    },
    "variantsFacetAssign": {
      "saveSuccess": "Đã lưu phân công",
      "saveErrorTitle": "Không lưu được phân công",
      "networkCheckError": "Lỗi mạng — kiểm tra kết nối",
      "title": "Gán merchant — {{name}}",
      "hint": "Bố cục lật — chọn biến thể trước, sau đó chọn merchant để gán hàng loạt. Tổng {{count}} biến thể.",
      "selectVariantsHeading": "1. Chọn biến thể (đã chọn {{count}})",
      "selectAllVisible": "Chọn tất cả đang hiển thị",
      "clearSelected": "Xoá chọn ({{count}})",
      "variantSearchPlaceholder": "Tìm biến thể…",
      "axis": {
        "color": "Màu",
        "size": "Kích cỡ"
      },
      "axisOption": "{{label}}: tất cả",
      "showHidden": "Hiện biến thể ẩn",
      "noVariantMatch": "Không có biến thể nào khớp bộ lọc.",
      "hiddenBadge": "Ẩn",
      "selectMerchantsHeading": "2. Chọn merchant (đã chọn {{count}})",
      "merchantSearchPlaceholder": "Tìm merchant…",
      "noMerchant": "Không có merchant.",
      "bulkApplyLabel": "Gán hàng loạt: {{variants}} biến thể × {{merchants}} merchant",
      "bulkApplyHint": "Gộp với phân công hiện tại (không ghi đè merchant đã gán ở biến thể khác).",
      "saving": "Đang lưu…",
      "apply": "Áp dụng",
      "currentToggle": "Phân công hiện tại — {{blueprint}} cấp blueprint · {{variant}} cấp biến thể",
      "noAssignment": "Chưa có phân công nào.",
      "blueprintLevel": "Cấp blueprint:",
      "merchantCount": "{{count}} merchant",
      "close": "Đóng",
      "loadingMerchants": "Đang tải danh sách merchant…",
      "directoryError": "Không tải được danh bạ merchant. Kiểm tra kết nối rồi thử lại.",
      "noSearchMatch": "Không có merchant nào khớp “{{term}}”.",
      "selectedAcrossPages": "Đã chọn {{count}} merchant, tính cả những merchant ở trang khác."
    },
    "variantsFacetTable": {
      "axis": {
        "color": "Màu",
        "size": "Kích cỡ",
        "stockStatus": "Tồn kho"
      },
      "axisOption": "{{label}}: tất cả",
      "warningHuge": "⚠ {{count}} SKU — Cảnh báo >500 biến thể",
      "warningLarge": "⚠ {{count}} SKU (blueprint lớn)",
      "searchPlaceholder": "Tìm SKU / màu / kích cỡ…",
      "clearFilters": "Xoá bộ lọc",
      "showingCount": "Hiển thị {{shown}} / {{total}}",
      "colSku": "SKU",
      "colColor": "Màu",
      "colSize": "Kích cỡ",
      "colStock": "Tồn kho",
      "colMerchants": "Merc.",
      "noVariantMatch": "Không có biến thể nào khớp bộ lọc.",
      "stockStatus": {
        "Discontinued": "Ngừng kinh doanh",
        "Hidden": "Ẩn"
      }
    },
    "list": {
      "pageTitle": "Options",
      "pageSubtitle": "Quản lý thuộc tính option của sản phẩm, danh sách giá trị, nhãn và option biến thể fulfillment.",
      "tabOptions": "Options",
      "tabLabels": "Nhãn Option",
      "searchPlaceholder": "Tìm Option...",
      "searchAria": "Tìm option theo tên",
      "filterLabelAll": "Nhãn Option: Tất cả",
      "filterLabelAria": "Lọc theo nhãn option",
      "filterUpdatedByAll": "Cập nhật bởi: Tất cả",
      "filterUpdatedByAria": "Lọc theo người sửa cuối",
      "filterLastUpdatedAll": "Cập nhật cuối: Tất cả",
      "filterDateClear": "Xoá",
      "filterDateClearAria": "Xoá bộ lọc Cập nhật gần nhất",
      "filterLoading": "Đang tải…",
      "createAction": "Tạo Option",
      "working": "Đang lưu…",
      "colLabel": "Nhãn",
      "colName": "Tên Option",
      "colValues": "Giá trị Option",
      "colCreated": "Ngày tạo",
      "colLastUpdated": "Cập nhật cuối",
      "colUpdatedBy": "Cập nhật bởi",
      "colStatus": "Trạng thái",
      "colActions": "Hành động",
      "noValues": "chưa có giá trị",
      "showAllValuesAria": "Xem toàn bộ giá trị của {{name}}",
      "expandValuesAria": "Xem thêm {{count}} giá trị của {{name}}",
      "collapseValues": "Thu gọn",
      "statusToggleAria": "Bật/tắt trạng thái của {{name}}",
      "editAria": "Sửa {{name}}",
      "statusSaved": "Đã cập nhật trạng thái.",
      "statusFailed": "Không cập nhật được trạng thái.",
      "createSaved": "Đã tạo option.",
      "updateSaved": "Đã cập nhật option.",
      "saveFailed": "Không lưu được option.",
      "loadError": "Không tải được danh sách option.",
      "retry": "Thử lại",
      "empty": "Không có option nào khớp bộ lọc hiện tại.",
      "rowsPerPage": "Số dòng mỗi trang:",
      "showingRange": "Đang xem {{from}}–{{to}} trên {{total}} option",
      "paginationAria": "Phân trang option",
      "prevPage": "Trang trước",
      "nextPage": "Trang sau",
      "updatedByTooltip": "{{email}} — sửa cuối {{at}}",
      "filterDateCancel": "Huỷ",
      "filterDateApply": "Áp dụng",
      "filterDatePresetToday": "Hôm nay",
      "filterDatePresetYesterday": "Hôm qua",
      "filterDatePresetLast7": "7 ngày qua",
      "filterDatePresetLast30": "30 ngày qua"
    },
    "form": {
      "createTitle": "Tạo Option",
      "editTitle": "Cập nhật Option",
      "labelLabel": "Nhãn Option",
      "labelRequired": "Vui lòng chọn nhãn option.",
      "labelsLoading": "Đang tải nhãn option…",
      "labelsEmpty": "Chưa có nhãn option nào đang bật — thêm ở tab Nhãn Option trước.",
      "nameLabel": "Tên Option",
      "namePlaceholder": "Nhập tên option",
      "nameHint": "Tên dùng để quản lý Option này trong hệ thống Admin.",
      "nameRequired": "Vui lòng nhập Nhãn lựa chọn.",
      "valuesTitle": "Giá trị Option",
      "valuesSubtitle": "Thêm giá trị cho option này. Mỗi giá trị sẽ được dùng để tạo biến thể và sinh SKU.",
      "addValueLabel": "Thêm giá trị",
      "addValuePlaceholder": "Nhập giá trị rồi nhấn Enter",
      "valuesRequired": "Vui lòng nhập tối thiểu 01 giá trị.",
      "valueDuplicate": "Giá trị \"{{code}}\" đã có trong danh sách.",
      "valueCodeInvalid": "Giá trị này không có chữ hoặc số nào để tạo mã.",
      "colHex": "Màu HEX",
      "colCode": "Mã",
      "colDisplayName": "Tên hiển thị",
      "colRemove": "Xoá giá trị",
      "codeLocked": "Không sửa được Mã sau khi giá trị đã lưu.",
      "hexAria": "Màu HEX của {{code}}",
      "hexPickerAria": "Chọn màu cho {{code}}",
      "removeValueAria": "Xoá giá trị {{code}}",
      "cancel": "Huỷ",
      "save": "Lưu",
      "labelLocked": "Không đổi được nhãn tuỳ chọn sau khi đã tạo.",
      "hexNAria": "Màu HEX {{n}} của {{code}}",
      "hexPickerNAria": "Chọn màu {{n}} của {{code}}",
      "addHexAria": "Thêm một màu nữa cho {{code}}",
      "addHexTitle": "Thêm màu (tối đa {{max}})",
      "removeHexAria": "Xoá màu {{n}} của {{code}}",
      "hexInvalid": "\"{{value}}\" không phải mã HEX hợp lệ — dùng dạng #RRGGBB.",
      "hexRequired": "Giá trị màu phải có ít nhất một mã HEX."
    }
  },
  "location": {
    "status": {
      "active": "Đang hoạt động",
      "inactive": "Ngừng hoạt động"
    },
    "fields": {
      "addrLine1": "Địa chỉ (line 1)",
      "addrLine2": "Địa chỉ (line 2)",
      "addressHeading": "Địa chỉ kho (ship-from)",
      "city": "Thành phố",
      "code": "Mã (không đổi)",
      "country": "Quốc gia",
      "countryIso": "Quốc gia (ISO-2)",
      "descriptionEn": "Mô tả (EN)",
      "descriptionVi": "Mô tả (VI)",
      "latitude": "Vĩ độ",
      "logisticsHeading": "Vận hành",
      "longitude": "Kinh độ",
      "name": "Tên",
      "state": "Bang",
      "status": "Trạng thái",
      "timezone": "Múi giờ",
      "zip": "Mã ZIP"
    },
    "placeholders": {
      "addrLine1": "VD: 7510 Garden Grove Blvd",
      "addrLine2": "Tuỳ chọn (Unit/Suite…)",
      "city": "Westminster",
      "country": "Gõ để tìm (vd: Vi, Vietnam, VN)",
      "countrySelect": "Chọn quốc gia",
      "countrySearch": "Gõ để tìm (vd: VN, Vietnam)",
      "descriptionEn": "Ví dụ: Trung tâm xử lý chính phục vụ Đông Nam Á",
      "descriptionVi": "Mô tả tiếng Việt (tùy chọn)",
      "name": "Nhập tên",
      "timezone": "Gõ để tìm (vd: Ho_Chi_Minh, Tokyo, UTC)",
      "timezoneSelect": "Chọn múi giờ"
    },
    "actions": {
      "cancel": "Hủy",
      "delete": "Xóa",
      "create": "Tạo",
      "save": "Lưu",
      "saveChanges": "Lưu thay đổi",
      "saving": "Đang lưu…",
      "newLocation": "Tạo địa điểm"
    },
    "toast": {
      "createFailed": "Không tạo được địa điểm",
      "created": "Đã tạo địa điểm",
      "statusUpdated": "Đã cập nhật trạng thái",
      "toggleFailed": "Đổi trạng thái thất bại",
      "updateFailed": "Không cập nhật được địa điểm",
      "updated": "Đã cập nhật địa điểm"
    },
    "form": {
      "description": "Thêm một địa điểm mới vào hệ thống.",
      "editSubtitle": "Cập nhật thông tin và cấu hình của địa điểm.",
      "editTitle": "Cập nhật địa điểm",
      "errors": {
        "nameRequired": "Vui lòng nhập tên",
        "countryIso": "Quốc gia phải là mã ISO 2 chữ cái (vd: VN, US)",
        "coordsNumeric": "Tọa độ phải là số",
        "coordsRange": "Tọa độ ngoài phạm vi cho phép",
        "submitFailed": "Gửi thất bại",
        "fieldRequired": "{{field}} là trường bắt buộc.",
        "addressIncomplete": "Địa chỉ kho cần đủ Thành phố, Bang và Mã ZIP.",
        "invalidTimezone": "Múi giờ phải là mã IANA hợp lệ (vd: Asia/Ho_Chi_Minh) — chọn trong danh sách, không kèm phần lệch giờ.",
        "descriptionEnRequired": "Mô tả phải có bản tiếng Anh — chỉ điền ô tiếng Việt thì không lưu được.",
        "imageRequired": "Hãy chọn ảnh cho địa điểm này."
      },
      "imageChange": "Đổi ảnh",
      "imageCurrent": "Ảnh hiện tại",
      "imageDropzone": "Bấm để tải lên hoặc kéo thả vào đây",
      "imageDropzoneHint": "PNG, JPG tối đa {{max}}",
      "imageLabel": "Ảnh",
      "countryLockedHint": "Không đổi được quốc gia sau khi đã tạo địa điểm — pool nhà cung cấp, phí vận chuyển và quy tắc thuế đều gắn theo nó.",
      "countryNoMatch": "Không có quốc gia phù hợp.",
      "imageRemove": "Xoá",
      "imageSizeError": "Ảnh phải nhỏ hơn hoặc bằng {{max}}.",
      "imageTypeError": "Chỉ nhận ảnh PNG, JPG hoặc WebP.",
      "imageUploadAria": "Tải ảnh địa điểm lên",
      "imageUploadError": "Không tải được ảnh lên.",
      "imageUploading": "Đang tải lên…",
      "moreSettings": "Cài đặt thêm",
      "newTitle": "Tạo địa điểm"
    },
    "list": {
      "activeToggleAria": "Bật/tắt hoạt động cho {{code}}",
      "columns": {
        "nameCode": "Tên / Mã",
        "country": "Quốc gia",
        "timezone": "Múi giờ",
        "status": "Trạng thái",
        "active": "Hoạt động",
        "image": "Ảnh",
        "name": "Tên",
        "code": "Mã",
        "createdDate": "Ngày tạo",
        "creator": "Người tạo",
        "action": "Thao tác"
      },
      "editAria": "Sửa địa điểm {{code}}",
      "empty": "Không có địa điểm nào khớp với bộ lọc hiện tại.",
      "filters": {
        "search": "Tìm kiếm",
        "searchPlaceholder": "Tìm theo mã, tên…",
        "country": "Quốc gia",
        "anyPlaceholder": "Tất cả",
        "status": "Trạng thái",
        "allStatuses": "Trạng thái: Tất cả",
        "searchAria": "Tìm địa điểm",
        "statusAria": "Lọc theo trạng thái"
      },
      "heading": "Địa điểm",
      "loadFailed": "Tải thất bại",
      "loading": "Đang tải…",
      "nextPage": "Trang sau",
      "paginationAria": "Phân trang địa điểm",
      "prevPage": "Trang trước",
      "retry": "Thử lại",
      "rowsPerPage": "Số dòng mỗi trang:",
      "showingRange": "Đang xem {{from}}–{{to}} trong {{total}} địa điểm",
      "subtitle": "Quản lý địa điểm sản xuất, cấu hình theo quốc gia và các nhà máy.",
      "vendorsAria": "Xem nhà cung cấp của {{name}}",
      "working": "Đang xử lý…"
    },
    "toggle": {
      "deactivate": "Ngừng hoạt động",
      "activate": "Kích hoạt",
      "deactivateTitle": "Ngừng hoạt động địa điểm?",
      "activateTitle": "Kích hoạt địa điểm?",
      "deactivateDesc": "Các blueprint đã liên kết với địa điểm này vẫn giữ tham chiếu nhưng địa điểm sẽ biến mất khỏi danh sách chọn cho tới khi được kích hoạt lại.",
      "activateDesc": "Địa điểm sẽ lại có thể chọn trong danh sách của blueprint."
    },
    "detail": {
      "toast": {
        "saved": "Đã lưu",
        "saveFailed": "Lưu thất bại",
        "deleted": "Đã xóa địa điểm",
        "deleteFailed": "Xóa thất bại"
      },
      "notFound": "Không tìm thấy địa điểm.",
      "backToList": "← Quay lại danh sách",
      "backToLocations": "← Quay lại Địa điểm",
      "deleteTitle": "Xóa địa điểm?",
      "deleteDesc": "Xóa mềm {{code}} — {{name}}. Các blueprint đã liên kết vẫn giữ id nhưng địa điểm sẽ ngừng hiển thị trong danh sách của admin."
    },
    "vendors": {
      "colCode": "Mã",
      "colCreated": "Ngày tạo",
      "colName": "Tên nhà cung cấp",
      "colStatus": "Trạng thái",
      "colUpdated": "Cập nhật cuối",
      "colUpdatedBy": "Người cập nhật",
      "empty": "Chưa có nhà cung cấp nào đăng ký tại {{country}}.",
      "loadFailed": "Không tải được danh sách nhà cung cấp.",
      "paginationAria": "Phân trang nhà cung cấp",
      "reactivateConfirm": "Kích hoạt lại",
      "reactivateDesc": "Nhà cung cấp nhận đơn trở lại. Nhà cung cấp bị ngưng vĩnh viễn thì không kích hoạt lại ở đây được.",
      "reactivateTitle": "Kích hoạt lại {{name}}?",
      "reasonHint": "Tối thiểu {{min}} ký tự — nội dung này được lưu vào lịch sử tạm ngưng.",
      "reasonLabel": "Lý do",
      "reasonPlaceholderReactivate": "Ghi chú (không bắt buộc) cho nhật ký",
      "reasonPlaceholderSuspend": "Vì sao tạm ngưng nhà cung cấp này?",
      "reasonTooShort": "Lý do cần ít nhất {{min}} ký tự.",
      "showingRange": "Đang xem {{from}}–{{to}} trong {{total}} nhà cung cấp",
      "status": {
        "active": "Đang hoạt động",
        "inactive": "Ngừng hoạt động",
        "pending_activation": "Chờ kích hoạt",
        "suspended": "Bị tạm ngưng"
      },
      "statusLocked": "{{name}} đang {{status}} — việc kích hoạt làm ở trang nhà cung cấp, không phải ở đây",
      "statusSwitchAria": "{{name}} đang {{status}} — bấm để đổi",
      "subtitle": "Các nhà cung cấp đăng ký tại {{country}} — quốc gia mà địa điểm sản xuất này phụ trách.",
      "suspendConfirm": "Tạm ngưng",
      "suspendDesc": "Nhà cung cấp sẽ ngừng nhận đơn mới. Thời gian tạm ngưng tăng dần theo số lần bị ngưng.",
      "suspendTitle": "Tạm ngưng {{name}}?",
      "title": "Nhà cung cấp — {{name}}",
      "toast": {
        "suspended": "Đã tạm ngưng {{name}}",
        "reactivated": "Đã kích hoạt lại {{name}}",
        "suspendFailed": "Không tạm ngưng được nhà cung cấp",
        "reactivateFailed": "Không kích hoạt lại được nhà cung cấp"
      },
      "refreshing": "Đang làm mới danh sách…"
    }
  },
  "print_area": {
    "title": "Vùng in (Print Areas)",
    "subtitlePre": "Danh mục vùng in dùng cho Khu vực kiểm tra của template.",
    "subtitlePost": "là định danh máy cố định sau khi tạo; chỉ sửa được Nhãn và Thứ tự.",
    "actions": {
      "create": "Print Area mới"
    },
    "columns": {
      "code": "Code",
      "label": "Nhãn",
      "order": "Thứ tự",
      "status": "Trạng thái",
      "actions": "Thao tác"
    },
    "empty": "Chưa có print area nào.",
    "status": {
      "active": "Hoạt động",
      "archived": "Đã lưu trữ"
    },
    "rowActions": {
      "edit": "Sửa",
      "archive": "Lưu trữ",
      "unarchive": "Bỏ lưu trữ",
      "delete": "Xoá"
    },
    "form": {
      "createTitle": "Print area mới",
      "editTitle": "Sửa print area",
      "codeLabel": "Code",
      "codePlaceholder": "vd: chest_pocket",
      "codeImmutableHint": "Code không đổi được sau khi tạo (định danh máy).",
      "labelLabel": "Nhãn",
      "orderLabel": "Thứ tự sắp xếp",
      "orderPlaceholder": "để trống → thêm vào cuối",
      "archivedLabel": "Đã lưu trữ (ẩn khỏi dropdown Khu vực kiểm tra mới)",
      "cancel": "Huỷ",
      "save": "Lưu",
      "saving": "Đang lưu…"
    },
    "delete": {
      "title": "Xoá print area?",
      "description": "Chỉ print area chưa được tham chiếu mới xoá được. Nếu đang được dùng, hãy lưu trữ thay vì xoá để giữ tham chiếu.",
      "confirm": "Xoá",
      "cancel": "Huỷ"
    },
    "validation": {
      "codePattern": "Code phải bắt đầu bằng chữ hoặc số, phần còn lại chỉ gồm chữ, số, gạch dưới và gạch ngang.",
      "codeRequired": "Code là bắt buộc.",
      "labelRequired": "Nhãn là bắt buộc.",
      "sortOrderInteger": "Thứ tự phải là số nguyên."
    },
    "toast": {
      "loadFail": "Không tải được danh sách print area",
      "saveFail": "Lưu thất bại",
      "created": "Đã tạo print area",
      "updated": "Đã cập nhật print area",
      "statusFail": "Cập nhật trạng thái thất bại",
      "archived": "Đã lưu trữ print area",
      "unarchived": "Đã bỏ lưu trữ",
      "deleteFail": "Xoá thất bại",
      "deleted": "Đã xoá print area"
    }
  },
  "label": {
    "searchPlaceholder": "Tìm nhãn…",
    "actions": {
      "add": "Thêm nhãn"
    },
    "columns": {
      "name": "Tên",
      "code": "Code",
      "status": "Trạng thái",
      "actions": "Thao tác",
      "lastUpdate": "Cập nhật lần cuối"
    },
    "loading": "Đang tải nhãn…",
    "emptyNone": "Chưa có nhãn nào. Thêm một nhãn để bắt đầu nhóm các option.",
    "emptySearch": "Không có nhãn nào khớp với tìm kiếm.",
    "status": {
      "Active": "Hoạt động",
      "Inactive": "Ngừng"
    },
    "rowActions": {
      "edit": "Sửa"
    },
    "dialog": {
      "editTitle": "Sửa nhãn",
      "createTitle": "Tạo nhãn mới"
    },
    "form": {
      "nameLabel": "Tên",
      "namePlaceholder": "Nhập tên nhãn",
      "codeLabel": "Code",
      "codePlaceholder": "Tự sinh từ tên",
      "codeHint": "Tự sinh từ tên. Không sửa được.",
      "cancel": "Huỷ",
      "saving": "Đang lưu…",
      "saveChanges": "Lưu thay đổi",
      "creating": "Đang tạo…",
      "createLabel": "Tạo nhãn",
      "nameHint": "Tên hiển thị khi chọn nhãn cho option."
    },
    "validation": {
      "nameRequired": "Tên là bắt buộc",
      "codeFormat": "Code phải là lowercase_snake_case",
      "codeFormatDesc": "Chỉ gồm chữ thường, số, gạch dưới; phải bắt đầu bằng chữ cái.",
      "codeRequired": "Code là bắt buộc"
    },
    "toast": {
      "updated": "Đã cập nhật nhãn",
      "created": "Đã tạo nhãn",
      "updateFailed": "Cập nhật thất bại",
      "createFailed": "Tạo thất bại",
      "deleted": "Đã xoá nhãn",
      "deleteFailed": "Xoá thất bại",
      "unknownError": "Lỗi không xác định",
      "statusSaved": "Đã cập nhật trạng thái nhãn",
      "statusFailed": "Không cập nhật được trạng thái nhãn"
    },
    "statusToggleAria": "Bật/tắt trạng thái cho {{name}}",
    "editAria": "Sửa nhãn {{name}}",
    "loadError": "Không tải được danh sách nhãn.",
    "retry": "Thử lại",
    "rowsPerPage": "Số dòng mỗi trang",
    "showingRange": "Hiển thị {{from}}–{{to}} trong {{total}} nhãn",
    "prevPage": "Trang trước",
    "nextPage": "Trang sau",
    "paginationAria": "Phân trang danh sách nhãn"
  },
  "material": {
    "title": "Vật liệu (Materials)",
    "subtitle": "Danh mục vật liệu dùng cho lớp template (gỗ, acrylic, vải…). Layer tham chiếu tới vật liệu ở đây.",
    "actions": {
      "create": "Vật liệu mới"
    },
    "empty": "Chưa có vật liệu nào.",
    "columns": {
      "code": "Code",
      "name": "Tên",
      "group": "Nhóm",
      "thickness": "Độ dày (mm)",
      "engravable": "Khắc được",
      "status": "Trạng thái",
      "actions": "Thao tác"
    },
    "status": {
      "active": "Hoạt động",
      "inactive": "Ngừng"
    },
    "rowActions": {
      "edit": "Sửa",
      "delete": "Xoá"
    },
    "form": {
      "createTitle": "Vật liệu mới",
      "editTitle": "Sửa vật liệu",
      "codeLabel": "Code",
      "codePlaceholder": "vd: clear_acrylic",
      "nameEnLabel": "Tên (EN)",
      "nameViLabel": "Tên (VI)",
      "groupLabel": "Nhóm",
      "groupPlaceholder": "acrylic / wood / fabric",
      "thicknessLabel": "Độ dày (mm)",
      "thicknessPlaceholder": "để trống nếu không áp dụng",
      "engravableLabel": "Khắc được",
      "activeLabel": "Đang hoạt động",
      "cancel": "Huỷ",
      "save": "Lưu",
      "saving": "Đang lưu…"
    },
    "delete": {
      "title": "Xoá vật liệu?",
      "description": "Vật liệu sẽ bị xoá khỏi danh mục (xoá mềm). Layer đang dùng vẫn giữ tham chiếu cũ.",
      "confirm": "Xoá",
      "cancel": "Huỷ"
    },
    "validation": {
      "required": "Code và Tên (EN) là bắt buộc"
    },
    "toast": {
      "loadFail": "Không tải được danh sách vật liệu",
      "saveFail": "Lưu thất bại",
      "created": "Đã tạo vật liệu",
      "updated": "Đã cập nhật vật liệu",
      "deleteFail": "Xoá thất bại",
      "deleted": "Đã xoá vật liệu"
    }
  },
  "check_type": {
    "title": "Loại kiểm tra (Check Types)",
    "subtitle": "Danh mục kiểm tra của Artwork Doctor. Bật/tắt (checklist) hoặc có tham số (vd nét tối thiểu). Admin tự thêm khi sản phẩm mới sinh ra kiểm tra mới.",
    "actions": {
      "create": "Loại kiểm tra mới"
    },
    "empty": "Chưa có loại kiểm tra nào.",
    "columns": {
      "code": "Code",
      "label": "Nhãn",
      "scope": "Phạm vi",
      "params": "Tham số",
      "severity": "Mức độ",
      "status": "Trạng thái",
      "actions": "Thao tác"
    },
    "status": {
      "active": "Hoạt động",
      "inactive": "Ngừng"
    },
    "rowActions": {
      "edit": "Sửa",
      "delete": "Xoá"
    },
    "form": {
      "createTitle": "Loại kiểm tra mới",
      "editTitle": "Sửa loại kiểm tra",
      "codeLabel": "Code",
      "codePlaceholder": "vd: MIN_STROKE_SIZE",
      "labelEnLabel": "Nhãn (EN)",
      "labelViLabel": "Nhãn (VI)",
      "scopeLabel": "Phạm vi",
      "severityLabel": "Mức độ mặc định",
      "severityError": "error (chặn)",
      "severityWarning": "warning (cảnh báo)",
      "hasParamsLabel": "Có tham số (chế độ param) — bỏ chọn = checklist bật/tắt",
      "paramsTitle": "Tham số (key → kiểu)",
      "addParam": "Thêm tham số",
      "paramKeyPlaceholder": "vd: minCm",
      "activeLabel": "Đang hoạt động",
      "cancel": "Huỷ",
      "save": "Lưu",
      "saving": "Đang lưu…"
    },
    "delete": {
      "title": "Xoá loại kiểm tra?",
      "description": "Loại kiểm tra sẽ bị xoá khỏi registry (xoá mềm).",
      "confirm": "Xoá",
      "cancel": "Huỷ"
    },
    "validation": {
      "required": "Code và Nhãn (EN) là bắt buộc",
      "paramsRequired": "Chế độ tham số cần ít nhất 1 tham số"
    },
    "toast": {
      "loadFail": "Không tải được danh sách loại kiểm tra",
      "saveFail": "Lưu thất bại",
      "created": "Đã tạo loại kiểm tra",
      "updated": "Đã cập nhật loại kiểm tra",
      "deleteFail": "Xoá thất bại",
      "deleted": "Đã xoá loại kiểm tra"
    }
  },
  "opacity": {
    "preflight": {
      "invalidMime": "Chỉ chấp nhận file PNG (image/png). File này có MIME: {{mime}}.",
      "unknownMime": "không xác định",
      "tooLarge": "Kích thước file vượt quá {{mb}} MB."
    },
    "decode": {
      "failed": "Không thể decode PNG: {{detail}}",
      "badDimensions": "PNG có kích thước không hợp lệ.",
      "noCanvas": "Trình duyệt không hỗ trợ canvas 2D.",
      "noAlpha": "PNG không có alpha channel (toàn pixel opaque). Template cần PNG có nhiều mức trong suốt."
    },
    "worker": {
      "runtimeError": "Worker khởi tạo thất bại."
    }
  },
  "blueprintWizard": {
    "title": "Vận chuyển & phí",
    "subtitle": "Dịch vụ hoả tốc, hải quan và phí xử lý cho blueprint này.",
    "hsCodeLabel": "Mã HS",
    "hsCodePlaceholder": "ví dụ 6109.10",
    "handleFeeLabel": "Phí xử lý",
    "rushSectionLabel": "Phí dịch vụ hoả tốc",
    "rushServiceLabel": "Dịch vụ",
    "rushFeeLabel": "Phí hoả tốc",
    "rushFeePlaceholder": "0.00",
    "rushDeadlineLabel": "Hạn hoả tốc (giờ)",
    "addRush": "Thêm bậc hoả tốc",
    "removeRush": "Xoá",
    "samplePolicyLabel": "Chính sách mẫu",
    "samplePolicies": {
      "none": "Không mẫu",
      "chargeable": "Tính phí",
      "free_first": "Mẫu đầu miễn phí"
    },
    "accessorySectionLabel": "Phụ kiện",
    "isAccessoryLabel": "Blueprint này là phụ kiện đi kèm",
    "chargeAdditionalFromQtyLabel": "Tính phí vận chuyển thêm từ số lượng",
    "services": {
      "ECONOMY": "Tiết kiệm",
      "STANDARD": "Tiêu chuẩn",
      "PRIORITY": "Ưu tiên",
      "NEXT_DAY": "Qua đêm"
    }
  },
  "tiktokLabelEntitlement": {
    "_vgBinding": "vg-binding: P14.1.D-36 — Merchant Detail tiktokLabelEntitled toggle (label-provided shipping bypass grant) across en/vi/fr",
    "title": "Miễn phí ship cho đơn dùng label có sẵn",
    "ariaLabel": "Bật/tắt quyền dùng label có sẵn",
    "readOnly": "Bạn không có quyền thay đổi cài đặt này.",
    "states": {
      "on": "Được cấp quyền",
      "off": "Chưa cấp quyền"
    },
    "helper": {
      "on": "Đơn upload label ship (TikTok, Etsy, tự mua) không tính phí ship và phụ phí ship mùa vụ — chỉ thu 1 phí handling mỗi đơn.",
      "off": "Đơn dùng label vẫn tính phí ship bình thường. Bật để merchant này dùng label upload (TikTok, Etsy, tự mua) và chỉ trả phí handling."
    },
    "toasts": {
      "saved": "Đã cập nhật quyền dùng label.",
      "error": "Cập nhật quyền dùng label thất bại."
    }
  },
  "tierFeeTable": {
    "colArea": "Vùng",
    "colAdditionalFee": "Giá",
    "colRequired": "Bắt buộc",
    "requiredToggleAria": "Bật/tắt bắt buộc cho {{name}}",
    "feeInputAria": "Phí thêm tier {{tier}} cho {{name}}",
    "expand": "Mở rộng {{name}}",
    "collapse": "Thu gọn {{name}}",
    "colDisplay": "Hiển thị",
    "displayToggleAria": "Hiển thị {{name}} trên trang bán hàng",
    "selectAllAria": "Chọn tất cả dòng",
    "selectRowAria": "Chọn {{name}}",
    "selectedCount": "Đã chọn {{count}} vùng in",
    "basePriceAria": "Giá của {{name}}",
    "tierRequiredAria": "Bật/tắt bắt buộc cho {{name}} ở tier {{tier}}",
    "tierDisplayAria": "Hiển thị {{name}} trên trang bán hàng cho tier {{tier}}",
    "areaFlagScopeHint": "Required / Display áp dụng cho mọi location",
    "tierFlagScopeHint": "Switch theo tier chỉ áp dụng cho location này"
  },
  "blueprintLogistics": {
    "columnSku": "SKU",
    "columnStatus": "Trạng thái",
    "columnShippingFee": "Phí ship ($)",
    "columnSeasonalFee": "Phí mùa vụ ($)",
    "columnAdditionalFee": "Phí phát sinh ($)",
    "columnReciprocalTariff": "Thuế đối ứng ($)",
    "defaultLabel": "Mặc định",
    "empty": "Chưa có SKU — chọn option ở block Options trước.",
    "selectAllAria": "Chọn tất cả SKU",
    "selectRowAria": "Chọn {{sku}}",
    "statusToggleAria": "Bật/tắt {{sku}}",
    "servicesLoading": "Đang tải shipping service…",
    "noServices": "Chưa có shipping service nào — thêm ở Shipping → Methods."
  },
  "accessoryFeeTable": {
    "colAccessory": "Phụ kiện",
    "colPrice": "Giá",
    "colShippingFee": "Phí vận chuyển",
    "colMinQty": "SL tối thiểu",
    "colMaxQty": "SL tối đa",
    "colRequired": "Bắt buộc",
    "removeAria": "Xoá {{name}}",
    "collapse": "Thu gọn {{name}}",
    "expand": "Mở rộng {{name}}",
    "priceAria": "Giá của {{name}}, bậc {{tier}}",
    "shippingAria": "Phí vận chuyển của {{name}}, bậc {{tier}}",
    "minQtyAria": "Số lượng tối thiểu của {{name}}",
    "maxQtyAria": "Số lượng tối đa của {{name}}",
    "requiredAria": "Bắt buộc có {{name}} trong mọi đơn",
    "tierMinQtyAria": "Số lượng tối thiểu của {{name}}, bậc {{tier}}",
    "tierMaxQtyAria": "Số lượng tối đa của {{name}}, bậc {{tier}}",
    "tierRequiredAria": "Bắt buộc có {{name}} với bậc {{tier}}"
  }
}
